// THIS FILE IS AUTO GENERATED

import React from 'react'

export const Ambire = React.forwardRef(function Ambire(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={48}
      height={48}
      viewBox='0 0 48 48'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <path
        d='M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24z'
        fill='#F2F5FF'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M30.831 19.83l4.462 9.497a.269.269 0 01-.055.296L23.5 40.963c-.088.077-.22.022-.22-.098v-10.42l7.396-7.139c.055-.044.077-.12.077-.186l.022-3.29c0-.022.044-.022.055 0z'
        fill='#6000FF'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M35.315 29.492a.287.287 0 00-.022-.165L30.83 19.83c-.011-.022-.055-.022-.055.01l-.022 3.29a.21.21 0 01-.044.132l4.605 6.23z'
        fill='url(#prefix__prefix__paint0_linear_11640_1543)'
      />
      <path
        opacity={0.2}
        fillRule='evenodd'
        clipRule='evenodd'
        d='M35.315 29.492c.01-.055 0-.11-.022-.165l-.231-.493-4.066-5.21 4.319 5.868z'
        fill='#fff'
      />
      <g opacity={0.5}>
        <mask
          id='prefix__a'
          maskUnits='userSpaceOnUse'
          x={23}
          y={19}
          width={13}
          height={22}
        >
          <path
            opacity={0.5}
            d='M30.831 19.83l4.462 9.497a.269.269 0 01-.055.296L23.5 40.963c-.088.077-.22.022-.22-.098v-10.42l7.396-7.139c.055-.044.077-.12.077-.186l.022-3.29c0-.022.044-.022.055 0z'
            fill='#fff'
          />
        </mask>
        <g mask='url(#prefix__a)'>
          <path
            fill='url(#prefix__prefix__pattern0)'
            d='M16.742 19.72h15.935v25.225H16.742z'
          />
        </g>
      </g>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M20.281 11.856L18.182 17.8a.274.274 0 00.011.209l1.956 3.85-5.385 3.048c-.066.033-.154.011-.187-.055l-1.165-2.423a.233.233 0 01.022-.253l6.792-10.353c.022-.022.066 0 .055.033z'
        fill='#6000FF'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M18.16 17.877c0-.022 0-.044.011-.066l2.1-5.955c.01-.033-.034-.044-.045-.022L13.71 21.76l3.121-2.665-3.428 3.147 4.758-4.365z'
        fill='url(#prefix__prefix__paint1_linear_11640_1543)'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M13.71 21.749l-.275.417-.033.065 3.428-3.147-3.12 2.665z'
        fill='url(#prefix__prefix__paint2_linear_11640_1543)'
      />
      <path
        opacity={0.2}
        fillRule='evenodd'
        clipRule='evenodd'
        d='M13.71 21.749l-.275.417-.033.065 3.428-3.147-3.12 2.665z'
        fill='#fff'
      />
      <g opacity={0.4}>
        <path
          opacity={0.4}
          fillRule='evenodd'
          clipRule='evenodd'
          d='M20.281 11.856L18.182 17.8a.274.274 0 00.011.209l1.956 3.85-5.385 3.048c-.066.033-.154.011-.187-.055l-1.165-2.423a.233.233 0 01.022-.253l6.792-10.353c.022-.022.066 0 .055.033z'
          fill='#6000FF'
        />
        <g opacity={0.4}>
          <mask
            id='prefix__b'
            maskUnits='userSpaceOnUse'
            x={13}
            y={11}
            width={8}
            height={14}
          >
            <path
              opacity={0.4}
              d='M20.281 11.856L18.182 17.8a.274.274 0 00.011.209l1.956 3.85-5.385 3.048c-.066.033-.154.011-.187-.055l-1.165-2.423a.233.233 0 01.022-.253l6.792-10.353c.022-.022.066 0 .055.033z'
              fill='#fff'
            />
          </mask>
          <g mask='url(#prefix__b)'>
            <path
              fill='url(#prefix__prefix__pattern1)'
              d='M8.061 17.197h19.561v14.696H8.061z'
            />
          </g>
        </g>
      </g>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M23.38 7.03l4.956 12.13a.304.304 0 010 .198l-8 18.721a.126.126 0 01-.209.044l-7.363-7.107a.254.254 0 01-.033-.34l10.495-14.224a.262.262 0 00.055-.154V7.053c0-.055.077-.077.1-.022z'
        fill='url(#prefix__prefix__paint3_linear_11640_1543)'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M24.226 16.923l-.78-.438 4.824 2.522-4.89-11.976c-.022-.055-.099-.033-.099.022v9.245c0 .022 0 .055-.011.077l.956.548z'
        fill='url(#prefix__prefix__paint4_linear_11640_1543)'
      />
      <path
        opacity={0.2}
        fillRule='evenodd'
        clipRule='evenodd'
        d='M28.347 19.26c0-.012 0-.012 0 0l-4.132-2.337 4.132 2.336z'
        fill='#fff'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M24.226 16.923l4.121 2.336c0-.033-.01-.055-.022-.088l-.066-.164-4.824-2.523.791.44z'
        fill='url(#prefix__prefix__paint5_linear_11640_1543)'
      />
      <path
        opacity={0.2}
        fillRule='evenodd'
        clipRule='evenodd'
        d='M24.226 16.923l4.121 2.336c0-.033-.01-.055-.022-.088l-.066-.164-4.824-2.523.791.44z'
        fill='#fff'
      />
      <defs>
        <linearGradient
          id='prefix__prefix__paint0_linear_11640_1543'
          x1={30.994}
          y1={18.969}
          x2={35.678}
          y2={22.833}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#AF50FF' stopOpacity={0} />
          <stop offset={1} stopColor='#AF50FF' />
        </linearGradient>
        <linearGradient
          id='prefix__prefix__paint1_linear_11640_1543'
          x1={20.131}
          y1={13.45}
          x2={11.658}
          y2={18.984}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#AF50FF' stopOpacity={0} />
          <stop offset={1} stopColor='#AF50FF' />
        </linearGradient>
        <linearGradient
          id='prefix__prefix__paint2_linear_11640_1543'
          x1={19.98}
          y1={13.35}
          x2={14.609}
          y2={22.925}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#AF50FF' stopOpacity={0} />
          <stop offset={1} stopColor='#AF50FF' />
        </linearGradient>
        <linearGradient
          id='prefix__prefix__paint3_linear_11640_1543'
          x1={1.331}
          y1={52.52}
          x2={29.391}
          y2={42.134}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#AF50FF' />
          <stop offset={1} stopColor='#6000FF' />
        </linearGradient>
        <linearGradient
          id='prefix__prefix__paint4_linear_11640_1543'
          x1={23.142}
          y1={11.487}
          x2={30.458}
          y2={12.997}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#AF50FF' stopOpacity={0} />
          <stop offset={1} stopColor='#AF50FF' />
        </linearGradient>
        <linearGradient
          id='prefix__prefix__paint5_linear_11640_1543'
          x1={21.652}
          y1={12.733}
          x2={23.885}
          y2={21.065}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#AF50FF' stopOpacity={0} />
          <stop offset={1} stopColor='#AF50FF' />
        </linearGradient>
        <pattern
          id='prefix__prefix__pattern0'
          patternContentUnits='objectBoundingBox'
          width={1}
          height={1}
        >
          <use
            xlinkHref='#prefix__prefix__image0_11640_1543'
            transform='scale(.0069 .00435)'
          />
        </pattern>
        <pattern
          id='prefix__prefix__pattern1'
          patternContentUnits='objectBoundingBox'
          width={1}
          height={1}
        >
          <use
            xlinkHref='#prefix__prefix__image1_11640_1543'
            transform='scale(.00562 .00746)'
          />
        </pattern>
        <image
          id='prefix__prefix__image0_11640_1543'
          width={145}
          height={230}
          xlinkHref='data:image/png;base64,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'
        />
        <image
          id='prefix__prefix__image1_11640_1543'
          width={178}
          height={134}
          xlinkHref='data:image/png;base64,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'
        />
      </defs>
    </svg>
  )
})

export const ArrowBack = React.forwardRef(function ArrowBack(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <path
        d='M20 12H4m6 6l-6-6 6-6'
        fill='none'
        stroke='currentColor'
        strokeWidth={2}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
})

export const ArrowBottom = React.forwardRef(function ArrowBottom(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M16.707 9.293a1 1 0 00-1.414 0L12 12.586 8.707 9.293a1 1 0 00-1.414 1.414l4 4a1 1 0 001.414 0l4-4a1 1 0 000-1.414z'
      />
    </svg>
  )
})

export const ArrowLeft = React.forwardRef(function ArrowLeft(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M14.707 16.707a1 1 0 000-1.414L11.414 12l3.293-3.293a1 1 0 00-1.414-1.414l-4 4a1 1 0 000 1.414l4 4a1 1 0 001.414 0z'
      />
    </svg>
  )
})

export const ArrowRight = React.forwardRef(function ArrowRight(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9.293 7.293a1 1 0 000 1.414L12.586 12l-3.293 3.293a1 1 0 101.414 1.414l4-4a1 1 0 000-1.414l-4-4a1 1 0 00-1.414 0z'
      />
    </svg>
  )
})

export const ArrowTop = React.forwardRef(function ArrowTop(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M7.293 14.707a1 1 0 001.414 0L12 11.414l3.293 3.293a1 1 0 001.414-1.414l-4-4a1 1 0 00-1.414 0l-4 4a1 1 0 000 1.414z'
      />
    </svg>
  )
})

export const Balancer = React.forwardRef(function Balancer(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={41}
      height={41}
      viewBox='0 0 41 41'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <rect y={0.004} width={40.002} height={40.002} rx={20.001} fill='#000' />
      <path
        d='M30.836 25.16c0-1.425-2.32-2.663-5.73-3.293v.001c-1.481.384-3.23.605-5.104.605s-3.623-.221-5.105-.606c-3.409.63-5.729 1.868-5.729 3.294 0 2.062 4.85 3.733 10.834 3.733 5.983 0 10.834-1.67 10.834-3.733zm-2.144-6.668c0-1.175-1.995-2.189-4.891-2.671-1.113.282-2.412.444-3.8.444-1.387 0-2.685-.161-3.798-.444-2.896.482-4.892 1.497-4.892 2.67 0 1.64 3.891 2.968 8.69 2.968 4.8 0 8.691-1.329 8.691-2.967zm-2.142-5.407c0-1.242-2.914-2.248-6.509-2.248-3.594 0-6.508 1.006-6.508 2.248 0 1.24 2.914 2.246 6.508 2.246 3.595 0 6.509-1.006 6.509-2.246z'
        fill='#fff'
      />
    </svg>
  )
})

export const Beth = React.forwardRef(function Beth(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <path
        d='M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11z'
        fill='#010101'
      />
      <path
        d='M7.898 11.29l-.112.17a4.824 4.824 0 00.678 6.1 5.036 5.036 0 003.534 1.434l-4.1-7.705z'
        fill='#4BDB4B'
      />
      <path
        opacity={0.6}
        d='M11.997 13.63l-4.1-2.34 4.1 7.704v-5.363zm4.105-2.34l.112.17a4.823 4.823 0 01-.678 6.1 5.036 5.036 0 01-3.534 1.434l4.1-7.705z'
        fill='#4BDB4B'
      />
      <path
        opacity={0.2}
        d='M12.002 13.63l4.1-2.34-4.1 7.704v-5.363zm.001-5.23v4.038l3.531-2.018-3.531-2.02z'
        fill='#4BDB4B'
      />
      <path
        opacity={0.6}
        d='M12.003 8.4l-3.534 2.02 3.534 2.018V8.4z'
        fill='#4BDB4B'
      />
      <path d='M12.003 5.002L8.469 10.42l3.534-2.027V5.002z' fill='#4BDB4B' />
      <path
        opacity={0.6}
        d='M12.003 8.394l3.534 2.027-3.534-5.422v3.395z'
        fill='#4BDB4B'
      />
    </svg>
  )
})

export const BlochainwalletInversion = React.forwardRef(
  function BlochainwalletInversion(
    props: React.SVGProps<SVGSVGElement>,
    svgRef?: React.Ref<SVGSVGElement>,
  ) {
    return (
      <svg
        width={48}
        height={48}
        viewBox='0 0 48 48'
        fill='currentColor'
        ref={svgRef}
        {...props}
      >
        <path
          d='M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24z'
          fill='#fff'
        />
        <path
          d='M11.44 20.02l-1.383 1.382a3.911 3.911 0 00-1.215 2.844 3.909 3.909 0 001.215 2.834l11.139 11.257c.266.267.572.494.908.662V25.362L11.44 20.019z'
          fill='#3D89F5'
        />
        <path
          d='M36.56 20.02l1.383 1.382a3.912 3.912 0 010 5.668L26.805 38.328a3.515 3.515 0 01-.909.661V25.362l10.665-5.343z'
          fill='#1656B9'
        />
        <path
          d='M33.885 17.195l-6.972-6.991a3.828 3.828 0 00-1.303-.89 3.909 3.909 0 00-3.081 0 4.189 4.189 0 00-1.304.89l-6.981 6.991 9.796 4.888 9.845-4.888z'
          fill='#85B5F8'
        />
      </svg>
    )
  },
)

export const Blochainwallet = React.forwardRef(function Blochainwallet(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={48}
      height={48}
      viewBox='0 0 48 48'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <path
        d='M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24z'
        fill='#141D31'
      />
      <path
        d='M11.44 20.02l-1.383 1.382a3.911 3.911 0 00-1.215 2.844 3.909 3.909 0 001.215 2.834l11.139 11.257c.266.267.572.494.908.662V25.362L11.44 20.019z'
        fill='#3D89F5'
      />
      <path
        d='M36.56 20.02l1.383 1.382a3.912 3.912 0 010 5.668L26.805 38.328a3.515 3.515 0 01-.909.661V25.362l10.665-5.343z'
        fill='#1656B9'
      />
      <path
        d='M33.885 17.195l-6.972-6.991a3.828 3.828 0 00-1.303-.89 3.909 3.909 0 00-3.081 0 4.189 4.189 0 00-1.304.89l-6.981 6.991 9.796 4.888 9.845-4.888z'
        fill='#85B5F8'
      />
    </svg>
  )
})

export const Brave = React.forwardRef(function Brave(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={48}
      height={48}
      viewBox='0 0 48 48'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <circle cx={24} cy={24} r={24} fill='#2C2C34' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M36.456 15.676l.736-1.842s-.937-1.023-2.076-2.183c-1.138-1.16-3.549-.477-3.549-.477L28.822 8h-9.644l-2.745 3.174s-2.41-.683-3.55.477c-1.138 1.16-2.075 2.183-2.075 2.183l.736 1.842-.937 2.73s2.757 10.64 3.08 11.939c.636 2.558 1.072 3.548 2.88 4.844 1.808 1.296 5.09 3.548 5.625 3.889.536.34 1.205.922 1.808.922s1.272-.581 1.808-.922c.536-.341 3.817-2.593 5.625-3.89 1.808-1.295 2.244-2.285 2.88-4.843.323-1.3 3.08-11.94 3.08-11.94l-.937-2.729z'
        fill='url(#prefix__prefix__paint0_linear_11995_1639)'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M24 27.914c.184 0 1.36.423 2.303.92.944.498 1.628.85 1.847.99.218.139.085.402-.114.545-.2.144-2.875 2.255-3.135 2.488-.26.233-.642.619-.901.619-.26 0-.641-.386-.9-.619-.26-.233-2.937-2.344-3.136-2.488-.199-.143-.332-.406-.113-.546.218-.139.902-.49 1.846-.988.943-.498 2.12-.92 2.303-.92zm.014-15.037c.09.003.598.028 1.325.275.804.273 1.675.614 2.076.614.402 0 3.382-.58 3.382-.58s3.532 4.35 3.532 5.28c0 .929-.445 1.174-.891 1.657l-2.648 2.865c-.25.271-.772.682-.466 1.422.307.74.76 1.68.256 2.635-.503.955-1.365 1.592-1.917 1.486-.553-.105-1.85-.796-2.328-1.111-.477-.316-1.989-1.587-1.989-2.073s1.563-1.359 1.852-1.557c.289-.198 1.606-.966 1.633-1.267.027-.302.017-.39-.372-1.134-.389-.745-1.089-1.738-.972-2.4.116-.66 1.245-1.004 2.051-1.314.806-.31 2.357-.896 2.55-.986.195-.092.145-.178-.443-.235-.587-.057-2.252-.282-3.003-.069-.751.214-2.034.538-2.138.71-.104.172-.196.178-.09.772.107.593.657 3.441.71 3.947.054.506.158.84-.377.965-.536.125-1.437.341-1.747.341-.31 0-1.211-.216-1.746-.34-.536-.126-.431-.46-.378-.966.053-.506.603-3.354.71-3.947.106-.594.014-.6-.09-.772-.103-.172-1.386-.496-2.137-.71-.752-.213-2.417.012-3.004.069-.587.057-.637.143-.444.235.194.09 1.745.676 2.551.986.806.31 1.935.654 2.051 1.315.117.66-.583 1.654-.972 2.399-.389.744-.399.832-.372 1.134.027.301 1.344 1.069 1.633 1.267.289.198 1.852 1.071 1.852 1.557s-1.512 1.757-1.99 2.073c-.477.315-1.774 1.006-2.326 1.111-.553.106-1.415-.531-1.918-1.486-.504-.955-.051-1.896.256-2.635.306-.74-.215-1.151-.466-1.422l-2.648-2.865c-.446-.483-.89-.728-.89-1.658 0-.93 3.531-5.279 3.531-5.279s2.98.58 3.382.58c.402 0 1.272-.341 2.076-.614.727-.247 1.235-.272 1.325-.275h.028z'
        fill='#fff'
      />
      <mask
        id='prefix__a'
        maskUnits='userSpaceOnUse'
        x={12}
        y={8}
        width={24}
        height={6}
      >
        <path
          d='M31.567 11.174L28.822 8h-9.644l-2.745 3.174s-2.41-.683-3.55.477c0 0 3.215-.296 4.32 1.535 0 0 2.98.58 3.382.58.402 0 1.272-.341 2.076-.614.803-.273 1.34-.275 1.34-.275s.535.002 1.338.275c.804.273 1.675.614 2.076.614.402 0 3.382-.58 3.382-.58 1.105-1.83 4.32-1.535 4.32-1.535-1.14-1.16-3.55-.477-3.55-.477z'
          fill='#fff'
        />
      </mask>
      <g mask='url(#prefix__a)'>
        <path
          d='M31.567 11.174L28.822 8h-9.644l-2.745 3.174s-2.41-.683-3.55.477c0 0 3.215-.296 4.32 1.535 0 0 2.98.58 3.382.58.402 0 1.272-.341 2.076-.614.803-.273 1.34-.275 1.34-.275s.535.002 1.338.275c.804.273 1.675.614 2.076.614.402 0 3.382-.58 3.382-.58 1.105-1.83 4.32-1.535 4.32-1.535-1.14-1.16-3.55-.477-3.55-.477z'
          fill='url(#prefix__prefix__paint1_linear_11995_1639)'
        />
      </g>
      <defs>
        <linearGradient
          id='prefix__prefix__paint0_linear_11995_1639'
          x1={10.607}
          y1={24.226}
          x2={37.393}
          y2={24.226}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#F50' />
          <stop offset={0.41} stopColor='#F50' />
          <stop offset={0.582} stopColor='#FF2000' />
          <stop offset={1} stopColor='#FF2000' />
        </linearGradient>
        <linearGradient
          id='prefix__prefix__paint1_linear_11995_1639'
          x1={13.361}
          y1={10.924}
          x2={35.116}
          y2={10.924}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FF452A' />
          <stop offset={1} stopColor='#FF2000' />
        </linearGradient>
      </defs>
    </svg>
  )
})

export const ChartColumnIncreasing = React.forwardRef(
  function ChartColumnIncreasing(
    props: React.SVGProps<SVGSVGElement>,
    svgRef?: React.Ref<SVGSVGElement>,
  ) {
    return (
      <svg
        width={20}
        height={20}
        viewBox='0 0 20 20'
        fill='currentColor'
        ref={svgRef}
        {...props}
      >
        <path d='M1.5 15.833V2.5a1 1 0 012 0v13.333a.667.667 0 00.667.667H17.5a1 1 0 110 2H4.167A2.668 2.668 0 011.5 15.833zm4.167-1.666v-2.5a1 1 0 112 0v2.5a1 1 0 01-2 0zm4.166 0V7.5a1 1 0 012 0v6.667a1 1 0 01-2 0zm4.167 0v-10a1 1 0 112 0v10a1 1 0 01-2 0z' />
      </svg>
    )
  },
)

export const ChartPie = React.forwardRef(function ChartPie(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={20}
      height={20}
      viewBox='0 0 20 20'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <g clipPath='url(#prefix__prefix__clip0_930_6963)'>
        <path d='M6.268 1.442a1 1 0 01.8 1.833 7.335 7.335 0 00.82 13.744 7.333 7.333 0 008.867-4.167 1 1 0 011.842.78 9.334 9.334 0 11-12.33-12.19zM10.93.715a9.333 9.333 0 018.356 8.354c.112 1.113-.804 1.932-1.786 1.932h-6.668A1.834 1.834 0 019 9.169V2.502C9 1.52 9.816.604 10.93.715zM11 9h6.263A7.333 7.333 0 0011 2.737v6.264z' />
      </g>
      <defs>
        <clipPath id='prefix__prefix__clip0_930_6963'>
          <path fill='#fff' d='M0 0h20v20H0z' />
        </clipPath>
      </defs>
    </svg>
  )
})

export const CheckLarge = React.forwardRef(function CheckLarge(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M20.707 6.293a1 1 0 010 1.414l-11 11a1 1 0 01-1.414 0l-5-5a1 1 0 111.414-1.414L9 16.586 19.293 6.293a1 1 0 011.414 0z'
      />
    </svg>
  )
})

export const Check = React.forwardRef(function Check(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M17.434 8.293a1 1 0 010 1.414l-6 6a1 1 0 01-1.414 0L7.293 12.98a1 1 0 111.414-1.414l2.02 2.02 5.293-5.293a1 1 0 011.414 0z'
      />
    </svg>
  )
})

export const Close = React.forwardRef(function Close(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <path d='M17.707 7.707a1 1 0 00-1.414-1.414L12 10.586 7.707 6.293a1 1 0 00-1.414 1.414L10.586 12l-4.293 4.293a1 1 0 101.414 1.414L12 13.414l4.293 4.293a1 1 0 001.414-1.414L13.414 12l4.293-4.293z' />
    </svg>
  )
})

export const Coin98Circle = React.forwardRef(function Coin98Circle(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={48}
      height={48}
      viewBox='0 0 48 48'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <circle
        cx={24}
        cy={24}
        r={24}
        fill='url(#prefix__prefix__paint0_linear_10169:6081)'
      />
      <path
        d='M16.16 11.984a7.496 7.496 0 107.503 7.503 7.507 7.507 0 00-7.503-7.503zm0 11.922a4.423 4.423 0 114.424-4.422 4.438 4.438 0 01-4.424 4.422zm22.1-5.508a6.31 6.31 0 01-.788 3.067 8.612 8.612 0 00-2.692-1.483 3.338 3.338 0 10-5.875 0 8.613 8.613 0 00-2.691 1.483 6.406 6.406 0 015.631-9.48 6.421 6.421 0 016.415 6.413zm-6.415 2.595a7.496 7.496 0 107.49 7.504 7.512 7.512 0 00-7.49-7.504zm0 11.914a4.417 4.417 0 11.01-8.835 4.417 4.417 0 01-.01 8.835zm-9.27-3.336a6.416 6.416 0 11-12.833 0h3.079a3.337 3.337 0 106.675 0h3.079z'
        fill='#252525'
      />
      <defs>
        <linearGradient
          id='prefix__prefix__paint0_linear_10169:6081'
          x1={45.553}
          y1={2.447}
          x2={3.111}
          y2={44.889}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#F1D961' />
          <stop offset={1} stopColor='#CDA146' />
        </linearGradient>
      </defs>
    </svg>
  )
})

export const Coinbase = React.forwardRef(function Coinbase(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={40}
      height={40}
      viewBox='0 0 40 40'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <circle cx={20} cy={20} r={15} fill='#fff' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20zm0-8c6.627 0 12-5.373 12-12S26.627 8 20 8 8 13.373 8 20s5.373 12 12 12z'
        fill='url(#prefix__prefix__a)'
      />
      <rect x={16} y={16} width={8} height={8} rx={1} fill='#2952EA' />
      <defs>
        <linearGradient
          id='prefix__prefix__a'
          x1={20}
          y1={0}
          x2={20}
          y2={40}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#345FF8' />
          <stop offset={1} stopColor='#1D44DC' />
        </linearGradient>
      </defs>
    </svg>
  )
})

export const CookieInverse = React.forwardRef(function CookieInverse(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={32}
      height={32}
      viewBox='0 0 32 32'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <rect opacity={0.4} width={32} height={32} rx={8} fill='#1C1C21' />
      <path
        d='M25.601 15.23c-1.286-.462-2.078-1.771-1.978-2.805 0-.17-.102-.328-.23-.44a.639.639 0 00-.496-.132c-1.96.288-3.756-1.146-3.934-3.162a.585.585 0 00-.785-.499c-1.59.582-3.09-.47-3.69-1.841a.586.586 0 00-.664-.337C9.314 7.02 6 11.377 6 16c0 5.493 4.507 10 10 10s10-4.507 10-10c-.016-.349-.019-.634-.399-.77zm-15.49 1.4a.586.586 0 110-1.172.586.586 0 010 1.172zm2.373 4.643a1.76 1.76 0 01-1.757-1.757c0-.97.788-1.758 1.757-1.758.97 0 1.758.788 1.758 1.758a1.76 1.76 0 01-1.758 1.758zm.586-7.03a1.173 1.173 0 01-1.172-1.173 1.173 1.173 0 012.344 0c0 .646-.526 1.172-1.172 1.172zm4.688 8.202a1.173 1.173 0 01-1.172-1.172c0-.645.526-1.171 1.172-1.171.646 0 1.172.526 1.172 1.171 0 .646-.526 1.172-1.172 1.172zm.586-4.687A1.76 1.76 0 0116.586 16c0-.97.789-1.758 1.758-1.758s1.758.789 1.758 1.758a1.76 1.76 0 01-1.758 1.758zm3.486 1.216a.586.586 0 110-1.172.586.586 0 010 1.172z'
        fill='#fff'
      />
    </svg>
  )
})

export const Cookie = React.forwardRef(function Cookie(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={32}
      height={32}
      viewBox='0 0 32 32'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <rect width={32} height={32} rx={8} fill='#F4F6F8' />
      <path
        d='M25.601 15.23c-1.286-.462-2.078-1.771-1.978-2.805 0-.17-.102-.328-.23-.44a.64.64 0 00-.496-.132c-1.96.288-3.756-1.146-3.934-3.162a.585.585 0 00-.785-.499c-1.59.582-3.09-.47-3.69-1.841a.586.586 0 00-.664-.337C9.314 7.02 6 11.377 6 16c0 5.493 4.507 10 10 10 5.492 0 10-4.507 10-10-.016-.349-.019-.634-.399-.77zm-15.49 1.4a.586.586 0 110-1.172.586.586 0 010 1.172zm2.373 4.643a1.76 1.76 0 01-1.757-1.757c0-.97.788-1.758 1.757-1.758.97 0 1.758.788 1.758 1.758a1.76 1.76 0 01-1.758 1.758zm.586-7.03a1.173 1.173 0 01-1.172-1.173 1.173 1.173 0 012.344 0c0 .646-.526 1.172-1.172 1.172zm4.688 8.202a1.173 1.173 0 01-1.172-1.172 1.173 1.173 0 012.344 0c0 .646-.526 1.172-1.172 1.172zm.586-4.687A1.76 1.76 0 0116.586 16a1.76 1.76 0 013.516 0 1.76 1.76 0 01-1.758 1.758zm3.486 1.216a.586.586 0 110-1.172.586.586 0 010 1.172z'
        fill='#7A8AA0'
      />
    </svg>
  )
})

export const Copy = React.forwardRef(function Copy(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M18.6 9.858V14.1a2.1 2.1 0 01-2.1 2.1h-.7v.7a2.1 2.1 0 01-2.1 2.1H8.1A2.1 2.1 0 016 16.9v-7c0-1.16.94-2.1 2.1-2.1h.7v-.7c0-1.16.94-2.1 2.1-2.1h2.835a.77.77 0 01.49.21l4.2 4.2a.62.62 0 01.175.448zM13.7 17.6a.7.7 0 00.7-.7v-.7h-3.5a2.1 2.1 0 01-2.1-2.1V9.2h-.7a.7.7 0 00-.7.7v7a.7.7 0 00.7.7h5.6zm.7-10.213L16.213 9.2H15.1a.7.7 0 01-.7-.7V7.387zm2.1 7.413a.7.7 0 00.7-.7v-3.5h-2.1A2.1 2.1 0 0113 8.5V6.4h-2.1a.7.7 0 00-.7.7v7a.7.7 0 00.7.7h5.6z'
      />
    </svg>
  )
})

export const Curve = React.forwardRef(function Curve(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={32}
      height={32}
      viewBox='0 0 32 32'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <path
        d='M13.504 19.415l-2.424.533-.3-1.133 2.573-.471.15 1.07zm-2.424.533l-2.106.715-.455-1.183 2.26-.666.3 1.134z'
        fill='#00F'
      />
      <path
        d='M13.353 18.344l-2.575.47-.27-1.322 2.71-.4.135 1.252z'
        fill='#0028FF'
      />
      <path
        d='M10.778 18.813l-2.26.665-.41-1.38 2.4-.608.27 1.323z'
        fill='#0018FF'
      />
      <path
        d='M13.665 20.278l-2.263.587-.323-.917 2.424-.534.162.864z'
        fill='#0000F1'
      />
      <path
        d='M11.403 20.864l-1.94.756-.49-.958 2.107-.715.323.917z'
        fill='#0000DA'
      />
      <path
        d='M13.219 17.092l-2.71.4-.235-1.48 2.83-.322.115 1.402z'
        fill='#0058FF'
      />
      <path
        d='M10.508 17.49l-2.4.607-.356-1.546 2.522-.541.234 1.48z'
        fill='#0048FF'
      />
      <path
        d='M16.153 19.062l-2.65.352-.15-1.07 2.79-.28.01.998z'
        fill='#0014FF'
      />
      <path
        d='M13.836 20.913l-2.094.629-.339-.678 2.263-.587.17.636z'
        fill='#0000DA'
      />
      <path
        d='M8.974 20.663l-1.727.885-.606-1.218 1.878-.85.455 1.183z'
        fill='#0000E8'
      />
      <path
        d='M11.74 21.542l-1.767.786-.511-.708 1.94-.756.339.678z'
        fill='#0000C4'
      />
      <path
        d='M16.142 18.065l-2.789.279-.134-1.252 2.916-.197.007 1.17z'
        fill='#003CFF'
      />
      <path
        d='M8.518 19.479l-1.878.85-.547-1.424 2.015-.807.41 1.38z'
        fill='#0008FF'
      />
      <path
        d='M16.165 19.864l-2.499.414-.162-.864 2.649-.352.012.802z'
        fill='#00F'
      />
      <path
        d='M9.462 21.62l-1.564.911-.65-.983 1.726-.886.488.958z'
        fill='#0000C8'
      />
      <path
        d='M13.103 15.688l-2.829.322-.192-1.603 2.927-.239.094 1.52z'
        fill='#0090FF'
      />
      <path
        d='M10.275 16.011l-2.522.542-.293-1.674 2.623-.47.192 1.602z'
        fill='#0084FF'
      />
      <path
        d='M16.134 16.895l-2.916.197-.116-1.403 3.028-.109.004 1.315z'
        fill='#0068FF'
      />
      <path
        d='M8.108 18.099l-2.016.807-.475-1.596 2.135-.757.356 1.546z'
        fill='#003CFF'
      />
      <path
        d='M16.178 20.448l-2.343.466-.17-.636 2.499-.415.014.585z'
        fill='#0000F6'
      />
      <path
        d='M14.01 21.306l-1.924.658-.345-.422 2.095-.628.175.392z'
        fill='#0000D1'
      />
      <path
        d='M9.973 22.328l-1.394.928-.68-.724 1.564-.912.51.708z'
        fill='#0000AD'
      />
      <path
        d='M12.087 21.964l-1.593.805-.52-.44 1.768-.786.345.421z'
        fill='#00B'
      />
      <path
        d='M16.13 15.58l-3.026.108-.094-1.52 3.119-.016.002 1.428z'
        fill='#009CFF'
      />
      <path
        d='M7.752 16.553l-2.134.757-.391-1.73 2.233-.701.292 1.674z'
        fill='#0078FF'
      />
      <path
        d='M16.195 20.803l-2.184.503-.175-.392 2.343-.465.016.354z'
        fill='#0000ED'
      />
      <path
        d='M13.01 14.168l-2.928.24-.145-1.688 3.003-.153.07 1.601z'
        fill='#0CF'
      />
      <path
        d='M18.907 18.884l-2.755.179-.01-.998 2.88-.098-.115.917z'
        fill='#002CFF'
      />
      <path
        d='M10.082 14.408l-2.623.471-.222-1.762 2.7-.396.145 1.687z'
        fill='#00C4FF'
      />
      <path
        d='M18.786 19.616l-2.621.249-.013-.802 2.756-.178-.122.731z'
        fill='#0014FF'
      />
      <path
        d='M19.023 17.966l-2.88.098-.007-1.17 2.993-.01-.106 1.082z'
        fill='#0050FF'
      />
      <path
        d='M7.247 21.547l-1.318 1.035-.748-1.237L6.64 20.33l.607 1.218z'
        fill='#0000DA'
      />
      <path
        d='M6.64 20.33l-1.459 1.016-.675-1.45 1.587-.99.548 1.424z'
        fill='#00F'
      />
      <path
        d='M10.495 22.769l-1.223.935-.693-.448 1.395-.928.52.44z'
        fill='#0000A4'
      />
      <path
        d='M7.898 22.532l-1.167 1.045-.802-.994 1.318-1.034.651.983z'
        fill='#0000B6'
      />
      <path
        d='M14.185 21.443l-1.755.674-.344-.153 1.924-.657.175.136z'
        fill='#0000D6'
      />
      <path
        d='M18.66 20.143l-2.482.306-.014-.586 2.622-.248-.125.528z'
        fill='#0004FF'
      />
      <path
        d='M19.128 16.886l-2.993.009-.005-1.315 3.092.087-.094 1.219z'
        fill='#0078FF'
      />
      <path
        d='M12.43 22.118l-1.419.812-.518-.16 1.593-.805.343.153z'
        fill='#0000BF'
      />
      <path
        d='M16.128 14.152l-3.119.017-.07-1.602 3.19.08-.001 1.505z'
        fill='#00D8FF'
      />
      <path
        d='M6.093 18.906l-1.587.99-.586-1.63 1.698-.956.475 1.596z'
        fill='#0034FF'
      />
      <path
        d='M16.212 20.916l-2.027.527-.174-.137 2.184-.503.017.113z'
        fill='#0000F1'
      />
      <path
        d='M8.578 23.256L7.57 24.302l-.839-.726 1.167-1.045.68.725z'
        fill='#00009F'
      />
      <path
        d='M7.46 14.878l-2.234.7-.297-1.823 2.308-.64.222 1.763z'
        fill='#00BCFF'
      />
      <path
        d='M18.536 20.454l-2.341.35-.016-.355 2.482-.305-.125.31z'
        fill='#00F'
      />
      <path
        d='M12.94 12.567l-3.002.152-.094-1.73 3.053-.065.043 1.643z'
        fill='#23FFD4'
      />
      <path
        d='M19.222 15.666l-3.092-.087-.002-1.427 3.174.187-.08 1.327z'
        fill='#00ACFF'
      />
      <path
        d='M9.937 12.72l-2.7.395-.145-1.808 2.751-.319.094 1.731z'
        fill='#1CFFDB'
      />
      <path
        d='M11.012 22.93l-1.051.931-.69-.157 1.223-.935.518.16z'
        fill='#0000AD'
      />
      <path
        d='M5.618 17.308l-1.698.957-.483-1.77 1.79-.917.39 1.73z'
        fill='#0070FF'
      />
      <path
        d='M14.355 21.32l-1.592.676-.333.121 1.755-.674.17-.124z'
        fill='#0000E8'
      />
      <path
        d='M9.271 23.703l-.848 1.04-.854-.441 1.009-1.046.693.447z'
        fill='#000096'
      />
      <path
        d='M16.13 12.647l-3.19-.08-.043-1.643 3.236.176-.004 1.547z'
        fill='#26FFD1'
      />
      <path
        d='M18.414 20.537l-2.202.379-.017-.113 2.342-.35-.123.084z'
        fill='#00F'
      />
      <path
        d='M21.63 18.863l-2.723.021.115-.917 2.83.063-.222.833z'
        fill='#04F'
      />
      <path
        d='M21.396 19.52l-2.61.095.121-.731 2.724-.022-.235.658z'
        fill='#002CFF'
      />
      <path
        d='M12.764 21.996l-1.25.808-.502.125 1.418-.812.334-.12z'
        fill='#0000D1'
      />
      <path
        d='M19.302 14.339l-3.174-.187v-1.505l3.238.289-.064 1.403z'
        fill='#00E0FB'
      />
      <path
        d='M16.23 20.783l-1.875.536-.17.123 2.027-.526.018-.133z'
        fill='#00F'
      />
      <path
        d='M21.852 18.03l-2.83-.064.106-1.081 2.925.157-.201.987z'
        fill='#0064FF'
      />
      <path
        d='M7.237 13.116l-2.308.64-.196-1.873 2.36-.575.144 1.808z'
        fill='#19FFDE'
      />
      <path
        d='M21.153 19.986l-2.492.157.125-.528 2.61-.095-.243.466z'
        fill='#001CFF'
      />
      <path
        d='M5.93 22.582l-.913 1.15-.871-1.236 1.036-1.15.747 1.236z'
        fill='#0000D1'
      />
      <path
        d='M6.732 23.576l-.78 1.143-.935-.986.912-1.151.803.994z'
        fill='#0000A8'
      />
      <path
        d='M12.896 10.924l-3.053.064-.04-1.732 3.077.023.016 1.645z'
        fill='#5AFF9D'
      />
      <path
        d='M22.053 17.042l-2.925-.157.094-1.219 3.009.257-.178 1.119z'
        fill='#008CFF'
      />
      <path
        d='M5.18 21.345l-1.035 1.15-.788-1.458 1.148-1.142.676 1.45z'
        fill='#00F'
      />
      <path
        d='M5.226 15.58l-1.79.916-.368-1.87 1.86-.87.298 1.823z'
        fill='#00B8FF'
      />
      <path
        d='M9.844 10.988l-2.751.32-.065-1.811 2.776-.241.04 1.732z'
        fill='#5AFF9D'
      />
      <path
        d='M20.909 20.25l-2.373.203.125-.31 2.492-.157-.244.263z'
        fill='#0018FF'
      />
      <path
        d='M11.514 22.804l-.884.919-.67.138 1.052-.932.502-.125z'
        fill='#0000BF'
      />
      <path
        d='M9.96 23.862l-.687 1.025-.85-.143.849-1.04.689.158z'
        fill='#00009B'
      />
      <path
        d='M7.57 24.303l-.641 1.13-.977-.713.78-1.144.838.727z'
        fill='#000092'
      />
      <path
        d='M18.297 20.393l-2.067.39-.018.133 2.202-.378-.117-.145z'
        fill='#000CFF'
      />
      <path
        d='M4.506 19.895l-1.148 1.142-.683-1.644 1.245-1.127.586 1.629z'
        fill='#002CFF'
      />
      <path
        d='M16.132 11.1l-3.236-.176-.016-1.645 3.259.27-.007 1.551z'
        fill='#5DFF9A'
      />
      <path
        d='M19.366 12.936l-3.237-.29.004-1.546 3.279.391-.046 1.445z'
        fill='#2CFFCA'
      />
      <path
        d='M22.23 15.924l-3.008-.257.08-1.327 3.078.361-.15 1.223z'
        fill='#00B8FF'
      />
      <path
        d='M14.516 20.936l-1.437.666-.315.395 1.59-.677.162-.384z'
        fill='#00F'
      />
      <path
        d='M16.249 20.408l-1.732.529-.162.383 1.875-.536.019-.376z'
        fill='#000CFF'
      />
      <path
        d='M20.669 20.301l-2.255.237.123-.085 2.372-.204-.24.052z'
        fill='#0018FF'
      />
      <path
        d='M13.08 21.604l-1.09.79-.475.411 1.249-.807.315-.395z'
        fill='#0000F1'
      />
      <path
        d='M7.092 11.307l-2.359.576-.087-1.877 2.382-.509.064 1.81z'
        fill='#56FFA0'
      />
      <path
        d='M8.425 24.744l-.502 1.11-.994-.421.641-1.13.855.44z'
        fill='#000089'
      />
      <path
        d='M3.92 18.266l-1.245 1.127-.564-1.792 1.326-1.105.483 1.77z'
        fill='#006CFF'
      />
      <path
        d='M4.929 13.756l-1.86.87-.242-1.923 1.906-.82.196 1.873z'
        fill='#16FFE1'
      />
      <path
        d='M22.38 14.701l-3.078-.362.064-1.402 3.131.468-.117 1.296z'
        fill='#06ECF1'
      />
      <path
        d='M12.88 9.279l-3.077-.023.015-1.69 3.074.107-.012 1.606z'
        fill='#94FF63'
      />
      <path
        d='M18.189 20.02l-1.941.387-.018.376 2.067-.391-.108-.372z'
        fill='#0024FF'
      />
      <path
        d='M10.63 23.723l-.533 1.002-.824.16.688-1.024.669-.138z'
        fill='#0000AD'
      />
      <path
        d='M23.848 19.558l-2.451-.038.234-.658 2.542.114-.325.582z'
        fill='#04F'
      />
      <path
        d='M24.173 18.976l-2.542-.114.22-.833 2.627.2-.305.747z'
        fill='#005CFF'
      />
      <path
        d='M19.412 11.492l-3.28-.392.007-1.55 3.3.491-.027 1.45z'
        fill='#5DFF9A'
      />
      <path
        d='M9.803 9.256l-2.776.24.02-1.766 2.771-.165-.015 1.691z'
        fill='#94FF63'
      />
      <path
        d='M20.438 20.14l-2.141.252.117.145 2.254-.236-.23-.16z'
        fill='#0028FF'
      />
      <path
        d='M11.99 22.393l-.729.896-.631.433.884-.919.475-.41z'
        fill='#0000DF'
      />
      <path
        d='M23.51 19.961l-2.357.025.243-.466 2.451.038-.337.403z'
        fill='#0038FF'
      />
      <path
        d='M24.478 18.23l-2.626-.2.201-.988 2.704.295-.279.893z'
        fill='#0078FF'
      />
      <path
        d='M16.14 9.55l-3.26-.271.013-1.606 3.256.361-.01 1.515z'
        fill='#90FF66'
      />
      <path
        d='M9.273 24.887l-.361 1.083-.99-.116.502-1.11.85.143z'
        fill='#00008D'
      />
      <path
        d='M14.665 20.3l-1.297.642-.289.66 1.437-.666.149-.635z'
        fill='#001CFF'
      />
      <path
        d='M23.17 20.176l-2.262.073.245-.263 2.357-.024-.34.214z'
        fill='#0034FF'
      />
      <path
        d='M16.267 19.795l-1.602.506-.148.635 1.732-.529.018-.612z'
        fill='#0030FF'
      />
      <path
        d='M24.757 17.338l-2.703-.296.178-1.118 2.77.397-.245 1.017z'
        fill='#00A0FF'
      />
      <path
        d='M22.498 13.404l-3.132-.468.046-1.445 3.167.574-.081 1.339z'
        fill='#33FFC4'
      />
      <path
        d='M3.436 16.496l-1.325 1.105-.428-1.898 1.386-1.076.367 1.87z'
        fill='#00B0FF'
      />
      <path
        d='M5.016 23.733l-.539 1.225-.97-1.22.638-1.242.871 1.237z'
        fill='#0000C8'
      />
      <path
        d='M5.951 24.72l-.432 1.2-1.041-.963.538-1.225.935.987z'
        fill='#0000A4'
      />
      <path
        d='M13.368 20.942l-.944.763-.435.689 1.09-.791.29-.66z'
        fill='#0008FF'
      />
      <path
        d='M4.145 22.496l-.637 1.242-.877-1.447.727-1.253.787 1.458z'
        fill='#00F'
      />
      <path
        d='M7.028 9.498l-2.382.508.023-1.834 2.377-.442-.018 1.768z'
        fill='#94FF63'
      />
      <path
        d='M22.837 20.197l-2.168.105.24-.053 2.262-.072-.334.02z'
        fill='#0034FF'
      />
      <path
        d='M20.224 19.771l-2.035.25.108.372 2.141-.251-.214-.37z'
        fill='#003CFF'
      />
      <path
        d='M4.733 11.883l-1.906.82-.11-1.93 1.928-.767.088 1.877z'
        fill='#56FFA0'
      />
      <path
        d='M6.929 25.431l-.322 1.172-1.087-.683.432-1.201.977.712z'
        fill='#000089'
      />
      <path
        d='M18.092 19.428l-1.826.367-.018.612 1.94-.387-.096-.592z'
        fill='#04F'
      />
      <path
        d='M25.002 16.32l-2.77-.396.149-1.223 2.825.503-.204 1.117z'
        fill='#00C8FF'
      />
      <path
        d='M19.439 10.042l-3.3-.492.01-1.515 3.297.587-.007 1.42z'
        fill='#90FF66'
      />
      <path
        d='M12.892 7.673l-3.074-.107.07-1.606 3.044.187-.04 1.526z'
        fill='#CAFF2C'
      />
      <path
        d='M11.26 23.29l-.386.972-.777.463.533-1.003.63-.433z'
        fill='#0000CD'
      />
      <path
        d='M3.358 21.037l-.727 1.253-.762-1.64.805-1.257.684 1.644z'
        fill='#0028FF'
      />
      <path
        d='M9.819 7.565l-2.772.164.102-1.68 2.74-.09-.07 1.606z'
        fill='#CEFF29'
      />
      <path
        d='M16.149 8.035l-3.256-.362.04-1.526 3.228.447-.012 1.44z'
        fill='#C7FF30'
      />
      <path
        d='M10.097 24.727l-.226 1.051-.959.192.362-1.083.823-.16z'
        fill='#00009F'
      />
      <path
        d='M22.578 12.066l-3.167-.575.027-1.45 3.184.677-.044 1.348z'
        fill='#60FF97'
      />
      <path
        d='M22.516 20.02l-2.077.12.23.161 2.168-.105-.321-.177z'
        fill='#0040FF'
      />
      <path
        d='M12.423 21.705l-.584.864-.578.721.728-.896.434-.689z'
        fill='#00F'
      />
      <path
        d='M7.922 25.852l-.21 1.137-1.107-.386.322-1.171.995.42z'
        fill='navy'
      />
      <path
        d='M3.068 14.627l-1.386 1.076-.282-1.958 1.427-1.042.241 1.924z'
        fill='#16FFE1'
      />
      <path
        d='M25.206 15.204l-2.825-.503.117-1.297 2.868.61-.16 1.19z'
        fill='#0FF8E7'
      />
      <path
        d='M16.284 18.959l-1.488.468-.132.874 1.602-.506.018-.836z'
        fill='#0058FF'
      />
      <path
        d='M14.796 19.428l-1.173.602-.255.912 1.297-.64.131-.874z'
        fill='#0048FF'
      />
      <path
        d='M20.03 19.2l-1.937.229.096.592 2.035-.25-.194-.572z'
        fill='#0058FF'
      />
      <path
        d='M2.675 19.394l-.805 1.257-.628-1.796.87-1.253.563 1.792z'
        fill='#0068FF'
      />
      <path
        d='M25.992 19.71l-2.145-.151.325-.582 2.212.224-.392.508z'
        fill='#0060FF'
      />
      <path
        d='M25.586 20.051l-2.075-.089.336-.403 2.146.15-.407.342z'
        fill='#0054FF'
      />
      <path
        d='M26.384 19.202l-2.212-.225.306-.747 2.275.31-.369.662z'
        fill='#0074FF'
      />
      <path
        d='M18.01 18.63l-1.726.33-.017.835 1.825-.367-.082-.798z'
        fill='#006CFF'
      />
      <path
        d='M13.623 20.03l-.816.722-.383.953.944-.763.255-.913z'
        fill='#0038FF'
      />
      <path
        d='M22.216 19.65l-1.992.12.214.37 2.077-.12-.299-.37z'
        fill='#0054FF'
      />
      <path
        d='M19.445 8.622l-3.297-.587.012-1.441 3.272.675.013 1.353z'
        fill='#C1FF36'
      />
      <path
        d='M8.912 25.97l-.099 1.1-1.1-.08.21-1.136.989.116z'
        fill='#000084'
      />
      <path
        d='M4.645 10.005l-1.927.767.027-1.89 1.923-.711-.023 1.834z'
        fill='#97FF60'
      />
      <path
        d='M25.176 20.217l-2.005-.042.34-.214 2.075.089-.41.167z'
        fill='#004CFF'
      />
      <path
        d='M7.046 7.73l-2.378.441.135-1.745 2.345-.375-.102 1.679z'
        fill='#D1FF26'
      />
      <path
        d='M26.754 18.54l-2.276-.31.28-.893 2.331.403-.335.8z'
        fill='#0090FF'
      />
      <path
        d='M25.366 14.014l-2.868-.61.081-1.339 2.896.718-.109 1.232z'
        fill='#36FFC1'
      />
      <path
        d='M22.622 10.718l-3.183-.677.006-1.42 3.182.775-.005 1.322z'
        fill='#8DFF6A'
      />
      <path
        d='M12.932 6.147L9.89 5.96l.125-1.48L13 4.741l-.067 1.406z'
        fill='#FFEA00'
      />
      <path
        d='M11.84 22.568l-.253.937-.712.758.386-.974.579-.72z'
        fill='#00F'
      />
      <path
        d='M24.771 20.206l-1.935-.01.335-.02 2.005.042-.405-.012z'
        fill='#0050FF'
      />
      <path
        d='M10.875 24.264l-.098 1.015-.906.5.226-1.052.778-.463z'
        fill='#0000C4'
      />
      <path
        d='M27.089 17.74l-2.332-.403.245-1.017 2.381.504-.294.917z'
        fill='#00B0FF'
      />
      <path
        d='M16.16 6.594l-3.227-.446L13 4.742l3.175.523-.014 1.33z'
        fill='#FBF100'
      />
      <path
        d='M19.863 18.438l-1.853.192.082.799 1.938-.23-.167-.762z'
        fill='#0080FF'
      />
      <path
        d='M9.888 5.96l-2.74.09.185-1.547 2.68-.023-.125 1.48z'
        fill='#FFE200'
      />
      <path
        d='M2.827 12.702L1.4 13.744l-.128-1.97 1.445-1.002.109 1.93z'
        fill='#53FFA4'
      />
      <path
        d='M2.111 17.6l-.87 1.253-.476-1.908.918-1.243.428 1.898z'
        fill='#00B0FF'
      />
      <path
        d='M12.806 20.752l-.458.823-.51.994.585-.864.383-.953z'
        fill='#002CFF'
      />
      <path
        d='M21.945 19.098l-1.916.1.194.573 1.992-.12-.27-.553z'
        fill='#0070FF'
      />
      <path
        d='M5.52 25.921l-.093 1.163-1.084-.947.135-1.179 1.042.963z'
        fill='#00009F'
      />
      <path
        d='M4.478 24.958l-.136 1.179-1.01-1.207.175-1.192.97 1.22z'
        fill='#0000C8'
      />
      <path
        d='M16.3 17.919l-1.393.415-.111 1.093 1.488-.468.017-1.04z'
        fill='#008CFF'
      />
      <path
        d='M24.383 20.014l-1.868.005.32.176 1.936.01-.388-.191z'
        fill='#005CFF'
      />
      <path
        d='M14.907 18.335l-1.07.55-.214 1.145 1.173-.602.111-1.093z'
        fill='#007CFF'
      />
      <path
        d='M27.383 16.823l-2.381-.503.205-1.117 2.422.608-.246 1.012z'
        fill='#00D8FF'
      />
      <path
        d='M6.606 26.603l-.047 1.145-1.132-.665.092-1.163 1.087.683z'
        fill='#000089'
      />
      <path
        d='M9.87 25.777l.01 1.06-1.068.232.099-1.1.959-.192z'
        fill='#00009B'
      />
      <path
        d='M25.475 12.784l-2.896-.718.044-1.347 2.909.821-.057 1.244z'
        fill='#63FF94'
      />
      <path
        d='M3.507 23.738L3.33 24.93l-.914-1.437.213-1.202.877 1.447z'
        fill='#0000FA'
      />
      <path
        d='M17.944 17.643l-1.642.276-.017 1.04 1.726-.33-.067-.986z'
        fill='#009CFF'
      />
      <path
        d='M19.432 7.27l-3.272-.676.014-1.33 3.224.755.034 1.25z'
        fill='#F1FC06'
      />
      <path
        d='M22.627 9.396l-3.182-.775-.013-1.352 3.16.864.035 1.263z'
        fill='#BEFF39'
      />
      <path
        d='M13.838 18.885l-.71.672-.321 1.195.816-.722.215-1.145z'
        fill='#0070FF'
      />
      <path
        d='M7.713 26.99v1.124l-1.153-.366.046-1.145 1.107.387z'
        fill='navy'
      />
      <path
        d='M24.022 19.646l-1.806.004.3.369 1.868-.006-.362-.367z'
        fill='#006CFF'
      />
      <path
        d='M4.668 8.17l-1.923.711.166-1.801 1.892-.654-.135 1.745z'
        fill='#D4FF23'
      />
      <path
        d='M27.628 15.812l-2.422-.608.16-1.188 2.452.713-.19 1.083z'
        fill='#19FFDE'
      />
      <path
        d='M7.148 6.05l-2.345.375.244-1.61 2.286-.313-.185 1.547z'
        fill='#FFDB00'
      />
      <path
        d='M2.63 22.291l-.212 1.203-.794-1.635.245-1.209.762 1.641z'
        fill='#0024FF'
      />
      <path
        d='M21.712 18.373l-1.849.064.167.761 1.916-.1-.234-.725z'
        fill='#0094FF'
      />
      <path
        d='M19.727 17.504l-1.784.139.067.986 1.853-.192-.136-.933z'
        fill='#00ACFF'
      />
      <path
        d='M13 4.741l-2.986-.26.176-1.313 2.903.325-.094 1.248z'
        fill='#FFB200'
      />
      <path
        d='M1.682 15.702l-.918 1.243-.314-1.976.95-1.225.282 1.958z'
        fill='#13FCE4'
      />
      <path
        d='M11.586 23.506l.018.976-.829.796.099-1.015.712-.757z'
        fill='#0000F1'
      />
      <path
        d='M16.174 5.264l-3.175-.522.093-1.249 3.097.59-.015 1.181z'
        fill='#FFBD00'
      />
      <path
        d='M12.349 21.574l-.135.895-.627 1.036.252-.937.51-.994z'
        fill='#0020FF'
      />
      <path
        d='M25.532 11.54l-2.909-.821.005-1.323 2.906.92-.002 1.224z'
        fill='#8DFF6A'
      />
      <path
        d='M27.243 20.233l-1.657-.182.406-.342 1.704.24-.453.284z'
        fill='#006CFF'
      />
      <path
        d='M27.695 19.95l-1.703-.24.392-.509 1.748.31-.437.438z'
        fill='#0078FF'
      />
      <path
        d='M2.718 10.771l-1.445 1.002.033-1.934 1.44-.958-.028 1.89z'
        fill='#97FF60'
      />
      <path
        d='M26.786 20.355l-1.61-.137.41-.167 1.657.182-.457.122z'
        fill='#0068FF'
      />
      <path
        d='M28.133 19.511l-1.748-.31.368-.662 1.79.392-.41.58z'
        fill='#008CFF'
      />
      <path
        d='M10.014 4.481l-2.68.022.263-1.374 2.594.04-.177 1.312z'
        fill='#FFA700'
      />
      <path
        d='M16.316 16.7l-1.32.348-.089 1.286 1.394-.415.015-1.22z'
        fill='#00C4FF'
      />
      <path
        d='M8.813 27.07l.045 1.102-1.146-.058.001-1.124 1.1.08z'
        fill='#000084'
      />
      <path
        d='M10.776 25.278l.11 1.018-1.006.54-.01-1.058.906-.5z'
        fill='#00B'
      />
      <path
        d='M23.695 19.113l-1.75-.015.27.553 1.806-.004-.326-.534z'
        fill='#0084FF'
      />
      <path
        d='M13.128 19.557l-.353.773-.426 1.245.458-.823.32-1.195z'
        fill='#0068FF'
      />
      <path
        d='M27.818 14.728l-2.453-.713.11-1.232 2.473.82-.13 1.125z'
        fill='#3CFFBA'
      />
      <path
        d='M17.895 16.492l-1.579.208-.015 1.219 1.642-.276-.048-1.15z'
        fill='#00D0FF'
      />
      <path
        d='M1.87 20.65l-.246 1.208-.653-1.793.271-1.212.627 1.797z'
        fill='#0064FF'
      />
      <path
        d='M26.336 20.313l-1.564-.108.404.012 1.61.138-.45-.042z'
        fill='#0068FF'
      />
      <path
        d='M14.995 17.049l-.99.486-.168 1.35 1.07-.55.088-1.286z'
        fill='#00B8FF'
      />
      <path
        d='M28.542 18.93l-1.79-.39.337-.8 1.826.481-.373.71z'
        fill='#00A4FF'
      />
      <path
        d='M22.592 8.134l-3.16-.865-.034-1.25 3.12.944.074 1.17z'
        fill='#EBFF0C'
      />
      <path
        d='M19.398 6.018l-3.224-.754.016-1.182 3.155.821.053 1.115z'
        fill='#FFC800'
      />
      <path
        d='M21.52 17.494l-1.793.01.136.933 1.849-.064-.192-.879z'
        fill='#00BCFF'
      />
      <path
        d='M25.904 20.108l-1.52-.094.388.191 1.564.108-.432-.205z'
        fill='#0074FF'
      />
      <path
        d='M28.915 18.222l-1.827-.48.294-.918 1.86.577-.327.821z'
        fill='#00C4FF'
      />
      <path
        d='M19.626 16.423l-1.73.07.048 1.15 1.784-.139-.102-1.081z'
        fill='#00DCFE'
      />
      <path
        d='M14.005 17.534l-.627.612-.25 1.41.71-.672.167-1.35z'
        fill='#00B0FF'
      />
      <path
        d='M25.534 10.316l-2.907-.92-.035-1.262 2.889 1.01.053 1.172z'
        fill='#B7FF40'
      />
      <path
        d='M23.412 18.425l-1.7-.052.234.725 1.75.015-.284-.688z'
        fill='#00A4FF'
      />
      <path
        d='M27.948 13.602l-2.473-.819.056-1.243 2.483.921-.066 1.141z'
        fill='#63FF94'
      />
      <path
        d='M9.88 26.836l.089 1.08-1.111.255-.045-1.102 1.067-.233z'
        fill='#000096'
      />
      <path
        d='M1.4 13.744l-.95 1.225-.14-1.995.963-1.2.127 1.97z'
        fill='#53FFA4'
      />
      <path
        d='M4.803 6.427l-1.892.654.3-1.667 1.836-.598-.244 1.61z'
        fill='gold'
      />
      <path
        d='M13.093 3.494l-2.903-.325.225-1.11 2.795.378-.117 1.057z'
        fill='#FF7A00'
      />
      <path
        d='M7.333 4.503l-2.286.313.349-1.432 2.2-.255-.263 1.374z'
        fill='#FF9C00'
      />
      <path
        d='M16.19 4.082l-3.097-.589.117-1.056 2.997.642-.017 1.003z'
        fill='#FF8900'
      />
      <path
        d='M25.5 19.743l-1.477-.096.361.366 1.52.094-.403-.364z'
        fill='#0084FF'
      />
      <path
        d='M5.426 27.084l.132 1.061-1.082-.945-.134-1.063 1.085.947z'
        fill='#00009F'
      />
      <path
        d='M29.242 17.4l-1.86-.576.246-1.013 1.886.677-.272.912z'
        fill='#00E4F8'
      />
      <path
        d='M4.342 26.137l.134 1.064-1.01-1.204-.135-1.066 1.011 1.206z'
        fill='#0000C8'
      />
      <path
        d='M12.214 22.47l.122.933-.73 1.078-.02-.976.628-1.035z'
        fill='#0018FF'
      />
      <path
        d='M1.242 18.854l-.271 1.212-.497-1.91.29-1.21.478 1.908z'
        fill='#00ACFF'
      />
      <path
        d='M6.559 27.748l.13 1.061-1.13-.664-.132-1.062 1.132.665z'
        fill='#000089'
      />
      <path
        d='M12.775 20.33l-.035.848-.526 1.292.134-.895.427-1.245z'
        fill='#005CFF'
      />
      <path
        d='M16.33 15.33l-1.273.27-.062 1.448 1.321-.349.014-1.369z'
        fill='#16FFE1'
      />
      <path
        d='M11.605 24.481l.205.975-.922.84-.112-1.018.83-.797z'
        fill='#0000ED'
      />
      <path
        d='M22.517 6.964l-3.12-.945-.052-1.115 3.06 1.013.112 1.047z'
        fill='gold'
      />
      <path
        d='M17.866 15.205l-1.536.126-.014 1.369 1.579-.208-.029-1.287z'
        fill='#1CFFDB'
      />
      <path
        d='M2.746 8.882l-1.44.958.194-1.848 1.411-.912-.165 1.802z'
        fill='#D7FF1F'
      />
      <path
        d='M3.33 24.93l.136 1.067-.911-1.433-.138-1.07.914 1.436z'
        fill='#0000FA'
      />
      <path
        d='M21.378 16.482l-1.752-.06.101 1.082 1.794-.01-.143-1.012z'
        fill='#02E8F4'
      />
      <path
        d='M10.19 3.168l-2.594-.04.335-1.162 2.483.092-.224 1.11z'
        fill='#FF6F00'
      />
      <path
        d='M19.346 4.904l-3.156-.821.018-1.003 3.066.875.072.949z'
        fill='#FF9800'
      />
      <path
        d='M15.058 15.602l-.938.411-.115 1.522.99-.486.063-1.447z'
        fill='#13FCE4'
      />
      <path
        d='M25.136 19.229l-1.44-.116.326.534 1.478.097-.364-.515z'
        fill='#009CFF'
      />
      <path
        d='M13.377 18.145l-.27.718-.333 1.467.353-.774.25-1.41z'
        fill='#00A8FF'
      />
      <path d='M23.18 17.599l-1.66-.105.192.88 1.7.05-.232-.825z' fill='#0CF' />
      <path
        d='M29.515 16.488l-1.886-.677.19-1.082 1.906.777-.21.982z'
        fill='#1FFFD7'
      />
      <path
        d='M7.711 28.114l.128 1.063-1.15-.367-.13-1.062 1.152.366z'
        fill='navy'
      />
      <path
        d='M28.014 12.461l-2.483-.92.002-1.225 2.48 1.018v1.127z'
        fill='#8DFF6A'
      />
      <path
        d='M25.48 9.143l-2.888-1.01-.074-1.17 2.855 1.089.108 1.091z'
        fill='#E1FF16'
      />
      <path
        d='M19.562 15.22l-1.696-.015.029 1.287 1.73-.07-.063-1.203z'
        fill='#23FFD4'
      />
      <path
        d='M2.418 23.494l.137 1.07-.792-1.629-.139-1.076.794 1.635z'
        fill='#0024FF'
      />
      <path
        d='M28.367 20.488l-1.124-.255.453-.284 1.149.31-.478.23z'
        fill='#0084FF'
      />
      <path
        d='M10.888 26.295l.13 1.058-1.049.563-.088-1.08 1.007-.541z'
        fill='#00B'
      />
      <path
        d='M27.884 20.57l-1.098-.215.457-.123 1.124.256-.483.082z'
        fill='#0080FF'
      />
      <path
        d='M28.845 20.258l-1.149-.309.437-.437 1.173.373-.46.373z'
        fill='#0090FF'
      />
      <path
        d='M27.408 20.503l-1.073-.189.45.042 1.099.215-.476-.068z'
        fill='#0084FF'
      />
      <path
        d='M29.305 19.886l-1.173-.374.41-.58 1.195.448-.432.506z'
        fill='#00A0FF'
      />
      <path
        d='M14.12 16.012l-.57.542-.172 1.591.627-.611.115-1.522z'
        fill='#0CF4EB'
      />
      <path
        d='M.764 16.945l-.29 1.21-.328-1.98.305-1.206.313 1.976z'
        fill='#13FCE4'
      />
      <path
        d='M24.82 18.576l-1.408-.151.283.688 1.441.116-.315-.653z'
        fill='#00B8FF'
      />
      <path
        d='M16.207 3.08l-2.998-.644.138-.834 2.878.682-.018.795z'
        fill='#FF6000'
      />
      <path
        d='M29.724 15.505l-1.906-.777.13-1.126 1.918.878-.142 1.025z'
        fill='#43FFB4'
      />
      <path
        d='M1.273 11.774l-.963 1.2.037-1.963.959-1.171-.033 1.934z'
        fill='#97FF60'
      />
      <path
        d='M8.858 28.172l.125 1.064-1.144-.06-.127-1.062 1.146.058z'
        fill='#000084'
      />
      <path
        d='M13.21 2.437l-2.795-.379.267-.875 2.666.42-.138.834z'
        fill='#FF4E00'
      />
      <path
        d='M22.405 5.915l-3.06-1.012-.072-.949L22.26 5.02l.146.895z'
        fill='#FFAB00'
      />
      <path
        d='M26.952 20.285l-1.049-.177.433.206 1.073.189-.457-.218z'
        fill='#008CFF'
      />
      <path
        d='M21.286 15.363l-1.725-.143.064 1.203 1.752.06-.091-1.12z'
        fill='#2CFFCA'
      />
      <path
        d='M29.738 19.379l-1.195-.449.373-.71 1.216.532-.394.627z'
        fill='#00B8FF'
      />
      <path
        d='M5.047 4.815l-1.835.598.43-1.486 1.754-.544-.349 1.432z'
        fill='#FF9400'
      />
      <path
        d='M7.596 3.128l-2.2.254.445-1.214 2.09-.203-.335 1.163z'
        fill='#FF6400'
      />
      <path
        d='M23.006 16.655l-1.629-.173.143 1.012 1.66.105-.174-.944z'
        fill='#0CF4EB'
      />
      <path
        d='M17.858 13.815l-1.517.032-.01 1.484 1.535-.126-.008-1.39z'
        fill='#50FFA7'
      />
      <path
        d='M16.341 13.847l-1.25.18-.033 1.573 1.272-.27.011-1.483z'
        fill='#4DFFAA'
      />
      <path
        d='M28.013 11.334l-2.48-1.018-.053-1.172 2.466 1.105.067 1.085z'
        fill='#B4FF43'
      />
      <path
        d='M12.74 21.178l.209.89-.613 1.335-.122-.934.526-1.291z'
        fill='#0058FF'
      />
      <path
        d='M19.274 3.955l-3.067-.875.018-.795 2.96.914.089.756z'
        fill='#FF6F00'
      />
      <path
        d='M1.624 21.859l.14 1.076-.652-1.788-.141-1.082.653 1.794z'
        fill='#0068FF'
      />
      <path
        d='M25.373 8.052l-2.856-1.089-.112-1.047 2.809 1.156.159.98z'
        fill='#FFE200'
      />
      <path
        d='M12.336 23.404l.287.934-.813 1.12-.205-.976.731-1.078z'
        fill='#0014FF'
      />
      <path
        d='M13.108 18.863l.042.798-.41 1.517.035-.848.333-1.467z'
        fill='#00A0FF'
      />
      <path
        d='M26.526 19.924l-1.026-.18.403.364 1.05.177-.427-.36z'
        fill='#009CFF'
      />
      <path
        d='M19.538 13.924l-1.68-.11.009 1.39 1.695.015-.024-1.295z'
        fill='#53FFA4'
      />
      <path
        d='M30.13 18.753l-1.215-.531.327-.822 1.233.62-.344.733z'
        fill='#00D4FF'
      />
      <path
        d='M10.414 2.058l-2.482-.092.4-.918 2.349.135-.267.875z'
        fill='#FF3F00'
      />
      <path
        d='M2.911 7.08L1.5 7.992l.351-1.713 1.361-.865-.3 1.666z'
        fill='#FFD300'
      />
      <path
        d='M15.092 14.027l-.912.329-.06 1.656.938-.412.034-1.573z'
        fill='#49FFAD'
      />
      <path
        d='M24.562 17.8l-1.381-.201.231.826 1.409.151-.259-.775z'
        fill='#00DCFE'
      />
      <path
        d='M29.867 14.48l-1.919-.878.066-1.141 1.924.976-.071 1.044z'
        fill='#66FF90'
      />
      <path
        d='M13.549 16.555l-.214.655-.228 1.653.27-.717.172-1.591z'
        fill='#09F0EE'
      />
      <path
        d='M9.968 27.917l.124 1.068-1.109.251-.126-1.064 1.111-.255z'
        fill='#00009B'
      />
      <path
        d='M11.809 25.457l.167 1.037-.96.86-.13-1.058.923-.839z'
        fill='#0000E8'
      />
      <path
        d='M26.143 19.428l-1.006-.2.364.515 1.026.18-.384-.495z'
        fill='#00B0FF'
      />
      <path
        d='M30.475 18.02l-1.233-.62.272-.913 1.247.712-.286.82z'
        fill='#0CF4EB'
      />
      <path
        d='M22.894 15.617l-1.609-.255.092 1.12 1.629.173-.112-1.038z'
        fill='#33FFC4'
      />
      <path
        d='M21.249 14.163l-1.712-.238.024 1.295 1.725.143-.037-1.2z'
        fill='#56FFA0'
      />
      <path
        d='M16.225 2.285l-2.878-.683.155-.588 2.742.707-.02.564z'
        fill='#FF3B00'
      />
      <path
        d='M5.558 28.145l.204.953-1.072-.935-.214-.963 1.082.945z'
        fill='#0000A8'
      />
      <path
        d='M27.946 10.25L25.48 9.143l-.107-1.091 2.44 1.183.133 1.013z'
        fill='#D7FF1F'
      />
      <path
        d='M22.26 5.021l-2.987-1.066-.087-.756 2.895 1.104.178.718z'
        fill='#FF8600'
      />
      <path
        d='M4.476 27.2l.215.963-.999-1.19-.225-.976L4.476 27.2z'
        fill='#0000CD'
      />
      <path
        d='M.45 14.97l-.304 1.205L0 14.172l.31-1.197.14 1.994z'
        fill='#53FFA4'
      />
      <path
        d='M14.18 14.355l-.543.468-.088 1.731.57-.542.06-1.657z'
        fill='#46FFB1'
      />
      <path
        d='M13.348 1.601l-2.666-.42.302-.615 2.519.447-.155.588z'
        fill='#FF2900'
      />
      <path
        d='M.97 20.066l.14 1.082-.495-1.903-.142-1.089.497 1.91z'
        fill='#00B0FF'
      />
      <path
        d='M17.871 12.357l-1.52-.07-.01 1.56 1.517-.032.013-1.458z'
        fill='#80FF77'
      />
      <path
        d='M6.689 28.809l.191.947-1.118-.659-.203-.953 1.13.665z'
        fill='#000092'
      />
      <path
        d='M25.215 7.072l-2.809-1.156-.146-.895 2.748 1.208.207.843z'
        fill='#FFB900'
      />
      <path
        d='M16.35 12.286l-1.253.084-.005 1.657 1.25-.18.008-1.56z'
        fill='#80FF77'
      />
      <path
        d='M24.367 16.923l-1.361-.268.174.944 1.382.202-.195-.878z'
        fill='#16FFE1'
      />
      <path
        d='M19.186 3.198l-2.96-.914.018-.563 2.84.936.102.541z'
        fill='#FF4E00'
      />
      <path
        d='M29.938 13.437l-1.924-.976v-1.128l1.92 1.069.004 1.035z'
        fill='#8AFF6D'
      />
      <path
        d='M1.307 9.84l-.96 1.171.218-1.882.935-1.137-.193 1.848z'
        fill='#D7FF1F'
      />
      <path
        d='M3.466 25.997l.226.975-.902-1.417-.235-.991.911 1.433z'
        fill='#00F'
      />
      <path
        d='M25.81 18.81l-.989-.234.316.653 1.005.2-.333-.62z'
        fill='#00C8FF'
      />
      <path
        d='M19.553 12.571l-1.683-.215-.013 1.459 1.68.11.016-1.354z'
        fill='#80FF77'
      />
      <path
        d='M30.76 17.2l-1.246-.713.21-.981 1.256.806-.22.887z'
        fill='#29FFCE'
      />
      <path
        d='M7.932 1.965l-2.09.203.532-.961 1.958-.16-.4.918z'
        fill='#FF3000'
      />
      <path
        d='M5.396 3.384l-1.754.545.55-1.264 1.65-.495-.446 1.214z'
        fill='#FF5900'
      />
      <path
        d='M28.386 20.848l-.501-.278.482-.082.51.314-.49.046z'
        fill='#0098FF'
      />
      <path
        d='M28.877 20.802l-.51-.313.478-.23.517.36-.485.183z'
        fill='#009CFF'
      />
      <path
        d='M7.84 29.177l.18.944-1.14-.365-.192-.946 1.151.367z'
        fill='#000084'
      />
      <path
        d='M27.903 20.757l-.494-.255.476.068.501.278-.483-.091z'
        fill='#0098FF'
      />
      <path
        d='M15.097 12.37l-.915.238-.002 1.747.911-.328.006-1.658z'
        fill='#80FF77'
      />
      <path
        d='M29.362 20.62l-.517-.361.46-.373.525.418-.468.315z'
        fill='#00A4FF'
      />
      <path
        d='M13.15 19.66l.277.846-.478 1.561-.209-.89.41-1.517z'
        fill='#009CFF'
      />
      <path
        d='M11.017 27.354l.122 1.072-1.046.558-.124-1.067 1.048-.564z'
        fill='#00B'
      />
      <path
        d='M12.949 22.068l.355.895-.682 1.374-.286-.933.613-1.336z'
        fill='#0054FF'
      />
      <path
        d='M10.681 1.182l-2.349-.135.455-.646 2.197.166-.303.615z'
        fill='#FF1600'
      />
      <path
        d='M22.849 14.511l-1.6-.348.037 1.2 1.609.254-.046-1.106z'
        fill='#5AFF9D'
      />
      <path
        d='M27.438 20.53l-.486-.245.457.217.493.255-.464-.227z'
        fill='#00A0FF'
      />
      <path
        d='M2.555 24.563l.235.992-.783-1.61-.243-1.011.791 1.629z'
        fill='#0028FF'
      />
      <path
        d='M13.335 17.21l.096.745-.281 1.706-.043-.797.228-1.653z'
        fill='#06ECF1'
      />
      <path
        d='M27.814 9.236l-2.441-1.184-.16-.98 2.406 1.249.195.915z'
        fill='#FBF100'
      />
      <path
        d='M21.268 12.916l-1.715-.344-.016 1.353 1.712.239.02-1.248z'
        fill='#80FF77'
      />
      <path
        d='M29.83 20.303l-.524-.418.432-.506.53.485-.438.44z'
        fill='#00B4FF'
      />
      <path
        d='M25.536 18.082l-.974-.281.259.775.988.233-.273-.727z'
        fill='#02E8F4'
      />
      <path
        d='M22.082 4.302l-2.896-1.103-.102-.542 2.793 1.124.205.52z'
        fill='#FF6400'
      />
      <path
        d='M3.212 5.413l-1.36.865.502-1.533 1.288-.817-.43 1.485z'
        fill='#FF9100'
      />
      <path
        d='M30.98 16.312l-1.256-.806.142-1.026 1.263.9-.149.932z'
        fill='#46FFB1'
      />
      <path
        d='M24.243 15.963l-1.348-.346.112 1.038 1.361.268-.125-.96z'
        fill='#39FFBE'
      />
      <path
        d='M16.244 1.722l-2.742-.707.169-.324 2.591.716-.018.315z'
        fill='#F20'
      />
      <path
        d='M29.934 12.401l-1.92-1.068-.068-1.085 1.911 1.153.077 1z'
        fill='#ADFF49'
      />
      <path
        d='M13.637 14.822l-.185.59-.116 1.798.214-.656.087-1.732z'
        fill='#43FFB4'
      />
      <path
        d='M27.006 20.173l-.48-.25.426.362.486.245-.432-.357z'
        fill='#00B0FF'
      />
      <path
        d='M25.008 6.229L22.26 5.02l-.178-.718 2.676 1.245.25.682z'
        fill='#FF9800'
      />
      <path
        d='M12.623 24.336l.2 1.017-.846 1.14-.167-1.038.813-1.12z'
        fill='#0014FF'
      />
      <path
        d='M17.904 10.87l-1.548-.18-.006 1.596 1.52.07.034-1.487z'
        fill='#B4FF43'
      />
      <path
        d='M30.269 19.864l-.53-.485.392-.627.537.559-.399.553z'
        fill='#00C8FF'
      />
      <path
        d='M8.984 29.236l.168.946-1.132-.06-.18-.945 1.144.06z'
        fill='#00008D'
      />
      <path
        d='M19.084 2.657l-2.84-.936.019-.315 2.707.94.114.311z'
        fill='#FF3800'
      />
      <path
        d='M.474 18.156l.143 1.09-.326-1.974-.144-1.096.327 1.98z'
        fill='#13FCE4'
      />
      <path
        d='M19.61 11.195l-1.706-.326-.033 1.488 1.683.214.057-1.376z'
        fill='#ADFF49'
      />
      <path
        d='M16.355 10.691l-1.283-.02.025 1.7 1.252-.084.006-1.596z'
        fill='#B7FF40'
      />
      <path
        d='M13.502 1.013L10.983.566l.33-.336 2.358.46-.169.323z'
        fill='#F60B00'
      />
      <path
        d='M14.182 12.607l-.545.387v1.828l.543-.467.002-1.748z'
        fill='#80FF77'
      />
      <path
        d='M.31 12.975L0 14.173l.04-1.975.307-1.186-.037 1.963z'
        fill='#97FF60'
      />
      <path
        d='M26.614 19.694l-.472-.266.384.496.48.249-.392-.479z'
        fill='#00C0FF'
      />
      <path
        d='M1.763 22.934l.244 1.01-.644-1.765-.252-1.032.652 1.787z'
        fill='#0068FF'
      />
      <path
        d='M25.33 17.266l-.962-.342.195.878.973.281-.206-.817z'
        fill='#1FFFD7'
      />
      <path
        d='M30.667 19.31l-.536-.558.344-.732.54.637-.348.654z'
        fill='#00E0FB'
      />
      <path
        d='M22.87 13.366l-1.602-.451-.019 1.248 1.6.348.02-1.145z'
        fill='#80FF77'
      />
      <path
        d='M31.129 15.38l-1.263-.9.071-1.043 1.264.99-.072.953z'
        fill='#66FF90'
      />
      <path
        d='M27.619 8.32l-2.405-1.249-.207-.842 2.36 1.3.252.791z'
        fill='#FC0'
      />
      <path
        d='M21.344 11.65l-1.734-.455-.056 1.376 1.715.344.075-1.264z'
        fill='#AAFF4D'
      />
      <path
        d='M15.072 10.672l-.946.144.056 1.793.915-.239-.025-1.698z'
        fill='#BAFF3C'
      />
      <path
        d='M24.19 14.947l-1.341-.435.046 1.105 1.347.347-.052-1.017z'
        fill='#5AFF9D'
      />
      <path
        d='M21.877 3.78l-2.793-1.124-.114-.31 2.681 1.126.226.308z'
        fill='#FF4E00'
      />
      <path
        d='M1.499 7.992L.563 9.129l.394-1.752.893-1.099-.35 1.714z'
        fill='#FFD000'
      />
      <path
        d='M29.858 11.402l-1.911-1.153-.133-1.014 1.894 1.228.15.939z'
        fill='#D1FF26'
      />
      <path
        d='M8.332 1.046l-1.958.16.605-.68L8.787.4l-.455.646z'
        fill='#F10800'
      />
      <path
        d='M26.275 19.106l-.466-.297.333.619.472.266-.339-.588z'
        fill='#00D8FF'
      />
      <path
        d='M11.977 26.494l.12 1.078-.958.855-.122-1.072.96-.86z'
        fill='#0000ED'
      />
      <path
        d='M24.758 5.547l-2.676-1.245-.205-.52 2.594 1.263.287.502z'
        fill='#FF7A00'
      />
      <path
        d='M10.984.568L8.787.402 9.285.05l2.03.183-.331.336z'
        fill='#DF0000'
      />
      <path
        d='M17.958 9.394l-1.599-.29-.003 1.588 1.548.178.054-1.476z'
        fill='#E4FF13'
      />
      <path
        d='M16.263 1.407L13.67.692l.178-.047 2.432.706-.018.056z'
        fill='#FA0F00'
      />
      <path
        d='M5.842 2.17l-1.65.495.656-1.006 1.526-.451-.532.962z'
        fill='#FF2500'
      />
      <path
        d='M31.015 18.657l-.54-.638.285-.82.544.721-.289.737z'
        fill='#16FFE1'
      />
      <path
        d='M10.092 28.984l.157.951-1.097.246-.169-.945 1.11-.252z'
        fill='#00009F'
      />
      <path
        d='M18.97 2.346l-2.707-.94.018-.056 2.566.927.122.07z'
        fill='#FF2500'
      />
      <path
        d='M19.706 9.834l-1.75-.441-.053 1.476 1.707.326.096-1.361z'
        fill='#DBFF1C'
      />
      <path
        d='M16.36 9.103l-1.34-.124.053 1.693 1.283.02.003-1.59z'
        fill='#EBFF0C'
      />
      <path
        d='M13.43 17.954l.325.802-.329 1.75-.277-.846.282-1.706z'
        fill='#02E8F4'
      />
      <path
        d='M25.196 16.378l-.954-.415.125.96.962.342-.133-.887z'
        fill='#3CFFBA'
      />
      <path
        d='M13.427 20.506l.41.857-.532 1.599-.356-.894.478-1.562z'
        fill='#0098FF'
      />
      <path
        d='M13.452 15.412l.123.689-.143 1.853-.096-.744.116-1.798z'
        fill='#43FFB4'
      />
      <path
        d='M13.67.69L11.313.23l.35-.043 2.185.456-.178.047z'
        fill='#DF0000'
      />
      <path
        d='M5.762 29.099l.199.798-1.051-.918-.22-.816 1.072.936z'
        fill='#0000B2'
      />
      <path
        d='M31.202 14.428l-1.265-.991-.002-1.036 1.261 1.077.006.95z'
        fill='#8AFF6D'
      />
      <path
        d='M4.691 28.163l.22.816-.98-1.167-.239-.84.999 1.19z'
        fill='#0000DA'
      />
      <path
        d='M22.959 12.21l-1.615-.56-.075 1.264 1.601.451.089-1.154z'
        fill='#A7FF50'
      />
      <path
        d='M13.637 12.994l-.186.521v1.897l.186-.59v-1.828z'
        fill='#80FF77'
      />
      <path
        d='M25.998 18.423l-.462-.341.273.727.467.297-.278-.683z'
        fill='#0CF4EB'
      />
      <path
        d='M28.247 21.178l.139-.33.49-.046-.144.36-.485.016z'
        fill='#00A8FF'
      />
      <path
        d='M27.367 7.529l-2.36-1.3-.25-.682 2.307 1.335.303.647z'
        fill='#FFAB00'
      />
      <path
        d='M1.11 21.147l.252 1.032-.49-1.88-.257-1.055.496 1.903z'
        fill='#00B0FF'
      />
      <path
        d='M21.473 10.405l-1.767-.571-.096 1.362 1.734.455.13-1.246z'
        fill='#D4FF23'
      />
      <path
        d='M27.77 21.067l.133-.31.483.091-.139.33-.477-.111z'
        fill='#00ACFF'
      />
      <path
        d='M3.642 3.928l-1.288.817.641-1.31 1.197-.77-.55 1.263z'
        fill='#F50'
      />
      <path
        d='M.146 16.175L.29 17.27l-.146-1.995L0 14.172l.146 2.003z'
        fill='#53FFA4'
      />
      <path
        d='M6.88 29.756l.178.786-1.097-.646-.2-.798 1.12.658z'
        fill='#00009B'
      />
      <path
        d='M21.65 3.473l-2.68-1.126-.123-.07 2.562 1.11.242.086z'
        fill='#FF3F00'
      />
      <path
        d='M28.732 21.162l.144-.36.486-.183-.15.4-.48.143z'
        fill='#00ACFF'
      />
      <path
        d='M14.127 10.815l-.577.305.088 1.875.545-.387-.056-1.793z'
        fill='#BEFF39'
      />
      <path
        d='M13.304 22.963l.23.998-.711 1.394-.2-1.017.681-1.375z'
        fill='#0050FF'
      />
      <path
        d='M24.212 13.899l-1.342-.534-.021 1.145 1.34.436.023-1.047z'
        fill='#80FF77'
      />
      <path
        d='M31.305 17.92l-.544-.72.22-.887.545.805-.221.803z'
        fill='#30FFC7'
      />
      <path
        d='M29.707 10.463l-1.893-1.228-.195-.915 1.869 1.29.219.853z'
        fill='#F1FC06'
      />
      <path
        d='M27.31 20.832l.129-.302.464.227-.133.31-.46-.235z'
        fill='#00B4FF'
      />
      <path
        d='M3.692 26.973l.239.84-.885-1.39-.256-.867.902 1.417z'
        fill='#00F'
      />
      <path
        d='M24.471 5.045L21.877 3.78l-.227-.308 2.505 1.264.316.308z'
        fill='#FF6400'
      />
      <path
        d='M29.213 21.02l.15-.401.468-.315-.156.45-.462.266z'
        fill='#00B8FF'
      />
      <path d='M18.03 7.966l-1.67-.402v1.538l1.598.29.072-1.426z' fill='gold' />
      <path
        d='M15.02 8.979l-1.007.048.113 1.79.947-.145-.054-1.693z'
        fill='#F1FC06'
      />
      <path
        d='M16.281 1.35L13.85.642l.181.232 2.269.68-.018-.206z'
        fill='#ED0400'
      />
      <path
        d='M18.847 2.277L16.28 1.35l.018.206 2.42.896.128-.175z'
        fill='#FF1E00'
      />
      <path
        d='M19.839 8.523l-1.81-.556-.072 1.426 1.749.441.133-1.31z'
        fill='#FFE200'
      />
      <path
        d='M26.883 20.479l.123-.305.433.357-.128.301-.428-.354z'
        fill='#00C0FF'
      />
      <path
        d='M.347 11.011L.04 12.198.267 10.3l.297-1.17-.217 1.88z'
        fill='#D7FF1F'
      />
      <path
        d='M8.02 30.12l.156.781-1.117-.359-.178-.786 1.139.364z'
        fill='#000092'
      />
      <path d='M16.358 7.565l-1.42-.23.08 1.643 1.34.124V7.565z' fill='#FC0' />
      <path
        d='M29.675 20.753l.155-.45.439-.44-.16.508-.434.382z'
        fill='#00C4FF'
      />
      <path
        d='M25.14 15.446l-.95-.499.053 1.017.954.415-.056-.933z'
        fill='#5DFF9A'
      />
      <path
        d='M25.788 17.662l-.458-.396.206.817.462.34-.21-.761z'
        fill='#26FFD1'
      />
      <path
        d='M31.196 13.478l-1.261-1.076-.078-1 1.255 1.155.084.921z'
        fill='#AAFF4D'
      />
      <path
        d='M11.315.231L9.285.048 9.813 0l1.851.187-.35.044z'
        fill='#C80000'
      />
      <path
        d='M11.139 28.426l.146.96-1.036.55-.157-.952 1.047-.558z'
        fill='#0000C4'
      />
      <path
        d='M26.495 20.015l.12-.32.39.479-.123.305-.387-.464z'
        fill='#00D0FF'
      />
      <path
        d='M8.787.401L6.979.527 7.642.15 9.285.048 8.787.4z'
        fill='#CD0000'
      />
      <path
        d='M23.113 11.078l-1.64-.673-.13 1.247 1.616.56.154-1.134z'
        fill='#CEFF29'
      />
      <path
        d='M21.41 3.387l-2.563-1.11-.128.175 2.44 1.075.25-.14z'
        fill='#FF3800'
      />
      <path
        d='M21.654 9.21l-1.815-.687-.133 1.311 1.767.57.18-1.194z'
        fill='#FBF100'
      />
      <path
        d='M31.527 17.118l-.546-.805.149-.932.546.89-.149.847z'
        fill='#4DFFAA'
      />
      <path
        d='M2.79 25.556l.256.867-.767-1.578-.272-.9.783 1.61z'
        fill='#0030FF'
      />
      <path
        d='M13.848.644L11.663.187l.36.252 2.007.437-.182-.232z'
        fill='#D10000'
      />
      <path
        d='M27.064 6.882l-2.306-1.335-.286-.502 2.245 1.353.347.484z'
        fill='#FF9100'
      />
      <path
        d='M12.824 25.354l.12 1.084-.846 1.133-.12-1.078.846-1.14z'
        fill='#0014FF'
      />
      <path
        d='M18.118 6.63l-1.762-.509.003 1.444 1.67.402.089-1.336z'
        fill='#FFA700'
      />
      <path
        d='M30.107 20.372l.161-.508.399-.553-.166.57-.394.49z'
        fill='#00D8FF'
      />
      <path
        d='M24.31 12.849l-1.351-.638-.089 1.155 1.342.533.097-1.05z'
        fill='#A4FF53'
      />
      <path
        d='M24.156 4.737l-2.505-1.265-.242-.085 2.41 1.247.337.103z'
        fill='#F50'
      />
      <path
        d='M29.488 9.611l-1.869-1.29-.252-.792 1.838 1.34.283.742z'
        fill='#FFDB00'
      />
      <path
        d='M18.719 2.452l-2.42-.895.016.464 2.274.847.13-.416z'
        fill='#FF1E00'
      />
      <path
        d='M1.85 6.278l-.893 1.1.561-1.575.835-1.058-.502 1.533z'
        fill='#FF8D00'
      />
      <path
        d='M20.005 7.3l-1.887-.67-.089 1.337 1.81.556.166-1.224z'
        fill='#FFB600'
      />
      <path
        d='M16.298 1.557L14.03.876l.181.507 2.103.638-.016-.464z'
        fill='#F10800'
      />
      <path
        d='M6.375 1.207l-1.526.452.746-.717L6.98.527l-.605.68z'
        fill='#E40000'
      />
      <path
        d='M26.16 19.452l.116-.347.339.589-.12.32-.336-.562z'
        fill='#02E8F4'
      />
      <path
        d='M14.937 7.336l-1.093-.045.168 1.736 1.006-.05-.08-1.64z'
        fill='#FFC100'
      />
      <path
        d='M16.356 6.121l-1.525-.329.107 1.545 1.42.228-.002-1.444z'
        fill='#FF9800'
      />
      <path
        d='M9.152 30.182l.135.781-1.111-.061-.156-.78 1.132.06z'
        fill='#000096'
      />
      <path
        d='M14.013 9.027l-.638.221.175 1.872.576-.304-.113-1.789z'
        fill='#F8F500'
      />
      <path
        d='M25.65 16.84l-.454-.461.133.886.458.397-.136-.821z'
        fill='#43FFB4'
      />
      <path
        d='M.616 19.244L.874 20.3l-.322-1.948-.261-1.08.325 1.973z'
        fill='#13FCE4'
      />
      <path
        d='M21.158 3.527l-2.44-1.075-.13.416 2.317 1.022.253-.363z'
        fill='#FF3800'
      />
      <path
        d='M13.55 11.12l-.216.45.118 1.945.186-.52-.088-1.876z'
        fill='#C1FF36'
      />
      <path
        d='M25.163 14.49l-.95-.59-.023 1.047.95.499.023-.956z'
        fill='#80FF77'
      />
      <path
        d='M18.22 5.422l-1.87-.612.006 1.31 1.762.51.104-1.21z'
        fill='#FF7E00'
      />
      <path
        d='M30.501 19.883l.166-.572.348-.653-.17.64-.344.585z'
        fill='#09F0EE'
      />
      <path
        d='M13.45 13.517l.124.633v1.952l-.123-.689v-1.896z'
        fill='#83FF73'
      />
      <path
        d='M21.881 8.098l-1.876-.8-.166 1.225 1.815.686.227-1.111z'
        fill='#FFC400'
      />
      <path
        d='M18.588 2.869l-2.274-.848.014.712 2.132.782.128-.646z'
        fill='#FF2900'
      />
      <path
        d='M13.574 16.102l.349.759-.168 1.895-.324-.802.143-1.852z'
        fill='#40FFB7'
      />
      <path
        d='M20.2 6.196l-1.979-.774-.103 1.209 1.887.668.196-1.103z'
        fill='#FF9100'
      />
      <path
        d='M31.113 12.557l-1.255-1.155-.15-.94 1.244 1.226.16.869z'
        fill='#CAFF2C'
      />
      <path
        d='M31.675 16.27l-.546-.89.072-.952.546.971-.072.871z'
        fill='#6AFF8D'
      />
      <path
        d='M23.328 9.996l-1.675-.786-.18 1.195 1.64.673.215-1.082z'
        fill='#F1FC06'
      />
      <path
        d='M13.755 18.756l.448.824-.367 1.784-.41-.858.329-1.75z'
        fill='#00E4F8'
      />
      <path
        d='M26.717 6.398l-2.245-1.353-.316-.308 2.18 1.353.381.308z'
        fill='#FF7A00'
      />
      <path
        d='M23.82 4.634l-2.411-1.247-.25.14 2.312 1.21.349-.103z'
        fill='#FF4E00'
      />
      <path
        d='M16.314 2.02l-2.103-.637.175.77 1.942.579-.014-.711z'
        fill='#FF1300'
      />
      <path
        d='M14.03.875L12.024.437l.36.542 1.829.403-.181-.507z'
        fill='#D60000'
      />
      <path
        d='M18.336 4.373L16.34 3.67l.009 1.14 1.872.611.115-1.048z'
        fill='#FF5900'
      />
      <path
        d='M0 14.172l.144 1.105.04-1.967-.144-1.113L0 14.172z'
        fill='#97FF60'
      />
      <path
        d='M18.46 3.514l-2.132-.783.012.939 1.996.703.123-.86z'
        fill='#FF3B00'
      />
      <path
        d='M2.007 23.946l.272.9-.632-1.73-.285-.936.645 1.766z'
        fill='#0070FF'
      />
      <path
        d='M25.884 18.807l.114-.384.278.683-.116.347-.276-.646z'
        fill='#16FFE1'
      />
      <path
        d='M20.905 3.89L18.59 2.866l-.129.646 2.197.954.248-.578z'
        fill='#FF4300'
      />
      <path
        d='M16.35 4.81l-1.65-.421.13 1.404 1.525.33-.007-1.311z'
        fill='#FF6C00'
      />
      <path
        d='M20.419 5.243l-2.083-.87-.115 1.049 1.979.774.219-.953z'
        fill='#FF6F00'
      />
      <path
        d='M24.478 11.823l-1.366-.745-.154 1.134 1.35.637.17-1.026z'
        fill='#C7FF30'
      />
      <path
        d='M4.191 2.664l-1.196.77.767-1.049 1.086-.727-.657 1.006z'
        fill='#FF1E00'
      />
      <path d='M11.663.187L9.812 0l.543.261 1.668.177-.36-.251z' fill='#B00' />
      <path
        d='M29.206 8.868l-1.838-1.34-.303-.646 1.801 1.372.34.614z'
        fill='#FFBD00'
      />
      <path
        d='M20.656 4.467l-2.197-.953-.123.859 2.083.87.237-.776z'
        fill='#F50'
      />
      <path
        d='M13.837 21.363l.25.983-.553 1.614-.23-.998.533-1.599z'
        fill='#0098FF'
      />
      <path
        d='M16.328 2.732l-1.941-.58.164 1.011 1.789.508-.012-.939z'
        fill='#FF2900'
      />
      <path
        d='M16.34 3.672l-1.788-.508.15 1.225 1.647.423-.009-1.14z'
        fill='#FF4700'
      />
      <path
        d='M22.149 7.1L20.2 6.196 20.005 7.3l1.876.799.268-.997z'
        fill='#FFA300'
      />
      <path
        d='M14.831 5.791l-1.205-.135.219 1.635 1.093.045-.107-1.545z'
        fill='#FF8900'
      />
      <path
        d='M30.845 19.297l.171-.64.289-.737-.176.711-.284.666z'
        fill='#1CFFDB'
      />
      <path
        d='M23.471 4.738l-2.313-1.21-.253.363 2.216 1.157.35-.31z'
        fill='#FF5200'
      />
      <path
        d='M25.592 15.982l-.452-.537.056.934.455.462-.059-.86z'
        fill='#60FF97'
      />
      <path
        d='M27.009 21.424l.76-.358.479.111-.775.376-.464-.129z'
        fill='#00BCFF'
      />
      <path
        d='M9.285.048L7.643.151l.703-.06L9.812 0l-.527.048z'
        fill='#B20000'
      />
      <path
        d='M27.473 21.553l.774-.375.486-.016-.79.402-.47-.01z'
        fill='#00B8FF'
      />
      <path
        d='M12.098 27.572l.137.972-.949.843-.146-.96.958-.855z'
        fill='#0000F1'
      />
      <path
        d='M26.563 21.181l.747-.35.459.235-.76.358-.447-.243z'
        fill='#00C4FF'
      />
      <path
        d='M23.6 8.994l-1.718-.896-.228 1.111 1.675.786.271-1.001z'
        fill='gold'
      />
      <path
        d='M25.263 13.534l-.954-.685-.097 1.05.95.59.1-.955z'
        fill='#A0FF56'
      />
      <path
        d='M26.335 6.09l-2.18-1.354-.336-.103 2.11 1.335.406.122z'
        fill='#FF6F00'
      />
      <path
        d='M14.212 1.383l-1.83-.404.35.819 1.655.354-.175-.77z'
        fill='#E40000'
      />
      <path
        d='M22.45 6.245l-2.03-1.002-.22.953 1.949.905.302-.856z'
        fill='#FF8200'
      />
      <path
        d='M.564 9.129L.267 10.3l.41-1.768.28-1.156-.393 1.752z'
        fill='#FFD000'
      />
      <path
        d='M10.25 29.936l.113.787-1.077.24-.135-.781 1.098-.246z'
        fill='#0000A8'
      />
      <path
        d='M13.845 7.291l-.727.14.257 1.817.638-.221-.168-1.736z'
        fill='#FFB900'
      />
      <path
        d='M25.675 18.093l.113-.43.21.76-.115.385-.208-.715z'
        fill='#30FFC7'
      />
      <path
        d='M27.943 21.563l.79-.401.48-.142-.805.435-.465.108z'
        fill='#00BCFF'
      />
      <path
        d='M31.747 15.4l-.545-.972-.006-.95.543 1.05.008.871z'
        fill='#87FF70'
      />
      <path
        d='M23.122 5.047l-2.216-1.156-.249.577 2.121 1.087.344-.508z'
        fill='#FF5900'
      />
      <path
        d='M30.952 11.687l-1.245-1.224-.219-.853 1.23 1.283.234.794z'
        fill='#E7FF0F'
      />
      <path
        d='M26.146 20.83l.736-.351.428.353-.747.35-.416-.352z'
        fill='#00D0FF'
      />
      <path
        d='M22.777 5.554l-2.121-1.086-.237.775 2.031 1.002.327-.69z'
        fill='#FF6C00'
      />
      <path
        d='M14.7 4.388l-1.338-.218.264 1.487 1.205.136-.13-1.405z'
        fill='#FF5D00'
      />
      <path
        d='M5.961 29.896l.138.606-1.022-.892-.167-.631 1.051.917z'
        fill='#0000C4'
      />
      <path
        d='M24.717 10.848l-1.388-.852-.216 1.082 1.366.745.238-.975z'
        fill='#E7FF0F'
      />
      <path
        d='M28.408 21.455l.804-.435.462-.266-.818.477-.448.224z'
        fill='#00C4FF'
      />
      <path
        d='M28.866 8.254l-1.802-1.372-.347-.485 1.761 1.39.388.467z'
        fill='#FFA700'
      />
      <path
        d='M14.387 2.153L12.732 1.8l.33 1.073 1.49.292-.165-1.01z'
        fill='#FF1300'
      />
      <path
        d='M4.91 28.98l.167.631-.952-1.134-.194-.665.979 1.168z'
        fill='#0000E8'
      />
      <path
        d='M31.128 18.63l.176-.71.222-.803-.18.784-.218.73z'
        fill='#36FFC1'
      />
      <path
        d='M25.77 20.377l.725-.363.387.463-.735.352-.377-.453z'
        fill='#00E0FB'
      />
      <path
        d='M14.551 3.163l-1.49-.292.301 1.299 1.339.218-.15-1.225z'
        fill='#FF3400'
      />
      <path
        d='M13.375 9.248l-.275.384.233 1.94.216-.452-.174-1.872z'
        fill='#FBF100'
      />
      <path
        d='M13.533 23.96l.119 1.092-.71 1.387-.119-1.085.71-1.393z'
        fill='#0054FF'
      />
      <path d='M6.98.527L5.594.941l.818-.405L7.643.15l-.664.377z' fill='#B00' />
      <path
        d='M12.023.439L10.355.262l.543.565 1.484.153-.36-.541z'
        fill='#BF0000'
      />
      <path
        d='M23.92 8.101l-1.771-1-.268.998 1.719.896.32-.894z'
        fill='#FFB600'
      />
      <path
        d='M25.928 5.969l-2.11-1.335-.347.104 2.038 1.3.42-.069z'
        fill='#FF6800'
      />
      <path
        d='M7.058 30.543l.107.588-1.066-.628-.138-.607 1.097.647z'
        fill='#0000AD'
      />
      <path
        d='M1.363 22.18l.285.936-.48-1.841-.295-.975.49 1.88z'
        fill='#00B4FF'
      />
      <path
        d='M.29 17.272l.262 1.08-.143-1.97-.264-1.105.145 1.995z'
        fill='#53FFA4'
      />
      <path
        d='M25.613 15.107l-.451-.618-.022.957.452.536.021-.875z'
        fill='#7DFF7A'
      />
      <path
        d='M2.353 4.745L1.52 5.803l.717-1.352.76-1.016-.643 1.31z'
        fill='#FF4E00'
      />
      <path
        d='M28.856 21.231l.819-.477.433-.382-.832.524-.42.335z'
        fill='#00D4FF'
      />
      <path
        d='M3.931 27.813l.195.664-.86-1.349-.22-.704.885 1.389z'
        fill='#0004FF'
      />
      <path
        d='M25.54 17.328l.111-.487.137.82-.113.432-.136-.765z'
        fill='#49FFAD'
      />
      <path
        d='M13.334 11.572l.097.58.144 1.999-.123-.634-.118-1.945z'
        fill='#C1FF36'
      />
      <path
        d='M25.443 19.837l.715-.384.336.562-.724.363-.327-.541z'
        fill='#0CF4EB'
      />
      <path
        d='M25.44 12.606l-.96-.784-.17 1.027.953.685.177-.928z'
        fill='#C1FF36'
      />
      <path
        d='M24.282 7.34l-1.831-1.095-.302.856 1.772 1 .361-.761z'
        fill='#FF9800'
      />
      <path
        d='M13.626 5.656l-.842.064.333 1.71.727-.14-.218-1.634z'
        fill='#FF7E00'
      />
      <path
        d='M25.51 6.038l-2.038-1.3-.35.31 1.966 1.246.422-.256z'
        fill='#FF6C00'
      />
      <path
        d='M31.739 14.527l-.543-1.049-.084-.921.54 1.119.087.85z'
        fill='#A7FF50'
      />
      <path
        d='M30.718 10.893l-1.23-1.283-.283-.743 1.212 1.329.3.697z'
        fill='#FFEA00'
      />
      <path
        d='M25.017 9.95L23.6 8.994l-.272 1.002 1.389.852.3-.898z'
        fill='#FFE600'
      />
      <path
        d='M28.478 7.787l-1.761-1.39-.382-.307 1.717 1.39.426.307z'
        fill='#FF9400'
      />
      <path
        d='M13.574 14.15l.35.72-.001 1.99-.349-.758V14.15z'
        fill='#83FF73'
      />
      <path
        d='M24.674 6.732l-1.897-1.177-.327.69 1.832 1.095.392-.608z'
        fill='#FF8200'
      />
      <path
        d='M25.087 6.293l-1.966-1.246-.344.507 1.898 1.177.412-.438z'
        fill='#FF7300'
      />
      <path
        d='M8.176 30.902l.076.579-1.086-.35-.107-.588 1.117.359z'
        fill='#0000A4'
      />
      <path d='M9.812 0L8.346.09l.724.262 1.285-.09L9.813 0z' fill='#A40000' />
      <path
        d='M31.346 17.902l.18-.784.149-.848-.184.857-.145.775z'
        fill='#50FFA7'
      />
      <path
        d='M29.276 20.897l.832-.524.393-.49-.844.577-.38.437z'
        fill='#00E4F8'
      />
      <path
        d='M12.383.98L10.9.825l.53.856 1.304.115-.35-.818z'
        fill='#CD0000'
      />
      <path
        d='M13.923 16.86l.468.796-.188 1.924-.448-.824.168-1.896z'
        fill='#40FFB7'
      />
      <path
        d='M25.176 19.22l.708-.413.276.646-.716.383-.268-.616z'
        fill='#1FFFD7'
      />
      <path
        d='M.04 12.197l.145 1.113.227-1.888-.145-1.121-.227 1.896z'
        fill='#D7FF1F'
      />
      <path
        d='M4.848 1.66l-1.086.726.871-.756.962-.688-.747.717z'
        fill='#DA0000'
      />
      <path
        d='M11.285 29.386l.095.8-1.017.537-.114-.788 1.036-.55z'
        fill='#0000CD'
      />
      <path
        d='M3.047 26.424l.22.704-.746-1.532-.242-.75.768 1.578z'
        fill='#003CFF'
      />
      <path
        d='M13.363 4.17l-.978-.006.4 1.557.841-.064-.263-1.487z'
        fill='#FF4E00'
      />
      <path
        d='M25.714 14.239l-.451-.704-.1.955.45.617.101-.868z'
        fill='#9DFF5A'
      />
      <path
        d='M25.48 16.534l.113-.552.058.86-.112.487-.06-.795z'
        fill='#63FF94'
      />
      <path
        d='M12.732 1.797l-1.304-.115.5 1.122 1.134.066-.33-1.073z'
        fill='#E80000'
      />
      <path
        d='M25.372 9.156L23.92 8.102l-.321.893 1.417.956.355-.795z'
        fill='#FFC400'
      />
      <path
        d='M13.117 7.432l-.361.318.344 1.882.275-.384-.258-1.816z'
        fill='#FFAE00'
      />
      <path
        d='M28.053 7.48l-1.717-1.39-.406-.121 1.67 1.373.452.138z'
        fill='#FF8600'
      />
      <path
        d='M25.689 11.73l-.973-.882-.238.975.962.784.249-.876z'
        fill='#DEFF19'
      />
      <path
        d='M14.202 19.58l.267.969-.382 1.797-.251-.983.366-1.783z'
        fill='#00E4F8'
      />
      <path
        d='M13.062 2.87l-1.134-.065.456 1.359.979.005-.301-1.298z'
        fill='#F20'
      />
      <path
        d='M12.943 26.438l.128.987-.836 1.118-.137-.973.845-1.133z'
        fill='#0018FF'
      />
      <path
        d='M30.418 10.196l-1.212-1.329-.34-.613 1.192 1.36.36.582z'
        fill='#FFD000'
      />
      <path
        d='M29.657 20.459l.845-.577.343-.585-.856.633-.332.529z'
        fill='#0FF8E7'
      />
      <path
        d='M31.65 13.676l-.538-1.12-.16-.868.533 1.181.166.807z'
        fill='#C1FF36'
      />
      <path
        d='M24.972 18.543l.702-.45.21.714-.709.413-.203-.677z'
        fill='#33FFC4'
      />
      <path
        d='M9.286 30.963l.046.578-1.08-.06-.076-.58 1.11.062z'
        fill='#0000A8'
      />
      <path
        d='M31.491 17.127l.185-.856.071-.872-.187.927-.069.801z'
        fill='#6AFF8D'
      />
      <path d='M7.642.15l-1.23.386.868-.08L8.345.09l-.703.06z' fill='#9F0000' />
      <path
        d='M25.668 21.83l1.341-.405.464.128-1.36.42-.445-.143z'
        fill='#00C8FF'
      />
      <path
        d='M25.772 8.484l-1.49-1.144-.361.761 1.451 1.055.4-.672z'
        fill='#FFAB00'
      />
      <path
        d='M25.24 21.578l1.324-.396.445.243-1.341.405-.428-.252z'
        fill='#00D0FF'
      />
      <path
        d='M27.6 7.342l-1.672-1.373-.42.068 1.625 1.339.467-.034z'
        fill='#FF8200'
      />
      <path
        d='M.873 20.3l.295.975-.314-1.907-.302-1.016.32 1.948z'
        fill='#16FFE1'
      />
      <path
        d='M.958 7.376l-.28 1.156.586-1.592.255-1.137-.561 1.573z'
        fill='#FF8D00'
      />
      <path
        d='M26.112 21.974l1.36-.42.471.01-1.38.443-.45-.033z'
        fill='#00C8FF'
      />
      <path
        d='M24.84 21.224l1.306-.394.417.352-1.324.396-.4-.354z'
        fill='#00D8FF'
      />
      <path
        d='M10.355.262L9.07.352l.725.578L10.9.827l-.544-.565z'
        fill='#A80000'
      />
      <path
        d='M13.1 9.633l.043.529.287 1.99-.097-.58-.233-1.94z'
        fill='#FEED00'
      />
      <path
        d='M26.207 7.955L24.675 6.73l-.393.608 1.49 1.145.435-.53z'
        fill='#FF9800'
      />
      <path
        d='M27.133 7.376L25.51 6.037l-.422.257 1.578 1.288.468-.206z'
        fill='#FF8200'
      />
      <path
        d='M25.499 15.728l.115-.62-.021.874-.113.552.019-.806z'
        fill='#7DFF7A'
      />
      <path
        d='M25.893 13.4l-.452-.793-.177.928.451.704.178-.84z'
        fill='#BAFF3C'
      />
      <path
        d='M26.004 10.93l-.987-.979-.3.897.972.883.315-.8z'
        fill='#FBF100'
      />
      <path
        d='M26.564 22.006l1.38-.443.465-.108-1.4.471-.445.08z'
        fill='#00C8FF'
      />
      <path
        d='M29.988 19.93l.857-.633.284-.665-.867.691-.274.607z'
        fill='#26FFD1'
      />
      <path
        d='M24.479 20.777l1.291-.4.377.452-1.307.394-.361-.446z'
        fill='#02E8F4'
      />
      <path d='M2.28 24.845l.24.75-.613-1.68-.26-.8.632 1.73z' fill='#0078FF' />
      <path
        d='M26.664 7.582l-1.578-1.288-.412.438 1.532 1.223.458-.373z'
        fill='#FF8900'
      />
      <path
        d='M30.058 9.614l-1.192-1.36-.387-.467 1.169 1.376.41.45z'
        fill='#FFB900'
      />
      <path
        d='M14.087 22.346l.118 1.1-.553 1.606-.119-1.092.554-1.614z'
        fill='#0098FF'
      />
      <path
        d='M.145 15.277l.264 1.105.04-1.941-.264-1.13-.04 1.966z'
        fill='#97FF60'
      />
      <path
        d='M12.784 5.72l-.474.26.446 1.77.361-.318-.333-1.711z'
        fill='#FF7300'
      />
      <path
        d='M24.839 17.824l.7-.496.136.765-.703.45-.133-.72z'
        fill='#4DFFAA'
      />
      <path
        d='M31.485 12.87l-.534-1.182-.233-.794.528 1.233.24.742z'
        fill='#DEFF19'
      />
      <path
        d='M2.995 3.435l-.76 1.016.856-1.091.67-.974-.766 1.049z'
        fill='#FF1A00'
      />
      <path
        d='M27.009 21.926l1.4-.471.447-.224-1.418.504-.43.19z'
        fill='#00D0FF'
      />
      <path
        d='M24.164 20.248l1.28-.412.326.541-1.292.4-.314-.529z'
        fill='#13FCE4'
      />
      <path
        d='M31.56 16.326l.187-.926-.008-.873-.19.993.01.806z'
        fill='#87FF70'
      />
      <path
        d='M13.43 12.151l.328.683.168 2.035-.35-.72-.145-1.998z'
        fill='#C4FF33'
      />
      <path
        d='M10.898.826L9.794.93l.706.879.927-.126-.529-.856z'
        fill='#B60000'
      />
      <path
        d='M26.376 10.225l-1.004-1.07-.355.795.986.98.373-.705z'
        fill='gold'
      />
      <path
        d='M29.647 9.164l-1.17-1.376-.425-.308 1.145 1.377.45.307z'
        fill='#FFA700'
      />
      <path
        d='M12.234 28.543l.076.82-.93.823-.095-.8.949-.843z'
        fill='#0000FA'
      />
      <path
        d='M10.364 30.723l.015.587-1.047.23-.045-.578 1.077-.24z'
        fill='#00B'
      />
      <path
        d='M30.262 19.323l.866-.691.218-.73-.875.751-.21.67z'
        fill='#3CFFBA'
      />
      <path
        d='M27.438 21.736l1.418-.505.42-.335-1.437.542-.401.298z'
        fill='#00DCFE'
      />
      <path
        d='M26.143 12.61l-.454-.88-.25.877.453.791.25-.788z'
        fill='#D4FF23'
      />
      <path
        d='M12.384 4.164l-.608.206.535 1.61.473-.26-.4-1.556z'
        fill='#FF3F00'
      />
      <path
        d='M25.597 14.933l.118-.695-.101.869-.115.62.098-.794z'
        fill='#9AFF5D'
      />
      <path
        d='M5.594.941l-.961.687.954-.44.825-.653-.818.406z'
        fill='#B20000'
      />
      <path
        d='M6.099 30.503l.046.387-.984-.859-.084-.42 1.022.892z'
        fill='#0000D6'
      />
      <path
        d='M23.905 19.652l1.27-.432.268.616-1.279.413-.259-.597z'
        fill='#26FFD1'
      />
      <path
        d='M5.078 29.61l.084.42-.917-1.092-.119-.461.952 1.134z'
        fill='#0000FA'
      />
      <path d='M24.78 17.08l.7-.547.059.795-.7.496-.06-.744z' fill='#63FF94' />
      <path
        d='M13.925 14.87l.47.771-.003 2.016-.468-.796.001-1.992z'
        fill='#83FF73'
      />
      <path
        d='M11.428 1.682l-.928.126.667 1.157.76-.16-.5-1.123z'
        fill='#D60000'
      />
      <path d='M8.345.09L7.28.455l.894.25.895-.354L8.345.09z' fill='#960000' />
      <path
        d='M31.246 12.127l-.527-1.234-.301-.698.521 1.275.307.657z'
        fill='#F4F802'
      />
      <path
        d='M11.927 2.805l-.76.16.61 1.404.607-.205-.457-1.36z'
        fill='#FF1300'
      />
      <path
        d='M7.165 31.131l.007.364-1.027-.605-.046-.387 1.066.628z'
        fill='#0000BF'
      />
      <path
        d='M26.797 9.636l-1.025-1.152-.4.672 1.004 1.07.42-.59z'
        fill='#FFC100'
      />
      <path
        d='M.267 10.3l.145 1.122.41-1.76-.145-1.13-.41 1.768z'
        fill='#FFD000'
      />
      <path
        d='M29.198 8.857L28.053 7.48l-.452-.138 1.12 1.361.477.154z'
        fill='#FF9C00'
      />
      <path
        d='M31.55 15.52l.189-.993-.088-.851-.191 1.053.09.79z'
        fill='#A0FF56'
      />
      <path
        d='M12.756 7.75l-.036.482.423 1.929-.043-.53-.344-1.881z'
        fill='#FFAB00'
      />
      <path
        d='M4.125 28.477l.119.462-.827-1.299-.151-.512.859 1.349z'
        fill='#0014FF'
      />
      <path
        d='M27.839 21.438l1.437-.542.38-.437-1.453.583-.364.396z'
        fill='#06ECF1'
      />
      <path
        d='M1.647 23.116l.26.8-.465-1.786-.274-.855.48 1.841z'
        fill='#00BCFF'
      />
      <path
        d='M13.653 25.053l.121 1.006-.702 1.368-.129-.988.71-1.386z'
        fill='#0054FF'
      />
      <path
        d='M23.709 19.001l1.262-.458.204.676-1.27.432-.196-.65z'
        fill='#39FFBE'
      />
      <path
        d='M27.254 9.18l-1.047-1.225-.434.53 1.024 1.151.457-.457z'
        fill='#FFAE00'
      />
      <path
        d='M14.39 17.656l.276.958-.197 1.935-.267-.969.189-1.924z'
        fill='#40FFB7'
      />
      <path
        d='M28.72 8.703L27.6 7.342l-.466.034 1.095 1.33.492-.003z'
        fill='#FF9800'
      />
      <path
        d='M.551 18.351l.303 1.016-.14-1.927-.306-1.058.143 1.97z'
        fill='#56FFA0'
      />
      <path
        d='M30.472 18.653l.874-.75.145-.776-.88.81-.14.716z'
        fill='#53FFA4'
      />
      <path
        d='M26.461 11.895l-.457-.965-.315.8.455.88.317-.715z'
        fill='#EEFF09'
      />
      <path
        d='M27.735 8.866l-1.07-1.284-.458.373 1.046 1.224.482-.313z'
        fill='#FF9F00'
      />
      <path
        d='M28.229 8.705l-1.095-1.33-.469.206 1.07 1.284.494-.16z'
        fill='#FF9800'
      />
      <path
        d='M25.77 14.168l.122-.77-.177.84-.118.694.174-.764z'
        fill='#B4FF43'
      />
      <path
        d='M8.251 31.48l-.033.352-1.046-.337-.007-.364 1.086.35z'
        fill='#0000B6'
      />
      <path
        d='M23.429 22.02l1.81-.442.428.252-1.83.454-.408-.263z'
        fill='#00D8FF'
      />
      <path
        d='M30.939 11.47l-.521-1.275-.36-.582.514 1.303.367.554z'
        fill='#FFDE00'
      />
      <path
        d='M24.796 16.33l.703-.602-.02.805-.7.547.017-.75z'
        fill='#7DFF7A'
      />
      <path
        d='M23.837 22.284l1.83-.454.445.144-1.851.47-.424-.16z'
        fill='#00D0FF'
      />
      <path
        d='M23.048 21.659l1.792-.436.4.354-1.811.442-.381-.36z'
        fill='#00E0FB'
      />
      <path
        d='M24.26 22.444l1.852-.47.451.033-1.873.49-.43-.053z'
        fill='#00D0FF'
      />
      <path
        d='M1.519 5.803L1.264 6.94l.748-1.372.224-1.117-.717 1.352z'
        fill='#FF4E00'
      />
      <path
        d='M22.703 21.212l1.776-.435.361.447-1.792.436-.345-.448z'
        fill='#09F0EE'
      />
      <path
        d='M28.203 21.042l1.454-.583.331-.528-1.468.626-.317.485z'
        fill='#19FFDE'
      />
      <path
        d='M3.266 27.127l.151.512-.718-1.475-.178-.57.745 1.533z'
        fill='#0048FF'
      />
      <path
        d='M23.58 18.314l1.259-.49.133.72-1.263.458-.129-.688z'
        fill='#50FFA7'
      />
      <path
        d='M31.46 14.73l.191-1.054-.165-.807-.192 1.107.166.753z'
        fill='#BEFF39'
      />
      <path d='M9.07.352l-.896.354.894.576.727-.353L9.07.352z' fill='#960000' />
      <path
        d='M26.837 11.27l-.46-1.045-.373.704.457.965.376-.624z'
        fill='#FFE600'
      />
      <path
        d='M11.38 30.188l-.014.603-.988.52-.015-.587 1.017-.537z'
        fill='#0000DA'
      />
      <path
        d='M24.69 22.495l1.873-.49.446-.08-1.896.513-.424.057z'
        fill='#00D0FF'
      />
      <path
        d='M13.143 10.16l.282.65.333 2.024-.328-.683-.287-1.99z'
        fill='#FFEA00'
      />
      <path
        d='M22.402 20.687l1.762-.438.314.528-1.775.435-.3-.525z'
        fill='#16FFE1'
      />
      <path
        d='M12.31 5.979l-.14.44.55 1.813.036-.483-.445-1.77z'
        fill='#FF6C00'
      />
      <path
        d='M.185 13.31l.264 1.13.226-1.863-.263-1.155-.227 1.888z'
        fill='#D7FF1F'
      />
      <path
        d='M30.61 17.937l.88-.81.069-.8-.886.865-.064.745z'
        fill='#6DFF8A'
      />
      <path
        d='M3.761 2.386l-.67.974.973-.798.569-.933-.872.757z'
        fill='#D10000'
      />
      <path
        d='M30.572 10.917l-.514-1.303-.41-.45.506 1.317.418.436z'
        fill='#FC0'
      />
      <path
        d='M14.469 20.549l.117 1.108-.381 1.788-.118-1.1.382-1.796z'
        fill='#00E4F8'
      />
      <path
        d='M26.017 13.455l.126-.846-.25.789-.123.77.247-.713z'
        fill='#CEFF29'
      />
      <path
        d='M6.413.536l-.825.653L6.6 1.08l.68-.624-.867.08z'
        fill='#960000'
      />
      <path
        d='M24.89 15.595l.707-.662-.098.795-.702.603.093-.736z'
        fill='#97FF60'
      />
      <path d='M9.33 31.541l-.073.35-1.04-.06.034-.35 1.08.06z' fill='#00B' />
      <path
        d='M25.113 22.438l1.896-.513.428-.19-1.916.538-.408.165z'
        fill='#00D8FF'
      />
      <path
        d='M13.072 27.426l.06.845-.82 1.092-.077-.82.837-1.117z'
        fill='#0020FF'
      />
      <path
        d='M28.52 20.556l1.468-.626.274-.607-1.482.67-.26.564zm-6.365-.458l1.751-.446.259.597-1.762.438-.248-.589z'
        fill='#29FFCE'
      />
      <path
        d='M27.263 10.755l-.466-1.12-.42.59.46 1.045.426-.515z'
        fill='#FFD000'
      />
      <path
        d='M23.521 17.607l1.258-.527.06.744-1.26.49-.058-.707z'
        fill='#66FF90'
      />
      <path
        d='M31.294 13.975l.191-1.106-.24-.742-.19 1.151.239.697z'
        fill='#D4FF23'
      />
      <path
        d='M30.153 10.48l-.506-1.317-.45-.307.499 1.319.457.306z'
        fill='#FFB900'
      />
      <path d='M9.795.93l-.727.353.871.887.562-.361-.706-.88z' fill='#A80000' />
      <path
        d='M1.168 21.275l.275.854-.304-1.85-.285-.912.314 1.908z'
        fill='#19FFDE'
      />
      <path
        d='M13.758 12.834l.453.754.184 2.053-.47-.772-.167-2.035z'
        fill='#C4FF33'
      />
      <path
        d='M11.777 4.37l-.264.405.658 1.645.14-.44-.534-1.61z'
        fill='#FF3400'
      />
      <path
        d='M2.52 25.596l.18.57-.59-1.617-.203-.633.614 1.68z'
        fill='#0080FF'
      />
      <path
        d='M27.725 10.362l-.471-1.183-.457.457.465 1.119.463-.393z'
        fill='#FFC100'
      />
      <path
        d='M25.521 22.274l1.917-.538.401-.297-1.936.566-.381.269z'
        fill='#00E4F8'
      />
      <path
        d='M30.674 17.192l.885-.866-.01-.806-.888.92.013.752z'
        fill='#87FF70'
      />
      <path
        d='M21.966 19.46l1.743-.458.196.65-1.75.446-.19-.637z'
        fill='#3CFFBA'
      />
      <path
        d='M26.328 12.813l.133-.918-.318.715-.126.846.311-.643z'
        fill='#E4FF13'
      />
      <path
        d='M29.695 10.176l-.498-1.319-.477-.154.49 1.305.485.168z'
        fill='#FFB200'
      />
      <path
        d='M10.5 1.809l-.562.361.823 1.175.406-.38L10.5 1.81z'
        fill='#C80000'
      />
      <path
        d='M11.168 2.967l-.406.38.75 1.43.265-.407-.61-1.403z'
        fill='#F10800'
      />
      <path
        d='M25.056 14.891l.715-.723-.174.764-.707.662.166-.703z'
        fill='#B1FF46'
      />
      <path
        d='M28.213 10.102l-.477-1.237-.482.313.47 1.183.489-.26z'
        fill='#FFB200'
      />
      <path
        d='M.678 8.533l.145 1.13.585-1.585-.144-1.138-.586 1.593z'
        fill='#FF8D00'
      />
      <path
        d='M28.78 19.993l1.482-.67.21-.67-1.493.715-.199.625z'
        fill='#40FFB7'
      />
      <path
        d='M29.212 10.008l-.49-1.305-.492.003.483 1.277.5.025z'
        fill='#FFAB00'
      />
      <path
        d='M28.713 9.982l-.484-1.277-.494.16.477 1.237.5-.12z'
        fill='#FFAE00'
      />
      <path
        d='M23.536 16.899l1.26-.568-.017.75-1.258.527.015-.71z'
        fill='#7DFF7A'
      />
      <path
        d='M21.258 22.514l2.172-.494.407.264-2.192.509-.387-.279z'
        fill='#00DCFE'
      />
      <path
        d='M20.895 22.141l2.153-.48.382.36-2.172.494-.363-.374z'
        fill='#00E4F8'
      />
      <path
        d='M.408 16.381l.306 1.059.042-1.9-.307-1.1-.04 1.941z'
        fill='#97FF60'
      />
      <path
        d='M31.055 13.279l.191-1.152-.307-.656-.19 1.186.306.622z'
        fill='#EBFF0C'
      />
      <path d='M6.145 30.89l-.044.153-.94-.82v-.193l.984.86z' fill='#0000ED' />
      <path
        d='M14.206 23.445l.116 1.029-.548 1.585-.122-1.007.554-1.607z'
        fill='#009CFF'
      />
      <path
        d='M14.394 15.642l.276.95-.004 2.023-.275-.958.003-2.015z'
        fill='#83FF73'
      />
      <path
        d='M21.645 22.793l2.192-.509.424.16-2.215.526-.401-.177z'
        fill='#00D4FF'
      />
      <path
        d='M5.162 30.03v.194l-.874-1.042-.043-.243.917 1.091z'
        fill='#00F'
      />
      <path
        d='M12.72 8.232l.214.624.491 1.955-.282-.65-.423-1.929z'
        fill='#FFA300'
      />
      <path
        d='M20.567 21.681l2.136-.47.345.448-2.152.481-.329-.459zm5.335.322l1.937-.566.364-.396-1.956.596-.345.366z'
        fill='#0CF4EB'
      />
      <path
        d='M10.378 31.31l-.112.359-1.008.222.073-.35 1.047-.231z'
        fill='#0000CD'
      />
      <path
        d='M21.84 18.79l1.74-.476.129.688-1.743.459-.125-.67z'
        fill='#50FFA7'
      />
      <path
        d='M7.172 31.495l-.091.127-.98-.579.044-.153 1.027.605z'
        fill='#0000D6'
      />
      <path
        d='M26.698 12.258l.139-.987-.376.624-.133.918.37-.555z'
        fill='#F8F500'
      />
      <path
        d='M22.046 22.97l2.215-.527.429.052-2.237.544-.407-.07z'
        fill='#00D4FF'
      />
      <path
        d='M7.28.456l-.68.624 1.041.228.532-.602-.893-.25z'
        fill='#890000'
      />
      <path
        d='M20.281 21.15l2.122-.463.3.525-2.136.47-.286-.533z'
        fill='#19FFDE'
      />
      <path d='M12.31 29.363l-.04.63-.904.797.014-.603.93-.824z' fill='#00F' />
      <path
        d='M30.661 16.438l.888-.92-.09-.79-.887.969.09.741z'
        fill='#A0FF56'
      />
      <path
        d='M4.245 28.938l.043.244-.79-1.24-.08-.302.827 1.298z'
        fill='#0024FF'
      />
      <path
        d='M2.235 4.45l-.223 1.118.892-1.112.187-1.097-.856 1.092z'
        fill='#FF1600'
      />
      <path
        d='M25.292 14.24l.724-.785-.246.713-.714.723.236-.652z'
        fill='#C7FF30'
      />
      <path
        d='M30.75 12.658l.19-1.186-.368-.554-.187 1.21.364.53z'
        fill='#FEED00'
      />
      <path
        d='M28.979 19.368l1.492-.715.139-.716-1.5.758-.131.673z'
        fill='#56FFA0'
      />
      <path
        d='M4.634 1.63l-.57.933 1.065-.48.46-.894-.955.441z'
        fill='#A80000'
      />
      <path
        d='M22.452 23.04l2.237-.543.424-.058-2.26.563-.4.039z'
        fill='#00D4FF'
      />
      <path
        d='M23.623 16.206l1.267-.611-.093.736-1.26.567.086-.692z'
        fill='#97FF60'
      />
      <path
        d='M20.045 20.556l2.11-.458.248.588-2.122.463-.236-.593z'
        fill='#29FFCE'
      />
      <path
        d='M1.907 23.916l.202.633-.447-1.719-.22-.701.465 1.787z'
        fill='#00C4FF'
      />
      <path
        d='M26.248 21.638l1.955-.596.317-.485-1.972.625-.3.456z'
        fill='#1CFFDB'
      />
      <path
        d='M8.219 31.832l-.14.111-.998-.322.092-.126 1.046.337z'
        fill='#0000CD'
      />
      <path
        d='M21.784 18.105l1.738-.498.059.707-1.74.476-.057-.685z'
        fill='#66FF90'
      />
      <path
        d='M27.116 11.805l.146-1.05-.425.515-.139.988.418-.453z'
        fill='#FFDE00'
      />
      <path
        d='M.411 11.422l.263 1.155.408-1.736-.26-1.179-.41 1.76z'
        fill='#FFD300'
      />
      <path
        d='M14.667 18.614l.117 1.117-.197 1.926-.117-1.108.197-1.935z'
        fill='#40FFB7'
      />
      <path
        d='M22.854 23.001l2.26-.562.407-.166-2.282.582-.386.146z'
        fill='#00DCFE'
      />
      <path
        d='M30.385 12.126l.187-1.21-.418-.436-.183 1.223.414.423z'
        fill='#FFDB00'
      />
      <path
        d='M30.573 15.697l.887-.968-.166-.753-.885 1.01.164.711z'
        fill='#B7FF40'
      />
      <path
        d='M13.425 10.81l.418.742.368 2.036-.453-.754-.333-2.024z'
        fill='#FFE600'
      />
      <path
        d='M3.417 27.64l.08.303-.684-1.407-.114-.371.718 1.475z'
        fill='#0054FF'
      />
      <path
        d='M.854 19.367l.284.911-.134-1.87-.29-.969.14 1.928z'
        fill='#56FFA0'
      />
      <path
        d='M19.864 19.916l2.102-.456.19.637-2.11.459-.182-.64z'
        fill='#3CFFBA'
      />
      <path
        d='M13.774 26.059l.046.874-.688 1.337-.06-.844.702-1.367z'
        fill='#005CFF'
      />
      <path
        d='M12.17 6.42l.126.602.637 1.833-.214-.623-.548-1.812z'
        fill='#FF6400'
      />
      <path
        d='M27.572 11.468l.153-1.106-.463.393-.146 1.05.456-.337z'
        fill='#FFD000'
      />
      <path
        d='M25.592 13.658l.736-.845-.312.643-.724.785.3-.583z'
        fill='#DEFF19'
      />
      <path
        d='M8.174.705l-.532.602 1.042.561.384-.587-.894-.576z'
        fill='#890000'
      />
      <path
        d='M29.11 18.695l1.5-.76.064-.744-1.506.801-.059.703z'
        fill='#6DFF8A'
      />
      <path
        d='M29.97 11.704l.183-1.222-.457-.306-.178 1.222.452.306z'
        fill='#FC0'
      />
      <path
        d='M23.78 15.549l1.275-.657-.166.703-1.267.611.158-.657z'
        fill='#ADFF49'
      />
      <path
        d='M26.548 21.183l1.972-.626.26-.563-1.986.656-.246.533z'
        fill='#2CFFCA'
      />
      <path
        d='M21.796 17.42l1.74-.522-.014.71-1.738.496.012-.684z'
        fill='#7DFF7A'
      />
      <path
        d='M19.006 23.255l2.443-.59-.376-.326-2.449.583.382.332z'
        fill='#00DCFE'
      />
      <path
        d='M18.624 22.922l2.449-.584-.346-.417-2.456.577.353.424z'
        fill='#02E8F4'
      />
      <path
        d='M28.053 11.254l.16-1.152-.488.26-.153 1.106.481-.214z'
        fill='#FFC400'
      />
      <path
        d='M11.366 30.791l-.15.38-.95.499.112-.36.988-.519z'
        fill='#0000ED'
      />
      <path
        d='M23.24 22.855l2.282-.582.381-.27-2.302.602-.36.25z'
        fill='#02E8F4'
      />
      <path
        d='M19.406 23.487l2.438-.593-.396-.228-2.443.589.401.232z'
        fill='#00D4FF'
      />
      <path
        d='M9.258 31.891L9.071 32l-.992-.056.14-.111 1.04.06z'
        fill='#0000D1'
      />
      <path
        d='M29.517 11.398l.179-1.223-.485-.167-.173 1.21.48.18z'
        fill='#FFC400'
      />
      <path
        d='M19.743 19.248l2.098-.458.125.67-2.102.457-.12-.669z'
        fill='#53FFA4'
      />
      <path
        d='M18.271 22.498l2.455-.577-.308-.497-2.461.569.314.505z'
        fill='#0FF8E7'
      />
      <path
        d='M28.546 11.17l.167-1.187-.5.12-.16 1.15.493-.083z'
        fill='#FFC100'
      />
      <path
        d='M30.409 14.986l.885-1.01-.24-.698-.88 1.046.235.662z'
        fill='#CEFF29'
      />
      <path
        d='M29.039 11.219l.173-1.211-.5-.025-.166 1.187.493.049z'
        fill='#FFBD00'
      />
      <path
        d='M19.817 23.613l2.432-.595-.405-.123-2.438.592.411.126z'
        fill='#00D4FF'
      />
      <path
        d='M25.95 13.158l.748-.9-.37.555-.735.844.356-.499z'
        fill='#F1FC06'
      />
      <path
        d='M11.513 4.775l.018.588.766 1.659-.126-.602-.658-1.645z'
        fill='#FF2D00'
      />
      <path
        d='M17.957 21.993l2.461-.569-.262-.565-2.466.56.267.574z'
        fill='#1CFFDB'
      />
      <path
        d='M1.264 6.94l.144 1.138.748-1.364-.144-1.146-.748 1.372z'
        fill='#FF4E00'
      />
      <path
        d='M14.21 13.588l.27.946.191 2.057-.276-.95-.184-2.053z'
        fill='#C4FF33'
      />
      <path
        d='M9.069 1.282l-.384.587 1.014.88.24-.579-.87-.888z'
        fill='#9B0000'
      />
      <path
        d='M.45 14.44l.307 1.1.222-1.821-.303-1.142L.45 14.44z'
        fill='#D4FF23'
      />
      <path
        d='M2.7 26.165l.113.371-.563-1.54-.14-.447.59 1.616z'
        fill='#008CFF'
      />
      <path
        d='M29.168 17.993l1.505-.8-.012-.754-1.508.84.015.714z'
        fill='#87FF70'
      />
      <path
        d='M20.227 23.63l2.428-.596-.405-.016-2.433.594.41.017z'
        fill='#00D4FF'
      />
      <path
        d='M5.587 1.19l-.46.892 1.129-.145.343-.857-1.012.11z'
        fill='#8D0000'
      />
      <path
        d='M24.005 14.944l1.288-.704-.237.652-1.276.657.225-.605z'
        fill='#C4FF33'
      />
      <path
        d='M26.794 20.649l1.986-.656.199-.626-1.998.685-.187.597z'
        fill='#43FFB4'
      />
      <path
        d='M23.6 22.606l2.302-.601.345-.367-2.322.619-.325.349z'
        fill='#0FF8E7'
      />
      <path
        d='M13.132 28.271l-.064.663-.797 1.059.04-.63.82-1.091z'
        fill='#0028FF'
      />
      <path
        d='M14.586 21.657l.113 1.052-.378 1.765-.116-1.028.381-1.789z'
        fill='#02E8F4'
      />
      <path
        d='M21.875 16.755l1.747-.549-.086.692-1.741.522.08-.665z'
        fill='#94FF63'
      />
      <path
        d='M1.443 22.129l.22.701-.292-1.78-.232-.772.304 1.85z'
        fill='#1CFFDB'
      />
      <path d='M6.1 31.043l-.102-.078-.888-.776.052.034.939.82z' fill='#00F' />
      <path
        d='M19.686 18.567l2.098-.462.057.685-2.098.458-.056-.68z'
        fill='#66FF90'
      />
      <path
        d='M5.162 30.224l-.052-.034-.827-.986.004-.022.875 1.042z'
        fill='#0010FF'
      />
      <path
        d='M17.69 21.42l2.466-.56-.209-.619-2.472.551.214.628z'
        fill='#30FFC7'
      />
      <path
        d='M30.174 14.324l.88-1.046-.305-.622-.873 1.073.298.595z'
        fill='#E4FF13'
      />
      <path
        d='M10.761 3.346l-.105.58.874 1.437-.017-.587-.752-1.43z'
        fill='#E80000'
      />
      <path d='M9.939 2.17l-.24.58.957 1.175.105-.58L9.94 2.17z' fill='#B00' />
      <path
        d='M3.09 3.36l-.186 1.096 1.015-.819.145-1.075-.973.798z'
        fill='#D10000'
      />
      <path
        d='M26.353 12.757l.763-.952-.418.452-.749.9.404-.4z'
        fill='#FEED00'
      />
      <path
        d='M7.08 31.622l-.155-.11-.927-.547.103.078.98.579z'
        fill='#0000F1'
      />
      <path
        d='M12.934 8.855l.365.736.544 1.962-.418-.742-.491-1.956z'
        fill='#FF9F00'
      />
      <path
        d='M20.625 23.536l2.424-.595-.395.093-2.427.595.398-.093z'
        fill='#00D8FF'
      />
      <path
        d='M4.286 29.182l-.003.023-.747-1.171-.039-.09.79 1.238z'
        fill='#0038FF'
      />
      <path
        d='M10.266 31.669l-.235.119-.96.211.187-.108 1.008-.222z'
        fill='#0000E3'
      />
      <path
        d='M29.153 17.278l1.508-.839-.09-.742-1.506.874.088.707z'
        fill='#9DFF5A'
      />
      <path
        d='M17.474 20.793l2.473-.551-.151-.656-2.478.541.156.666z'
        fill='#43FFB4'
      />
      <path
        d='M29.876 13.73l.873-1.073-.365-.53-.864 1.09.356.512z'
        fill='#F4F802'
      />
      <path
        d='M23.926 22.256l2.322-.619.3-.455-2.34.636-.282.438z'
        fill='#1FFFD7'
      />
      <path
        d='M24.29 14.406l1.302-.749-.3.583-1.288.704.286-.538z'
        fill='#D7FF1F'
      />
      <path
        d='M16.489 23.905l2.516-.65-.381-.333-2.532.637.397.346z'
        fill='#00D8FF'
      />
      <path
        d='M26.98 20.053l1.998-.685.13-.673-2.006.713-.122.645z'
        fill='#56FFA0'
      />
      <path
        d='M16.093 23.56l2.531-.638-.352-.424-2.546.62.367.441z'
        fill='#00E4F8'
      />
      <path
        d='M26.794 12.466l.778-.998-.455.338-.764.952.44-.292z'
        fill='#FFDE00'
      />
      <path
        d='M19.695 17.89l2.1-.47-.011.684-2.098.463.009-.677z'
        fill='#7DFF7A'
      />
      <path
        d='M22.023 16.127l1.757-.578-.158.657-1.747.55.148-.629z'
        fill='#AAFF4D'
      />
      <path
        d='M8.079 31.944l-.21-.128-.944-.304.156.11.998.322z'
        fill='#0000E8'
      />
      <path
        d='M16.906 24.146l2.5-.66-.4-.232-2.517.65.417.242z'
        fill='#00D0FF'
      />
      <path
        d='M.715 17.44l.289.97.041-1.842-.289-1.027-.041 1.899z'
        fill='#94FF63'
      />
      <path
        d='M15.725 23.117l2.547-.62-.314-.505-2.56.6.327.525z'
        fill='#0CF4EB'
      />
      <path
        d='M21.003 23.336l2.42-.592-.373.199-2.424.594.377-.2z'
        fill='#00E4F8'
      />
      <path
        d='M14.67 16.592l.119 1.125-.005 2.014-.118-1.117.005-2.022z'
        fill='#83FF73'
      />
      <path
        d='M.822 9.662l.26 1.18.58-1.563-.254-1.2-.586 1.583z'
        fill='#FF9100'
      />
      <path
        d='M12.27 29.992l-.183.41-.87.768.15-.38.904-.798z'
        fill='#0008FF'
      />
      <path
        d='M29.521 13.217l.863-1.09-.414-.424-.852 1.1.403.414z'
        fill='#FFE600'
      />
      <path
        d='M17.331 24.278l2.486-.665-.411-.127-2.5.66.425.132z'
        fill='#0CF'
      />
      <path
        d='M14.322 24.474l.036.91-.538 1.55-.047-.875.549-1.585z'
        fill='#00A0FF'
      />
      <path
        d='M2.11 24.549l.14.446-.426-1.638-.162-.527.447 1.719z'
        fill='#0CF'
      />
      <path
        d='M27.258 12.29l.794-1.036-.48.214-.779.998.465-.176z'
        fill='#FFD300'
      />
      <path
        d='M3.498 27.942l.04.09-.648-1.33-.077-.167.685 1.407z'
        fill='#0064FF'
      />
      <path
        d='M15.398 22.593l2.56-.6-.268-.573-2.573.577.28.596z'
        fill='#1CFFDB'
      />
      <path
        d='M17.318 20.126l2.477-.54-.089-.678-2.481.531.093.687z'
        fill='#5AFF9D'
      />
      <path
        d='M6.6 1.08l-.344.857 1.16.195.225-.824-1.042-.228z'
        fill='maroon'
      />
      <path
        d='M29.065 16.571l1.507-.873-.164-.712-1.502.904.16.681z'
        fill='#B4FF43'
      />
      <path
        d='M29.118 12.803l.853-1.099-.453-.306-.84 1.098.44.307z'
        fill='#FFDB00'
      />
      <path
        d='M24.63 13.95l1.32-.792-.357.499-1.303.749.34-.456z'
        fill='#E7FF0F'
      />
      <path
        d='M27.736 12.236l.81-1.066-.494.084-.794 1.036.478-.054z'
        fill='#FFD000'
      />
      <path
        d='M17.757 24.297l2.47-.667-.41-.017-2.485.666.425.018z'
        fill='#00D0FF'
      />
      <path
        d='M24.208 21.817l2.34-.636.246-.533-2.354.652-.232.517z'
        fill='#30FFC7'
      />
      <path
        d='M28.679 12.496l.839-1.098-.48-.18-.824 1.088.465.19z'
        fill='#FFD000'
      />
      <path
        d='M28.214 12.305l.825-1.087-.493-.048-.81 1.066.478.07z'
        fill='#FC0'
      />
      <path
        d='M27.102 19.408l2.007-.712.059-.703-2.012.738-.053.677z'
        fill='#6DFF8A'
      />
      <path
        d='M19.769 17.236l2.107-.48-.08.665-2.1.47.073-.655z'
        fill='#94FF63'
      />
      <path
        d='M22.234 15.552l1.77-.609-.224.606-1.758.578.212-.575z'
        fill='#C1FF36'
      />
      <path
        d='M21.35 23.031l2.418-.588-.344.3-2.42.593.346-.305z'
        fill='#0CF4EB'
      />
      <path
        d='M15.117 21.996l2.573-.576-.215-.628-2.584.552.226.652z'
        fill='#2CFFCA'
      />
      <path
        d='M12.297 7.022l.295.736.707 1.834-.365-.736-.637-1.834z'
        fill='#FF6000'
      />
      <path
        d='M13.842 11.553l.256.944.382 2.037-.27-.946-.368-2.035z'
        fill='#FFE600'
      />
      <path d='M9.07 32l-.265-.131-.937-.054.21.128.992.057z' fill='#0000ED' />
      <path
        d='M1.138 20.278l.232.773-.128-1.797-.238-.845.134 1.87z'
        fill='#56FFA0'
      />
      <path
        d='M17.225 19.439l2.482-.531-.024-.681-2.486.52.028.692z'
        fill='#6DFF8A'
      />
      <path
        d='M18.169 24.201l2.456-.664-.399.093-2.47.667.413-.096z'
        fill='#00D4FF'
      />
      <path
        d='M2.012 5.57l.143 1.145.892-1.106-.143-1.152-.892 1.112z'
        fill='#FF1A00'
      />
      <path
        d='M28.907 15.89l1.502-.904-.234-.662-1.494.927.226.638z'
        fill='#CAFF2C'
      />
      <path
        d='M5.998 30.964l-.1-.296-.832-.727.045.248.887.775z'
        fill='#000CFF'
      />
      <path d='M11.217 31.17l-.28.142-.906.476.235-.119.95-.5z' fill='#00F' />
      <path
        d='M14.05 24.621l2.439-.716-.397-.345-2.463.694.421.367z'
        fill='#00D0FF'
      />
      <path
        d='M13.629 24.253l2.463-.694-.367-.44-2.487.666.39.468z'
        fill='#00DCFE'
      />
      <path
        d='M5.11 30.19l-.044-.247-.775-.924-.008.187.827.985z'
        fill='#0028FF'
      />
      <path
        d='M25.015 13.59l1.338-.832-.404.4-1.32.793.386-.36z'
        fill='#F8F500'
      />
      <path
        d='M4.064 2.562l-.145 1.076 1.11-.5.1-1.056-1.065.48z'
        fill='#A40000'
      />
      <path
        d='M14.493 24.879l2.413-.73-.417-.243-2.438.716.442.257z'
        fill='#00C8FF'
      />
      <path
        d='M13.82 26.934l-.083.703-.669 1.296.064-.662.689-1.337z'
        fill='#0064FF'
      />
      <path
        d='M.675 12.578l.303 1.141.4-1.697-.296-1.18-.407 1.736z'
        fill='gold'
      />
      <path
        d='M2.813 26.536l.077.167-.532-1.456-.108-.252.563 1.541z'
        fill='#0098FF'
      />
      <path
        d='M14.891 21.344l2.584-.552-.156-.666-2.593.525.165.693z'
        fill='#43FFB4'
      />
      <path
        d='M13.238 23.786l2.487-.667-.328-.525-2.508.634.35.558z'
        fill='#06ECF1'
      />
      <path d='M6.925 31.511l-.158-.331-.869-.512.1.297.927.546z' fill='#00F' />
      <path
        d='M24.44 21.3l2.354-.65.186-.597-2.366.665-.175.583z'
        fill='#43FFB4'
      />
      <path
        d='M27.157 18.73l2.012-.738-.015-.715-2.013.76.016.693z'
        fill='#83FF73'
      />
      <path
        d='M7.642 1.308l-.225.823 1.16.533.107-.795-1.042-.561z'
        fill='#840000'
      />
      <path
        d='M21.656 22.631l2.416-.582-.305.395-2.417.587.306-.4z'
        fill='#19FFDE'
      />
      <path
        d='M14.784 19.731l.11 1.078-.195 1.9-.112-1.052.197-1.926z'
        fill='#40FFB7'
      />
      <path
        d='M14.944 25.019l2.387-.74-.426-.131-2.413.73.451.14z'
        fill='#00C4FF'
      />
      <path
        d='M22.504 15.046l1.786-.64-.285.538-1.77.609.27-.507z'
        fill='#D4FF23'
      />
      <path
        d='M19.906 16.62l2.117-.493-.148.628-2.106.48.137-.615z'
        fill='#AAFF4D'
      />
      <path
        d='M4.283 29.205l.008-.186-.7-1.098-.054.112.746 1.172z'
        fill='#004CFF'
      />
      <path
        d='M18.56 23.992l2.443-.656-.377.201-2.457.664.39-.209z'
        fill='#00E0FB'
      />
      <path
        d='M12.89 23.227l2.508-.634-.28-.597-2.528.598.3.633z'
        fill='#16FFE1'
      />
      <path
        d='M28.68 15.252l1.494-.928-.298-.595-1.484.945.288.578z'
        fill='#DEFF19'
      />
      <path
        d='M11.53 5.363l.212.742.85 1.653-.296-.736-.766-1.659z'
        fill='#FF2900'
      />
      <path
        d='M25.435 13.334l1.358-.87-.44.293-1.338.833.42-.256z'
        fill='#FFEA00'
      />
      <path
        d='M17.197 18.747l2.486-.52.04-.668-2.488.51-.038.678z'
        fill='#83FF73'
      />
      <path
        d='M1.662 22.83l.162.527-.278-1.696-.176-.61.292 1.78z'
        fill='#1FFFD7'
      />
      <path d='M7.868 31.815l-.218-.35-.883-.285.158.33.943.305z' fill='#00F' />
      <path
        d='M15.393 25.038l2.363-.742-.425-.018-2.388.74.45.02z'
        fill='#00C4FF'
      />
      <path
        d='M14.726 20.651l2.593-.525-.094-.688-2.6.498.1.715z'
        fill='#56FFA0'
      />
      <path d='M10.031 31.788l-.319-.12-.907.2.265.131.961-.211z' fill='#00F' />
      <path
        d='M12.59 22.594l2.526-.598-.226-.652-2.543.557.242.693z'
        fill='#29FFCE'
      />
      <path
        d='M28.392 14.674l1.484-.944-.355-.512-1.471.955.342.501z'
        fill='#EEFF09'
      />
      <path
        d='M8.684 1.87l-.107.794 1.129.857-.008-.771-1.014-.88z'
        fill='#920000'
      />
      <path
        d='M13.068 28.934l-.214.451-.767 1.018.184-.41.797-1.06z'
        fill='#0038FF'
      />
      <path
        d='M25.88 13.189l1.378-.9-.465.176-1.357.868.444-.144z'
        fill='#FFDE00'
      />
      <path
        d='M27.14 18.038l2.014-.76-.088-.708-2.011.78.086.688z'
        fill='#9AFF5D'
      />
      <path
        d='M3.537 28.032l.055-.112-.607-1.246-.095.029.647 1.33z'
        fill='#0074FF'
      />
      <path
        d='M24.615 20.718l2.366-.665.122-.645-2.374.676-.114.634z'
        fill='#5AFF9D'
      />
      <path
        d='M11.822 25.398l2.229-.778-.422-.367-2.262.748.455.396z'
        fill='#00C4FF'
      />
      <path
        d='M11.366 25.002l2.262-.748-.39-.469-2.294.711.422.506z'
        fill='#00D0FF'
      />
      <path
        d='M.756 15.54l.289 1.028.217-1.766-.284-1.083-.222 1.822z'
        fill='#D1FF26'
      />
      <path
        d='M22.825 14.621l1.805-.67-.34.455-1.786.64.321-.425z'
        fill='#E4FF13'
      />
      <path
        d='M10.656 3.926l.115.754.97 1.425-.21-.742-.875-1.437z'
        fill='#DF0000'
      />
      <path
        d='M21.916 22.144l2.415-.576-.258.48-2.416.582.259-.486z'
        fill='#29FFCE'
      />
      <path
        d='M14.48 14.535l.12 1.134.189 2.049-.118-1.125-.19-2.058z'
        fill='#C4FF33'
      />
      <path
        d='M12.297 25.676l2.195-.798-.442-.257-2.229.777.476.278z'
        fill='#00BCFF'
      />
      <path
        d='M18.916 23.676l2.433-.645-.346.305-2.444.656.357-.316z'
        fill='#09F0EE'
      />
      <path
        d='M20.104 16.06l2.13-.507-.21.575-2.118.493.198-.56z'
        fill='#BEFF39'
      />
      <path
        d='M9.698 2.75l.008.772 1.064 1.157-.114-.754-.958-1.175z'
        fill='#B20000'
      />
      <path d='M15.83 24.937l2.34-.736-.413.097-2.363.74.436-.1z' fill='#0CF' />
      <path
        d='M10.945 24.495l2.293-.71-.35-.558-2.322.667.379.602z'
        fill='#00E0FB'
      />
      <path
        d='M28.05 14.173l1.47-.955-.402-.415-1.456.958.387.412z'
        fill='#FBF100'
      />
      <path
        d='M1.408 8.08l.255 1.2.74-1.344-.247-1.221-.748 1.364z'
        fill='#FF5200'
      />
      <path
        d='M26.338 13.161l1.399-.925-.478.054-1.378.9.457-.029z'
        fill='#FFDB00'
      />
      <path
        d='M13.298 9.59l.235.947.565 1.96-.256-.944-.544-1.962z'
        fill='#FF9F00'
      />
      <path
        d='M2.25 24.995l.108.253-.402-1.548-.132-.343.426 1.639z'
        fill='#00D4FF'
      />
      <path
        d='M5.897 30.668l-.016-.488-.773-.675-.043.436.832.727z'
        fill='#0028FF'
      />
      <path
        d='M12.783 25.827l2.16-.81-.451-.14-2.195.798.486.152z'
        fill='#00B8FF'
      />
      <path
        d='M17.235 18.07l2.489-.511.106-.637-2.49.501-.105.647z'
        fill='#9AFF5D'
      />
      <path
        d='M14.699 22.709l.029.948-.37 1.727-.037-.91.378-1.765z'
        fill='#02E8F4'
      />
      <path
        d='M5.066 29.941l.042-.436-.72-.858-.097.371.775.923z'
        fill='#0040FF'
      />
      <path
        d='M14.625 19.937l2.6-.498-.028-.691-2.605.47.033.72z'
        fill='#6DFF8A'
      />
      <path
        d='M12.347 21.9l2.543-.557-.165-.693-2.557.515.179.735z'
        fill='#40FFB7'
      />
      <path
        d='M27.663 13.761l1.456-.958-.44-.307-1.438.955.422.31z'
        fill='#FFE600'
      />
      <path
        d='M26.796 13.249l1.418-.943-.477-.07-1.4.925.459.088z'
        fill='gold'
      />
      <path
        d='M8.804 31.869l-.277-.355-.878-.05.218.351.937.054z'
        fill='#00F'
      />
      <path
        d='M27.24 13.45l1.439-.955-.465-.19-1.42.943.447.202z'
        fill='#FFDB00'
      />
      <path
        d='M10.567 23.894l2.322-.667-.3-.633-2.348.617.326.683z'
        fill='#0FF8E7'
      />
      <path
        d='M6.767 31.18l-.078-.524-.807-.475.016.488.869.511z'
        fill='#0018FF'
      />
      <path
        d='M5.129 2.082l-.1 1.055 1.176-.165.051-1.035-1.127.145z'
        fill='#890000'
      />
      <path
        d='M12.088 30.404l-.32.178-.83.731.28-.142.87-.767z'
        fill='#0018FF'
      />
      <path
        d='M27.053 17.35l2.012-.78-.16-.681-2.006.794.154.667z'
        fill='#B1FF46'
      />
      <path
        d='M23.19 14.29l1.825-.7-.385.36-1.805.67.365-.33z'
        fill='#F1FC06'
      />
      <path
        d='M4.291 29.019l.097-.372-.65-1.02-.146.294.7 1.098z'
        fill='#0060FF'
      />
      <path
        d='M24.729 20.084l2.374-.676.054-.678-2.38.685-.049.669z'
        fill='#6DFF8A'
      />
      <path
        d='M13.266 25.849l2.127-.812-.45-.02-2.16.81.483.022z'
        fill='#00B8FF'
      />
      <path
        d='M1.004 18.41l.238.845.04-1.77-.237-.917-.041 1.841z'
        fill='#94FF63'
      />
      <path
        d='M16.24 24.715l2.32-.724-.39.209-2.34.736.41-.221z'
        fill='#00D8FF'
      />
      <path
        d='M9.903 26.226l1.918-.828-.455-.396-1.959.792.496.432z'
        fill='#00B4FF'
      />
      <path
        d='M22.119 21.585l2.416-.567-.204.552-2.416.575.204-.56z'
        fill='#3CFFBA'
      />
      <path
        d='M19.233 23.26l2.424-.63-.307.401-2.433.645.316-.416z'
        fill='#16FFE1'
      />
      <path
        d='M9.408 25.793l1.959-.792-.422-.505-1.998.747.46.55z'
        fill='#00C0FF'
      />
      <path
        d='M2.89 26.704l.096-.029-.498-1.364-.13-.063.532 1.456z'
        fill='#00A8FF'
      />
      <path
        d='M20.357 15.57l2.147-.525-.27.507-2.13.507.253-.49z'
        fill='#D1FF26'
      />
      <path
        d='M2.905 4.457l.143 1.152 1.013-.813-.141-1.158-1.015.819z'
        fill='#D10000'
      />
      <path
        d='M10.422 26.53l1.876-.854-.476-.278-1.919.828.519.303z'
        fill='#00A8FF'
      />
      <path
        d='M10.242 23.211l2.347-.618-.242-.693-2.37.564.264.747z'
        fill='#23FFD4'
      />
      <path
        d='M7.65 31.465l-.14-.545-.822-.264.078.525.884.284z'
        fill='#0010FF'
      />
      <path
        d='M8.947 25.243l1.998-.747-.379-.601-2.033.692.414.656z'
        fill='#00D4FF'
      />
      <path
        d='M12.169 21.166l2.557-.515-.1-.715-2.567.471.11.76z'
        fill='#56FFA0'
      />
      <path
        d='M10.938 31.313l-.37-.094-.855.45.319.12.906-.476z'
        fill='#0008FF'
      />
      <path
        d='M14.592 19.217l2.605-.47.038-.678-2.607.444-.036.704z'
        fill='#83FF73'
      />
      <path
        d='M17.339 17.423l2.49-.501.168-.59-2.49.492-.168.599z'
        fill='#B1FF46'
      />
      <path
        d='M26.9 16.685l2.006-.795-.227-.638-1.997.806.218.627z'
        fill='#C4FF33'
      />
      <path
        d='M10.95 26.695l1.833-.867-.485-.152-1.876.853.528.166z'
        fill='#00A8FF'
      />
      <path d='M23.59 14.06l1.846-.726-.42.256-1.826.7.4-.23z' fill='#FEED00' />
      <path
        d='M14.357 25.384l-.099.75-.522 1.503.084-.703.537-1.55z'
        fill='#00A8FF'
      />
      <path
        d='M13.734 25.741l2.094-.805-.436.102-2.126.812.468-.109z'
        fill='#00C0FF'
      />
      <path
        d='M5.881 30.18l.158-.643-.713-.623-.218.591.773.675z'
        fill='#0040FF'
      />
      <path
        d='M3.592 27.921l.146-.294-.563-1.158-.19.206.607 1.246z'
        fill='#08F'
      />
      <path
        d='M1.37 21.05l.175.611-.121-1.711-.183-.696.128 1.796z'
        fill='#5AFF9D'
      />
      <path
        d='M5.108 29.505l.218-.591-.664-.792-.274.525.72.858z'
        fill='#0058FF'
      />
      <path
        d='M1.083 10.841l.297 1.18.57-1.526-.287-1.216-.58 1.562z'
        fill='#FF9400'
      />
      <path
        d='M8.533 24.587l2.033-.692-.325-.683-2.064.631.356.744z'
        fill='#06ECF1'
      />
      <path
        d='M8.36 27.085l1.543-.859-.495-.432-1.59.817.543.474z'
        fill='#00A0FF'
      />
      <path
        d='M16.618 24.38l2.3-.704-.358.316-2.319.724.377-.335z'
        fill='#02E8F4'
      />
      <path
        d='M7.818 26.61l1.59-.817-.46-.55-1.636.764.506.603z'
        fill='#00B0FF'
      />
      <path
        d='M14.79 17.717l.11 1.103-.005 1.988-.11-1.077.004-2.014z'
        fill='#83FF73'
      />
      <path
        d='M6.688 30.656l.095-.68-.744-.439-.158.644.807.475z'
        fill='#0034FF'
      />
      <path
        d='M24.777 19.415l2.38-.684-.017-.692-2.381.69.018.686z'
        fill='#83FF73'
      />
      <path
        d='M9.713 31.669l-.336-.343-.85.188.278.355.908-.2z'
        fill='#0008FF'
      />
      <path
        d='M9.977 22.465l2.37-.564-.179-.735-2.387.506.196.793z'
        fill='#39FFBE'
      />
      <path
        d='M12.592 7.758l.207.952.735 1.828-.236-.947-.706-1.833z'
        fill='#FF6000'
      />
      <path
        d='M8.928 27.418l1.494-.89-.519-.302-1.543.859.568.332z'
        fill='#0094FF'
      />
      <path
        d='M20.66 15.163l2.166-.542-.322.425-2.147.524.303-.407z'
        fill='#E1FF16'
      />
      <path
        d='M19.498 22.755l2.417-.61-.258.486-2.425.63.266-.506z'
        fill='#29FFCE'
      />
      <path
        d='M22.263 20.965l2.417-.559-.145.61-2.416.568.144-.62z'
        fill='#53FFA4'
      />
      <path
        d='M4.388 28.647l.274-.525-.6-.941-.324.446.65 1.02z'
        fill='#0074FF'
      />
      <path
        d='M11.475 26.72l1.791-.87-.483-.023-1.833.868.525.025z'
        fill='#00A8FF'
      />
      <path
        d='M26.682 16.057l1.998-.806-.288-.577-1.986.812.276.57z'
        fill='#D7FF1F'
      />
      <path
        d='M7.312 26.006l1.635-.765-.413-.655-1.677.702.455.718z'
        fill='#00C4FF'
      />
      <path
        d='M24.011 13.94l1.869-.75-.445.144-1.846.726.422-.12z'
        fill='#FFE600'
      />
      <path
        d='M1.824 23.357l.131.342-.262-1.6-.147-.438.278 1.696z'
        fill='#26FFD1'
      />
      <path
        d='M8.528 31.514l-.203-.55-.815-.044.14.545.878.05z'
        fill='#0014FF'
      />
      <path
        d='M12.058 20.407l2.567-.471-.033-.72-2.572.427.038.764z'
        fill='#6DFF8A'
      />
      <path
        d='M6.257 1.936L6.205 2.97l1.209.176.003-1.016-1.16-.195z'
        fill='maroon'
      />
      <path
        d='M6.04 29.536l.42-.758-.654-.571-.48.706.713.623z'
        fill='#005CFF'
      />
      <path
        d='M7.218 27.948l1.143-.863-.544-.474-1.196.816.597.521z'
        fill='#008CFF'
      />
      <path
        d='M5.326 28.913l.48-.707-.608-.726-.536.641.664.792z'
        fill='#0070FF'
      />
      <path
        d='M8.177 23.843l2.064-.631-.264-.747-2.09.564.29.814z'
        fill='#1CFFDB'
      />
      <path
        d='M6.62 27.427l1.197-.816-.506-.604-1.246.757.556.663z'
        fill='#009CFF'
      />
      <path
        d='M9.506 27.6l1.443-.905-.528-.166-1.493.889.578.183z'
        fill='#0094FF'
      />
      <path
        d='M7.51 30.92l.031-.703-.757-.242-.096.68.822.264z'
        fill='#002CFF'
      />
      <path
        d='M14.099 12.498l.12 1.141.38 2.03-.119-1.134-.381-2.037z'
        fill='#FFE600'
      />
      <path
        d='M14.176 25.503l2.065-.788-.412.22-2.095.805.442-.237z'
        fill='#0CF'
      />
      <path
        d='M13.736 27.638l-.24.502-.643 1.246.215-.452.668-1.296z'
        fill='#0070FF'
      />
      <path
        d='M14.628 18.512l2.607-.443.104-.646-2.607.417-.104.672z'
        fill='#9AFF5D'
      />
      <path
        d='M17.506 16.824l2.491-.492.227-.527-2.492.484-.226.535z'
        fill='#C4FF33'
      />
      <path
        d='M6.46 28.778l.758-.83-.597-.521-.814.78.653.571z'
        fill='#0074FF'
      />
      <path
        d='M7.84 28.313l1.088-.895-.568-.333-1.143.862.623.366z'
        fill='#0080FF'
      />
      <path
        d='M6.783 29.974l.36-.795-.683-.402-.42.759.743.438z'
        fill='#004CFF'
      />
      <path
        d='M2.358 25.247l.129.063-.377-1.45-.155-.16.403 1.547z'
        fill='#00E0FB'
      />
      <path
        d='M26.407 15.486l1.985-.812-.342-.501-1.97.813.327.5z'
        fill='#E7FF0F'
      />
      <path
        d='M5.807 28.207l.815-.78-.556-.663-.868.717.609.726z'
        fill='#0084FF'
      />
      <path
        d='M24.446 13.932l1.891-.772-.457.03-1.868.75.434-.008z'
        fill='#FFE200'
      />
      <path
        d='M6.856 25.29l1.677-.702-.357-.744-1.712.63.392.815z'
        fill='#00E0FB'
      />
      <path
        d='M6.066 26.765l1.245-.758-.454-.718-1.292.687.5.789z'
        fill='#00B4FF'
      />
      <path
        d='M4.663 28.122l.535-.64-.548-.864-.587.563.6.941z'
        fill='#008CFF'
      />
      <path
        d='M2.985 26.675l.19-.206-.462-1.268-.226.11.498 1.364z'
        fill='#00B4FF'
      />
      <path
        d='M7.142 29.18l.699-.867-.623-.366-.758.83.682.402z'
        fill='#0068FF'
      />
      <path
        d='M24.759 18.729l2.381-.69-.086-.688-2.38.692.085.686z'
        fill='#9AFF5D'
      />
      <path
        d='M3.738 27.627l.325-.446-.52-1.069-.368.357.563 1.158z'
        fill='#009CFF'
      />
      <path
        d='M16.95 23.94l2.282-.68-.315.415-2.3.706.332-.441z'
        fill='#13FCE4'
      />
      <path
        d='M11.984 26.602l1.75-.862-.467.11-1.791.87.508-.118z'
        fill='#00B0FF'
      />
      <path
        d='M.98 13.719l.283 1.083.39-1.644-.273-1.136-.4 1.697z'
        fill='#FFDB00'
      />
      <path
        d='M9.782 21.67l2.386-.505-.11-.759-2.399.447.123.818z'
        fill='#53FFA4'
      />
      <path
        d='M21.004 14.85l2.186-.56-.364.331-2.166.542.344-.313z'
        fill='#EEFF09'
      />
      <path
        d='M26.079 14.987l1.971-.814-.387-.411-1.954.81.37.415z'
        fill='#F4F802'
      />
      <path
        d='M5.198 27.481l.868-.717-.5-.788-.917.642.55.863z'
        fill='#00A0FF'
      />
      <path
        d='M24.882 14.037l1.913-.79-.458-.087-1.89.772.435.105z'
        fill='#FFE200'
      />
      <path
        d='M8.475 28.515l1.032-.914-.578-.183-1.088.896.634.201z'
        fill='#007CFF'
      />
      <path
        d='M10.081 27.629l1.394-.909-.525-.025-1.443.906.574.028z'
        fill='#0094FF'
      />
      <path
        d='M12.854 29.386l-.356.226-.73.97.32-.178.767-1.018z'
        fill='#04F'
      />
      <path
        d='M2.156 6.715l.248 1.22.883-1.088-.24-1.238-.89 1.106z'
        fill='#FF1E00'
      />
      <path
        d='M22.342 20.3l2.419-.548-.081.654-2.417.558.079-.663z'
        fill='#66FF90'
      />
      <path
        d='M7.54 30.218l.296-.817-.694-.221-.359.795.758.243z'
        fill='#0048FF'
      />
      <path
        d='M25.708 14.571l1.954-.81-.422-.31-1.934.801.402.32z'
        fill='#FEED00'
      />
      <path
        d='M19.706 22.172l2.413-.588-.204.56-2.417.61.208-.582z'
        fill='#3CFFBA'
      />
      <path
        d='M25.306 14.252l1.935-.802-.446-.202-1.913.79.424.214z'
        fill='#FFE200'
      />
      <path
        d='M7.886 23.029l2.09-.564-.195-.793-2.111.493.216.864z'
        fill='#36FFC1'
      />
      <path
        d='M7.837 29.4l.638-.886-.634-.201-.698.866.694.221z'
        fill='#0064FF'
      />
      <path
        d='M5.565 25.976l1.292-.687-.393-.815-1.331.607.432.895z'
        fill='#00D0FF'
      />
      <path
        d='M11.742 6.104l.174.96.884 1.645-.208-.951-.85-1.654z'
        fill='#FF2900'
      />
      <path
        d='M12.02 19.644l2.572-.426.036-.705-2.574.382-.034.749z'
        fill='#87FF70'
      />
      <path
        d='M8.325 30.964l-.032-.707-.752-.04-.031.702.815.045z'
        fill='#0030FF'
      />
      <path
        d='M6.465 24.473l1.712-.63-.29-.815-1.742.553.32.892z'
        fill='#13FCE4'
      />
      <path
        d='M14.895 20.809l.025.99-.192 1.859-.029-.949.196-1.9z'
        fill='#43FFB4'
      />
      <path
        d='M4.063 27.181l.586-.562-.475-.98-.63.474.519 1.068z'
        fill='#00ACFF'
      />
      <path
        d='M11.768 30.581l-.417-.054-.782.691.37.094.829-.73z'
        fill='#002CFF'
      />
      <path
        d='M3.919 3.637l.14 1.158 1.11-.495-.14-1.162-1.109.5z'
        fill='#A80000'
      />
      <path
        d='M14.58 25.143l2.037-.762-.377.335-2.064.788.403-.36z'
        fill='#00DCFE'
      />
      <path
        d='M7.417 2.13l-.003 1.017 1.209.516-.045-1-1.16-.532z'
        fill='maroon'
      />
      <path
        d='M9.378 31.326l-.264-.537-.789.176.203.55.85-.189z'
        fill='#0020FF'
      />
      <path
        d='M17.732 16.29l2.492-.484.279-.45-2.49.477-.28.457z'
        fill='#D7FF1F'
      />
      <path
        d='M4.649 26.617l.917-.642-.433-.895-.96.557.476.98z'
        fill='#00C0FF'
      />
      <path
        d='M10.57 31.217l-.391-.315-.801.423.335.342.856-.45z'
        fill='#0020FF'
      />
      <path
        d='M14.732 17.84l2.608-.417.167-.599-2.605.394-.17.622zm9.943.203l2.379-.693-.154-.666-2.374.692.149.667z'
        fill='#B1FF46'
      />
      <path
        d='M1.045 16.568l.237.918.21-1.696-.23-.987-.217 1.765z'
        fill='#CEFF29'
      />
      <path
        d='M9.104 28.547l.977-.918-.574-.028-1.032.914.63.032z'
        fill='#007CFF'
      />
      <path
        d='M21.38 14.64l2.209-.58-.399.23-2.186.56.377-.21z'
        fill='#FBF100'
      />
      <path
        d='M12.463 26.344l1.713-.841-.442.237-1.75.862.479-.258z'
        fill='#00BCFF'
      />
      <path
        d='M3.175 26.468l.369-.356-.426-1.17-.405.259.462 1.267z'
        fill='#00C4FF'
      />
      <path
        d='M10.637 27.501l1.347-.899-.509.118-1.394.909.556-.128z'
        fill='#009CFF'
      />
      <path
        d='M9.659 20.854l2.399-.446-.039-.764-2.406.387.046.823z'
        fill='#6DFF8A'
      />
      <path
        d='M8.293 30.258l.233-.82-.69-.037-.295.817.752.04z'
        fill='#004CFF'
      />
      <path
        d='M17.228 23.404l2.27-.65-.266.506-2.283.68.279-.536z'
        fill='#23FFD4'
      />
      <path
        d='M8.526 29.437l.578-.89-.63-.032-.637.886.69.036z'
        fill='#0064FF'
      />
      <path
        d='M5.133 25.081l1.331-.608-.32-.892-1.365.521.354.979z'
        fill='#09F0EE'
      />
      <path
        d='M10.77 4.68l.135.97 1.01 1.415-.173-.96-.972-1.425z'
        fill='#DF0000'
      />
      <path
        d='M22.353 19.61l2.423-.538-.016.68-2.42.549.013-.69z'
        fill='#7DFF7A'
      />
      <path
        d='M2.487 25.31l.226-.11-.35-1.346-.253.006.377 1.45z'
        fill='#02E8F4'
      />
      <path
        d='M1.242 19.254l.183.696.039-1.684-.181-.78-.04 1.768z'
        fill='#94FF63'
      />
      <path
        d='M8.577 2.664l.045.999 1.175.842-.091-.984-1.129-.857z'
        fill='#920000'
      />
      <path
        d='M19.852 21.529l2.41-.564-.143.62-2.413.588.146-.644zm-12.182.636l2.111-.493-.122-.819-2.126.42.137.892z'
        fill='#50FFA7'
      />
      <path
        d='M6.144 23.581l1.743-.552-.217-.864-1.766.47.24.946z'
        fill='#30FFC7'
      />
      <path
        d='M24.527 17.376l2.374-.692-.218-.627-2.365.688.21.63z'
        fill='#C4FF33'
      />
      <path
        d='M1.955 23.7l.155.161-.245-1.5-.173-.262.263 1.6z'
        fill='#2CFFCA'
      />
      <path
        d='M3.544 26.113l.63-.474-.39-1.073-.666.377.426 1.17z'
        fill='#00D4FF'
      />
      <path
        d='M1.547 21.662l.147.437-.115-1.615-.154-.533.122 1.711z'
        fill='#5AFF9D'
      />
      <path
        d='M9.706 3.521l.091.984 1.108 1.144-.134-.97-1.065-1.158z'
        fill='#B20000'
      />
      <path
        d='M4.174 25.638l.96-.557-.354-.98-.995.464.39 1.073z'
        fill='#00E4F8'
      />
      <path
        d='M21.78 14.538l2.232-.598-.423.12-2.208.58.4-.102z'
        fill='#FFEA00'
      />
      <path
        d='M12.054 18.895l2.574-.383.104-.672-2.572.341-.106.714z'
        fill='#9DFF5A'
      />
      <path
        d='M18.013 15.833l2.49-.478.325-.36-2.489.472-.326.366z'
        fill='#E7FF0F'
      />
      <path
        d='M14.934 24.668l2.015-.729-.332.441-2.038.763.355-.475z'
        fill='#09F0EE'
      />
      <path
        d='M14.729 23.657l-.11.804-.36 1.673.1-.75.37-1.727z'
        fill='#06ECF1'
      />
      <path
        d='M9.114 30.789l-.094-.694-.727.163.032.707.789-.176z'
        fill='#003CFF'
      />
      <path d='M9.714 28.407l.923-.907-.556.128-.977.918.61-.14z' fill='#08F' />
      <path
        d='M14.6 15.668l.113 1.13.187 2.023-.111-1.104-.19-2.049z'
        fill='#C4FF33'
      />
      <path
        d='M13.533 10.537l.122 1.149.564 1.953-.12-1.142-.566-1.96z'
        fill='#FF9F00'
      />
      <path
        d='M14.901 17.218l2.605-.393.226-.535-2.599.372-.232.556z'
        fill='#C7FF30'
      />
      <path
        d='M1.663 9.28l.287 1.216.727-1.313-.273-1.247-.74 1.344z'
        fill='#FF5900'
      />
      <path
        d='M12.9 25.953l1.68-.81-.404.36-1.713.841.437-.392z'
        fill='#00D0FF'
      />
      <path
        d='M24.317 16.746l2.365-.689-.276-.57-2.352.682.264.577z'
        fill='#D7FF1F'
      />
      <path
        d='M11.16 27.22l1.303-.875-.48.257-1.346.899.523-.281z'
        fill='#00ACFF'
      />
      <path
        d='M22.192 14.549l2.254-.616-.434.008-2.232.597.412.01z'
        fill='#FFE600'
      />
      <path
        d='M9.193 29.286l.52-.879-.608.14-.579.89.667-.151z'
        fill='#0070FF'
      />
      <path
        d='M9.02 30.096l.173-.809-.667.151-.233.82.727-.162z'
        fill='#0054FF'
      />
      <path
        d='M9.613 20.03l2.406-.386.034-.748-2.407.327-.033.807z'
        fill='#87FF70'
      />
      <path
        d='M22.298 18.913l2.426-.528.051.688-2.422.538-.055-.698z'
        fill='#94FF63'
      />
      <path
        d='M4.78 24.102l1.364-.52-.24-.947-1.39.428.266 1.04z'
        fill='#26FFD1'
      />
      <path
        d='M17.445 22.786l2.261-.614-.208.582-2.27.65.217-.618z'
        fill='#39FFBE'
      />
      <path
        d='M10.179 30.903l-.322-.508-.743.393.264.537.8-.422z'
        fill='#0038FF'
      />
      <path
        d='M2.713 25.201l.405-.258-.321-1.242-.434.154.35 1.346z'
        fill='#0CF4EB'
      />
      <path
        d='M19.931 20.84l2.41-.538-.078.663-2.41.564.078-.69z'
        fill='#66FF90'
      />
      <path
        d='M14.258 26.135l-.26.56-.502 1.445.24-.502.522-1.503z'
        fill='#00B0FF'
      />
      <path
        d='M24.054 16.169l2.353-.683-.328-.5-2.337.674.312.509z'
        fill='#E4FF13'
      />
      <path
        d='M7.534 21.272l2.125-.42-.045-.823-2.134.345.054.898z'
        fill='#6AFF8D'
      />
      <path
        d='M22.604 14.67l2.277-.633-.435-.104-2.255.616.413.121z'
        fill='#FFE600'
      />
      <path
        d='M5.904 22.634l1.766-.47-.137-.892-1.782.384.153.978z'
        fill='#49FFAD'
      />
      <path
        d='M18.339 15.467l2.488-.472.362-.263-2.486.47-.364.265z'
        fill='#F4F802'
      />
      <path
        d='M5.03 3.136L5.167 4.3l1.174-.163-.137-1.165-1.176.165z'
        fill='#8D0000'
      />
      <path
        d='M11.351 30.528l-.44-.272-.732.648.39.315.782-.691z'
        fill='#0040FF'
      />
      <path
        d='M3.785 24.566l.995-.464-.266-1.04-1.022.365.293 1.139z'
        fill='#1FFFD7'
      />
      <path
        d='M3.118 24.943l.667-.377-.293-1.138-.695.273.321 1.242z'
        fill='#16FFE1'
      />
      <path
        d='M23.742 15.66l2.337-.674-.37-.415-2.32.662.353.427z'
        fill='#F1FC06'
      />
      <path
        d='M12.16 18.182l2.572-.34.17-.623-2.566.302-.176.661z'
        fill='#B4FF43'
      />
      <path
        d='M23.007 14.9l2.298-.648-.424-.215-2.277.633.403.23z'
        fill='#FFE600'
      />
      <path
        d='M13.497 28.14l-.388.286-.612 1.186.357-.226.643-1.245z'
        fill='#007CFF'
      />
      <path
        d='M23.39 15.233l2.32-.662-.403-.319-2.3.648.383.333z'
        fill='#FEED00'
      />
      <path
        d='M15.232 24.091l1.996-.687-.279.536-2.014.729.297-.578z'
        fill='#1CFFDB'
      />
      <path d='M12.498 29.612h-.458l-.688.916.415.054.73-.97z' fill='#0054FF' />
      <path
        d='M3.047 5.608l.239 1.238 1.003-.8-.23-1.251-1.012.813z'
        fill='#D60000'
      />
      <path
        d='M10.287 28.1l.874-.88-.524.28-.923.908.573-.308z'
        fill='#0098FF'
      />
      <path
        d='M15.134 16.663l2.599-.372.28-.457-2.592.354-.287.475z'
        fill='#D7FF1F'
      />
      <path
        d='M1.379 12.022l.273 1.137.555-1.478-.258-1.185-.57 1.526z'
        fill='#FF9C00'
      />
      <path
        d='M2.11 23.86l.253-.006-.227-1.393-.27-.1.245 1.5z'
        fill='#30FFC7'
      />
      <path
        d='M22.178 18.224l2.43-.518.117.678-2.426.529-.121-.69z'
        fill='#AAFF4D'
      />
      <path
        d='M9.856 30.395l-.152-.665-.684.365.093.694.743-.394z'
        fill='#0050FF'
      />
      <path
        d='M13.285 25.436l1.65-.768-.355.475-1.68.81.385-.517z'
        fill='#00E4F8'
      />
      <path
        d='M11.639 26.792l1.262-.839-.438.392-1.302.875.478-.428z'
        fill='#00C0FF'
      />
      <path
        d='M18.703 15.2l2.486-.47.389-.156-2.482.467-.393.159z'
        fill='#FEED00'
      />
      <path
        d='M9.646 19.223l2.407-.327.106-.714-2.403.27-.11.77z'
        fill='#A0FF56'
      />
      <path
        d='M17.596 22.104l2.256-.575-.146.645-2.26.613.15-.683z'
        fill='#50FFA7'
      />
      <path
        d='M9.821 28.951l.466-.85-.573.307-.52.878.627-.335z'
        fill='#0080FF'
      />
      <path
        d='M4.514 23.063l1.39-.429-.153-.978-1.408.333.17 1.074z'
        fill='#46FFB1'
      />
      <path
        d='M14.9 18.82l.025 1.034-.005 1.944-.025-.99.005-1.988z'
        fill='#83FF73'
      />
      <path
        d='M19.94 20.121l2.414-.51-.012.69-2.411.538.009-.718z'
        fill='#7DFF7A'
      />
      <path
        d='M9.705 29.73l.116-.779-.628.335-.172.809.684-.364z'
        fill='#0068FF'
      />
      <path
        d='M1.693 22.098l.172.263-.107-1.512-.18-.367.115 1.616z'
        fill='#5DFF9A'
      />
      <path
        d='M12.8 8.709l.123 1.155.733 1.822-.122-1.149L12.8 8.71z'
        fill='#FF6000'
      />
      <path
        d='M1.263 14.803l.23.988.376-1.578-.216-1.054-.39 1.644z'
        fill='#FFE200'
      />
      <path
        d='M7.48 20.375l2.133-.345.033-.807-2.135.272-.032.88z'
        fill='#87FF70'
      />
      <path
        d='M5.75 21.656l1.783-.383-.054-.898-1.79.297.061.984z'
        fill='#6AFF8D'
      />
      <path
        d='M21.992 17.562l2.436-.507.18.65-2.431.518-.185-.66z'
        fill='#BEFF39'
      />
      <path
        d='M2.363 23.854l.433-.153-.208-1.284-.452.045.227 1.392z'
        fill='#36FFC1'
      />
      <path
        d='M12.336 17.52l2.566-.302.231-.556-2.555.268-.242.59z'
        fill='#CAFF2C'
      />
      <path
        d='M15.42 16.187l2.592-.354.327-.366-2.582.339-.336.38z'
        fill='#E7FF0F'
      />
      <path
        d='M1.424 19.95l.154.533.038-1.588-.153-.628-.04 1.683z'
        fill='#90FF66'
      />
      <path
        d='M1.282 17.485l.182.781.2-1.613-.172-.863-.21 1.695z'
        fill='#CAFF2C'
      />
      <path
        d='M3.491 23.427l1.023-.364-.171-1.074-1.041.262.19 1.176z'
        fill='#40FFB7'
      />
      <path
        d='M19.097 15.042l2.481-.467.407-.046-2.477.467-.411.046z'
        fill='#FFE600'
      />
      <path
        d='M10.91 30.256l-.374-.463-.679.603.322.508.731-.648z'
        fill='#0054FF'
      />
      <path
        d='M15.464 23.426l1.982-.639-.218.618-1.996.687.232-.666z'
        fill='#33FFC4'
      />
      <path
        d='M2.797 23.7l.695-.273-.19-1.176-.713.166.208 1.284z'
        fill='#3CFFBA'
      />
      <path
        d='M10.81 27.631l.828-.84-.477.428-.874.88.523-.468z'
        fill='#00ACFF'
      />
      <path
        d='M6.204 2.972l.137 1.165 1.207.179-.135-1.168-1.209-.176z'
        fill='maroon'
      />
      <path
        d='M14.219 13.639l.118 1.155.376 2.003-.113-1.13-.381-2.028z'
        fill='#FFEA00'
      />
      <path
        d='M21.75 16.947l2.442-.498.237.606-2.436.508-.243-.616z'
        fill='#D1FF26'
      />
      <path
        d='M19.88 19.394l2.42-.482.054.699-2.414.51-.06-.727z'
        fill='#94FF63'
      />
      <path
        d='M13.606 24.808l1.626-.717-.297.577-1.65.768.321-.628z'
        fill='#16FFE1'
      />
      <path
        d='M12.057 26.226l1.227-.79-.384.517-1.262.838.42-.565z'
        fill='#00D8FF'
      />
      <path
        d='M17.677 21.37l2.254-.531-.079.69-2.255.574.08-.732z'
        fill='#66FF90'
      />
      <path
        d='M19.508 14.996l2.477-.467.414.066-2.473.468-.418-.067z'
        fill='#FFE200'
      />
      <path
        d='M9.757 18.452l2.403-.27.176-.662-2.393.219-.186.713z'
        fill='#B7FF40'
      />
      <path
        d='M14.92 21.798l-.116.86-.186 1.803.11-.804.192-1.86z'
        fill='#43FFB4'
      />
      <path
        d='M2.403 7.935l.273 1.248.867-1.062-.257-1.274-.883 1.088z'
        fill='#FF2500'
      />
      <path
        d='M4.343 21.99l1.408-.334-.062-.984-1.418.236.072 1.081z'
        fill='#66FF90'
      />
      <path
        d='M10.394 28.439l.417-.807-.523.468-.467.851.573-.512z'
        fill='#0098FF'
      />
      <path
        d='M12.039 29.61l-.487-.213-.643.858.441.272.689-.916z'
        fill='#0068FF'
      />
      <path
        d='M21.455 16.394l2.448-.49.289.545-2.442.498-.295-.553z'
        fill='#E1FF16'
      />
      <path
        d='M15.758 15.805l2.581-.339.365-.266-2.57.329-.376.276z'
        fill='#F8F500'
      />
      <path
        d='M10.535 29.793l-.205-.62-.625.558.152.665.678-.603z'
        fill='#006CFF'
      />
      <path
        d='M11.915 7.064l.126 1.16.882 1.64-.124-1.155-.884-1.645z'
        fill='#FF2900'
      />
      <path
        d='M1.866 22.361l.27.1-.098-1.403-.28-.208.108 1.511z'
        fill='#60FF97'
      />
      <path
        d='M19.926 15.064l2.472-.468.41.176-2.467.471-.415-.18z'
        fill='#FFE600'
      />
      <path
        d='M12.578 16.93l2.555-.267.288-.476-2.541.239-.302.504z'
        fill='#DEFF19'
      />
      <path
        d='M7.512 19.495l2.134-.272.11-.77-2.128.201-.116.84z'
        fill='#A4FF53'
      />
      <path
        d='M10.33 29.174l.063-.735-.572.513-.116.779.625-.557z'
        fill='#0080FF'
      />
      <path
        d='M5.688 20.672l1.791-.297.032-.88-1.791.211-.032.966z'
        fill='#87FF70'
      />
      <path
        d='M21.116 15.917l2.454-.482.334.47-2.448.489-.34-.477z'
        fill='#EEFF09'
      />
      <path
        d='M20.34 15.242l2.467-.47.395.282-2.461.476-.4-.287z'
        fill='#FFEA00'
      />
      <path
        d='M4.06 4.795l.23 1.25 1.096-.486-.217-1.26-1.108.496z'
        fill='#AD0000'
      />
      <path
        d='M20.741 15.53l2.46-.475.37.38-2.455.482-.375-.387z'
        fill='#FBF100'
      />
      <path
        d='M14.618 24.46l-.275.628-.345 1.608.26-.562.36-1.673z'
        fill='#0CF4EB'
      />
      <path
        d='M19.75 18.677l2.427-.453.121.689-2.419.481-.129-.717z'
        fill='#AAFF4D'
      />
      <path
        d='M15.623 22.689l1.974-.585-.151.683-1.982.64.16-.738z'
        fill='#4DFFAA'
      />
      <path
        d='M13.108 28.425l-.493.065-.576 1.121h.458l.611-1.186z'
        fill='#08F'
      />
      <path
        d='M7.414 3.147l.135 1.168 1.206.516-.132-1.168-1.209-.516z'
        fill='maroon'
      />
      <path
        d='M3.302 22.25l1.04-.26-.07-1.082-1.05.158.08 1.185z'
        fill='#66FF90'
      />
      <path
        d='M13.998 26.695l-.413.354-.477 1.376.389-.285.5-1.445z'
        fill='#00B8FF'
      />
      <path
        d='M11.27 27.013l.788-.786-.42.565-.828.84.46-.62z'
        fill='#00C8FF'
      />
      <path
        d='M17.683 20.608l2.257-.487-.01.718-2.253.532.006-.763z'
        fill='#7DFF7A'
      />
      <path
        d='M2.135 22.462l.453-.045-.09-1.293-.46-.065.098 1.403z'
        fill='#60FF97'
      />
      <path
        d='M16.134 15.529l2.57-.329.393-.158-2.557.322-.406.165z'
        fill='#FFEA00'
      />
      <path
        d='M10.905 5.65l.128 1.163 1.008 1.411-.126-1.16-1.01-1.415z'
        fill='#DF0000'
      />
      <path
        d='M2.588 22.417l.713-.166-.08-1.185-.723.058.09 1.293z'
        fill='#63FF94'
      />
      <path
        d='M1.578 20.483l.18.367.036-1.486-.178-.47-.038 1.59z'
        fill='#90FF66'
      />
      <path
        d='M13.856 24.083l1.608-.657-.232.666-1.626.716.25-.725z'
        fill='#2CFFCA'
      />
      <path
        d='M9.943 17.739l2.394-.219.242-.59-2.378.171-.258.638z'
        fill='#D1FF26'
      />
      <path
        d='M1.95 10.497l.257 1.185.707-1.27-.238-1.228-.727 1.313z'
        fill='#FF6000'
      />
      <path
        d='M12.408 25.539l1.198-.73-.321.628-1.227.79.35-.688z'
        fill='#0CF4EB'
      />
      <path
        d='M8.622 3.663l.132 1.168 1.173.84-.13-1.166-1.175-.842z'
        fill='#920000'
      />
      <path
        d='M12.88 16.425l2.541-.238.336-.381-2.523.214-.354.405z'
        fill='#EEFF09'
      />
      <path
        d='M19.556 17.99l2.437-.427.184.66-2.427.454-.194-.688z'
        fill='#C1FF36'
      />
      <path
        d='M11.553 29.396l-.422-.403-.596.799.375.463.643-.859z'
        fill='#007CFF'
      />
      <path
        d='M9.797 4.505l.13 1.167 1.106 1.141-.128-1.164-1.108-1.144z'
        fill='#B20000'
      />
      <path
        d='M14.713 16.797l.029 1.077.183 1.979-.025-1.033-.187-2.023z'
        fill='#C1FF36'
      />
      <path
        d='M4.271 20.909l1.418-.236.031-.966-1.417.141-.032 1.06z'
        fill='#8AFF6D'
      />
      <path
        d='M16.54 15.365l2.556-.323.412-.046-2.542.32-.426.049z'
        fill='#FFE200'
      />
      <path
        d='M7.628 18.654l2.128-.202.187-.714-2.116.137-.2.779z'
        fill='#BEFF39'
      />
      <path
        d='M10.896 27.762l.373-.75-.459.62-.416.807.502-.677z'
        fill='#00B4FF'
      />
      <path
        d='M13.655 11.685l.125 1.18.557 1.929-.118-1.156-.564-1.953z'
        fill='#FFA300'
      />
      <path
        d='M1.463 18.267l.152.628.19-1.522-.141-.72-.201 1.614z'
        fill='#C7FF30'
      />
      <path
        d='M5.72 19.706l1.791-.211.117-.84-1.784.13-.124.921z'
        fill='#A7FF50'
      />
      <path
        d='M1.652 13.16l.216 1.053.535-1.417-.196-1.114-.555 1.477z'
        fill='#FFA300'
      />
      <path
        d='M15.706 21.899l1.97-.528-.08.733-1.973.585.083-.79z'
        fill='#63FF94'
      />
      <path
        d='M17.615 19.836l2.264-.441.06.726-2.256.488-.068-.773z'
        fill='#97FF60'
      />
      <path
        d='M1.492 15.79l.172.864.36-1.5-.156-.941-.376 1.578z'
        fill='#FFEA00'
      />
      <path
        d='M19.3 17.349l2.45-.402.243.616-2.438.426-.254-.64z'
        fill='#D4FF23'
      />
      <path
        d='M11.132 28.994l-.253-.558-.549.737.205.62.597-.8z'
        fill='#0090FF'
      />
      <path
        d='M10.879 28.436l.017-.674-.503.677-.063.734.549-.737z'
        fill='#00A0FF'
      />
      <path
        d='M16.966 15.317l2.541-.32.419.067-2.526.323-.434-.07z'
        fill='#FFDE00'
      />
      <path
        d='M1.758 20.85l.279.208.034-1.38-.277-.315-.036 1.486z'
        fill='#8DFF6A'
      />
      <path
        d='M10.2 17.1l2.378-.17.302-.505-2.358.13-.322.546z'
        fill='#E4FF13'
      />
      <path
        d='M13.234 16.02l2.524-.214.376-.277-2.503.198-.397.294z'
        fill='#FEED00'
      />
      <path
        d='M3.222 21.066l1.05-.158.031-1.06-1.05.055-.031 1.163z'
        fill='#8AFF6D'
      />
      <path
        d='M11.653 26.259l.755-.72-.35.688-.788.786.383-.754z'
        fill='#02E8F4'
      />
      <path
        d='M12.615 28.49l-.525-.143-.537 1.05.486.214.576-1.121z'
        fill='#0098FF'
      />
      <path
        d='M14.026 23.28l1.597-.591-.16.737-1.607.657.17-.804z'
        fill='#46FFB1'
      />
      <path
        d='M18.992 16.773l2.463-.378.295.553-2.45.401-.308-.576z'
        fill='#E4FF13'
      />
      <path
        d='M5.168 4.3l.217 1.26 1.161-.158-.205-1.265-1.173.162z'
        fill='#920000'
      />
      <path
        d='M3.286 6.847l.257 1.274.983-.78-.237-1.294-1.003.8z'
        fill='#DF0000'
      />
      <path
        d='M17.4 15.387l2.526-.324.415.18-2.51.331-.43-.187z'
        fill='#FFDE00'
      />
      <path
        d='M12.68 24.743l1.176-.661-.25.725-1.198.73.272-.794z'
        fill='#26FFD1'
      />
      <path
        d='M14.926 19.854l-.117.92-.005 1.884.116-.86.006-1.944z'
        fill='#83FF73'
      />
      <path
        d='M18.639 16.277l2.477-.359.34.477-2.463.378-.354-.496z'
        fill='#F1FC06'
      />
      <path
        d='M17.832 15.575l2.51-.33.4.286-2.494.343-.416-.299z'
        fill='#FFE600'
      />
      <path
        d='M2.038 21.059l.461.065.033-1.27-.46-.174-.034 1.379z'
        fill='#8DFF6A'
      />
      <path
        d='M2.499 21.124l.723-.058.032-1.163-.722-.05-.033 1.27z'
        fill='#8DFF6A'
      />
      <path
        d='M17.475 19.075l2.275-.397.129.716-2.264.442-.14-.761z'
        fill='#ADFF49'
      />
      <path
        d='M18.248 15.873l2.494-.343.374.387-2.477.36-.391-.404z'
        fill='#FEED00'
      />
      <path
        d='M7.827 17.876l2.116-.137.257-.637-2.096.078-.277.696z'
        fill='#D7FF1F'
      />
      <path
        d='M15.71 21.076l1.973-.468-.006.763-1.97.527.003-.822z'
        fill='#7DFF7A'
      />
      <path
        d='M4.303 19.848l1.417-.14.124-.923-1.408.05-.133 1.013z'
        fill='#AAFF4D'
      />
      <path
        d='M13.585 27.049l-.522.142-.448 1.299.493-.066.477-1.375z'
        fill='#00C4FF'
      />
      <path
        d='M13.63 15.727l2.504-.197.407-.165-2.48.187-.43.175z'
        fill='#FFE200'
      />
      <path
        d='M5.844 18.785l1.784-.13.199-.779-1.769.054-.214.855z'
        fill='#C4FF33'
      />
      <path
        d='M11.315 26.935l.337-.677-.383.755-.373.748.419-.826z'
        fill='#00D8FF'
      />
      <path
        d='M14.804 22.658l-.284.698-.177 1.731.275-.627.186-1.802z'
        fill='#46FFB1'
      />
      <path
        d='M1.616 18.894l.178.47.179-1.422-.166-.569-.19 1.521z'
        fill='#C1FF36'
      />
      <path
        d='M12.923 9.864l.133 1.203.724 1.8-.125-1.18-.732-1.823z'
        fill='#FF6400'
      />
      <path
        d='M10.523 16.556l2.357-.13.354-.405-2.333.098-.378.437z'
        fill='#F8F500'
      />
      <path
        d='M12.09 28.346l-.461-.328-.498.975.421.404.538-1.05z'
        fill='#00A8FF'
      />
      <path
        d='M14.343 25.088l-.431.43-.327 1.531.413-.353.345-1.608z'
        fill='#0FF8E7'
      />
      <path
        d='M17.266 18.344l2.29-.354.194.688-2.275.397-.21-.731z'
        fill='#C4FF33'
      />
      <path
        d='M14.114 22.418l1.591-.52-.082.79-1.597.592.088-.862z'
        fill='#63FF94'
      />
      <path
        d='M14.337 14.795l.037 1.12.368 1.96-.029-1.077-.376-2.003z'
        fill='#FFEA00'
      />
      <path
        d='M2.677 9.183l.238 1.228.842-1.027-.214-1.263-.866 1.062z'
        fill='#FF3000'
      />
      <path
        d='M11.337 27.535l-.021-.6-.42.827-.017.673.458-.9z'
        fill='#00C8FF'
      />
      <path
        d='M14.06 15.551l2.48-.187.426-.048-2.456.185-.45.05z'
        fill='#FFDB00'
      />
      <path
        d='M11.63 28.018l-.293-.483-.458.9.253.559.497-.976z'
        fill='#00B8FF'
      />
      <path
        d='M11.949 25.386l.73-.642-.271.795-.756.72.297-.873z'
        fill='#1CFFDB'
      />
      <path
        d='M3.254 19.903l1.05-.055.133-1.014-1.04-.043-.143 1.112z'
        fill='#ADFF49'
      />
      <path
        d='M6.342 4.137l.205 1.265 1.194.178-.192-1.265-1.207-.178z'
        fill='#840000'
      />
      <path
        d='M15.633 20.242l1.982-.406.067.772-1.973.467-.076-.833z'
        fill='#97FF60'
      />
      <path
        d='M12.864 23.863l1.162-.584-.17.804-1.177.66.185-.88z'
        fill='#43FFB4'
      />
      <path
        d='M1.665 16.653l.142.72.34-1.415-.123-.806-.359 1.5z'
        fill='#FBF100'
      />
      <path
        d='M16.993 17.662l2.308-.313.255.64-2.29.354-.273-.68z'
        fill='#D7FF1F'
      />
      <path
        d='M8.104 17.18l2.097-.079.322-.544-2.07.029-.349.594z'
        fill='#EEFF09'
      />
      <path
        d='M1.794 19.364l.277.315.167-1.319-.265-.419-.18 1.423z'
        fill='#BEFF39'
      />
      <path
        d='M10.9 16.12l2.334-.1.396-.293-2.304.075-.426.317z'
        fill='#FFE600'
      />
      <path d='M14.51 15.5l2.456-.184.435.07-2.43.19-.46-.075z' fill='gold' />
      <path
        d='M2.208 11.68l.196 1.115.68-1.218-.17-1.167-.706 1.27z'
        fill='#FF6C00'
      />
      <path
        d='M4.437 18.834l1.408-.05.214-.854-1.39-.035-.232.939z'
        fill='#CAFF2C'
      />
      <path
        d='M2.531 19.853l.722.05.144-1.112-.71-.152-.156 1.214z'
        fill='#B4FF43'
      />
      <path
        d='M1.868 14.212l.155.94.51-1.346-.13-1.011-.535 1.417z'
        fill='#FFAE00'
      />
      <path
        d='M6.06 17.93l1.768-.054.277-.696-1.745-.014-.3.764z'
        fill='#DEFF19'
      />
      <path
        d='M12.04 8.225l.143 1.222.872 1.62-.133-1.203-.882-1.64z'
        fill='#FF2D00'
      />
      <path
        d='M16.663 17.05l2.33-.277.308.577-2.308.313-.33-.613z'
        fill='#EBFF0C'
      />
      <path
        d='M13.063 27.191l-.555-.06-.417 1.216.525.143.447-1.299z'
        fill='#0CF'
      />
      <path
        d='M4.29 6.046l.236 1.294 1.076-.473-.216-1.308-1.097.487z'
        fill='#B00'
      />
      <path
        d='M2.071 19.678l.46.174.155-1.214-.448-.279-.167 1.32z'
        fill='#B7FF40'
      />
      <path d='M14.97 15.576l2.43-.19.431.188-2.403.2-.457-.198z' fill='gold' />
      <path
        d='M14.115 21.52l1.595-.445-.004.823-1.592.52.001-.898z'
        fill='#7DFF7A'
      />
      <path
        d='M15.48 19.42l1.995-.346.14.762-1.981.406-.155-.823z'
        fill='#B1FF46'
      />
      <path
        d='M11.64 25.981l.309-.594-.297.872-.337.677.325-.955z'
        fill='#16FFE1'
      />
      <path
        d='M16.286 16.523l2.352-.246.355.497-2.33.277-.377-.528z'
        fill='#F8F500'
      />
      <path
        d='M15.428 15.775l2.403-.2.416.298-2.377.22-.442-.318z'
        fill='#FFDB00'
      />
      <path
        d='M7.548 4.314L7.74 5.58l1.194.511-.18-1.26-1.206-.517z'
        fill='#890000'
      />
      <path
        d='M15.871 16.093l2.377-.22.39.403-2.351.246-.416-.429z'
        fill='#FFE600'
      />
      <path
        d='M14.742 17.875l-.112.981.178 1.918.117-.92-.183-1.979z'
        fill='#C1FF36'
      />
      <path
        d='M11.326 15.802l2.305-.075.43-.175-2.274.06-.46.19z'
        fill='gold'
      />
      <path
        d='M8.452 16.585l2.07-.03.379-.436-2.04-.012-.409.478z'
        fill='#FFEA00'
      />
      <path
        d='M12.958 22.918l1.156-.5-.087.862-1.163.583.094-.945z'
        fill='#60FF97'
      />
      <path
        d='M12.151 24.42l.714-.557-.186.881-.73.643.202-.968z'
        fill='#3CFFBA'
      />
      <path
        d='M11.033 6.813l.154 1.24.997 1.393-.143-1.223-1.008-1.41z'
        fill='#E40000'
      />
      <path
        d='M12.508 27.13l-.493-.242-.386 1.13.461.328.418-1.216z'
        fill='#00D8FF'
      />
      <path
        d='M13.912 25.518l-.542.228-.306 1.445.52-.142.328-1.531z'
        fill='#16FFE1'
      />
      <path
        d='M11.691 26.493l-.051-.512-.325.954.022.6.354-1.042z'
        fill='#0CF4EB'
      />
      <path
        d='M3.396 18.79l1.04.044.233-.94-1.02-.134-.253 1.03z'
        fill='#D1FF26'
      />
      <path
        d='M8.754 4.832l.18 1.261 1.159.832-.167-1.253-1.172-.84z'
        fill='#9B0000'
      />
      <path
        d='M1.807 17.373l.166.569.319-1.322-.146-.661-.34 1.414z'
        fill='#F4F802'
      />
      <path
        d='M15.251 18.63l2.015-.286.21.73-1.997.346-.228-.79z'
        fill='#C7FF30'
      />
      <path
        d='M13.78 12.866l.048 1.163.546 1.886-.037-1.12-.557-1.929z'
        fill='#FFA700'
      />
      <path
        d='M9.927 5.672l.166 1.252 1.094 1.13-.154-1.24-1.106-1.142z'
        fill='#B00'
      />
      <path
        d='M12.015 26.889l-.323-.395-.355 1.042.293.482.385-1.129z'
        fill='#02E8F4'
      />
      <path
        d='M14.808 20.773l-.285.773-.003 1.81.283-.698.005-1.885z'
        fill='#80FF77'
      />
      <path
        d='M6.36 17.166l1.744.014.348-.595-1.714-.072-.379.653z'
        fill='#F8F500'
      />
      <path
        d='M14.03 20.61l1.603-.368.076.834-1.594.444-.086-.91z'
        fill='#9AFF5D'
      />
      <path
        d='M14.52 23.356l-.44.514-.168 1.648.431-.43.178-1.732z'
        fill='#49FFAD'
      />
      <path
        d='M11.787 15.614l2.273-.061.45-.051-2.238.057-.485.055z'
        fill='#FFD000'
      />
      <path
        d='M4.669 17.895l1.39.035.3-.764-1.363-.111-.327.84z'
        fill='#E7FF0F'
      />
      <path
        d='M3.542 8.12l.214 1.264.955-.753-.185-1.29-.984.78z'
        fill='#F10800'
      />
      <path
        d='M2.686 18.639l.71.152.253-1.03-.69-.25-.273 1.128z'
        fill='#DBFF1C'
      />
      <path
        d='M14.954 17.894l2.039-.232.273.681-2.015.287-.297-.736z'
        fill='#DEFF19'
      />
      <path
        d='M8.861 16.108l2.04.012.425-.318-2.003-.04-.462.346z'
        fill='gold'
      />
      <path
        d='M1.973 17.942l.265.42.296-1.226-.243-.515-.318 1.321z'
        fill='#EBFF0C'
      />
      <path
        d='M5.386 5.559l.216 1.308 1.138-.151L6.547 5.4l-1.161.158z'
        fill='#9F0000'
      />
      <path
        d='M11.86 24.92l.29-.501-.201.967-.31.595.221-1.06z'
        fill='#36FFC1'
      />
      <path
        d='M2.024 15.153l.123.806.482-1.269-.095-.884-.51 1.347z'
        fill='#FFB900'
      />
      <path
        d='M12.271 15.558l2.24-.057.46.075-2.204.063-.495-.08z'
        fill='#FC0'
      />
      <path
        d='M12.957 21.933l1.159-.413-.002.898-1.156.5-.001-.985z'
        fill='#80FF77'
      />
      <path
        d='M2.238 18.36l.448.279.274-1.127-.425-.376-.297 1.224z'
        fill='#E1FF16'
      />
      <path
        d='M14.597 17.233l2.067-.182.33.612-2.04.232-.357-.662z'
        fill='#F1FC06'
      />
      <path
        d='M12.252 23.381l.705-.463-.093.945-.714.556.102-1.038z'
        fill='#5DFF9A'
      />
      <path
        d='M2.914 10.412l.17 1.166.81-.983-.138-1.21-.842 1.027z'
        fill='#FF3B00'
      />
      <path
        d='M13.37 25.746l-.577.032-.285 1.353.555.06.307-1.445z'
        fill='#1CFFDB'
      />
      <path
        d='M13.858 19.713l1.621-.293.154.822-1.604.37-.17-.899z'
        fill='#B7FF40'
      />
      <path
        d='M12.768 15.64l2.203-.064.457.2-2.167.079-.493-.216z'
        fill='#FC0'
      />
      <path
        d='M2.403 12.795l.13 1.01.65-1.156-.099-1.072-.68 1.218z'
        fill='#FF7A00'
      />
      <path
        d='M14.188 16.661l2.098-.14.377.528-2.067.183-.409-.57z'
        fill='#FFEA00'
      />
      <path
        d='M6.737 16.513l1.715.072.41-.477-1.678-.12-.447.525z'
        fill='#FFDB00'
      />
      <path
        d='M13.26 15.855l2.168-.08.442.318-2.132.106-.477-.344z'
        fill='#FFD000'
      />
      <path
        d='M3.65 17.76l1.019.136.327-.84-.99-.218-.357.923z'
        fill='#F4F802'
      />
      <path
        d='M13.738 16.199l2.132-.105.416.428-2.099.14-.449-.463z'
        fill='#FFDB00'
      />
      <path
        d='M9.323 15.761l2.003.04.461-.188-1.963-.058-.5.206z'
        fill='#FFC800'
      />
      <path
        d='M13.057 11.066l.062 1.202.71 1.76-.048-1.162-.724-1.8z'
        fill='#FF6C00'
      />
      <path
        d='M14.374 15.916l-.101 1.041.358 1.9.112-.982-.369-1.959z'
        fill='#FBF100'
      />
      <path
        d='M11.932 25.336l-.072-.416-.22 1.06.051.513.241-1.157z'
        fill='#30FFC7'
      />
      <path
        d='M4.995 17.055l1.364.111.378-.653-1.329-.177-.413.719z'
        fill='#FFE600'
      />
      <path
        d='M12.794 25.778l-.515-.145-.263 1.255.492.242.286-1.352z'
        fill='#23FFD4'
      />
      <path
        d='M12.278 25.633l-.345-.297-.242 1.157.324.395.263-1.256z'
        fill='#29FFCE'
      />
      <path
        d='M13.607 18.85l1.644-.22.229.79-1.621.293-.252-.863z'
        fill='#D1FF26'
      />
      <path
        d='M12.86 20.934l1.17-.324.085.91-1.158.413-.097-.998z'
        fill='#9DFF5A'
      />
      <path
        d='M2.146 15.958l.145.661.451-1.184-.115-.745-.481 1.268z'
        fill='#FFC400'
      />
      <path
        d='M14.08 23.87l-.554.321-.156 1.555.542-.228.167-1.648z'
        fill='#4DFFAA'
      />
      <path
        d='M6.547 5.401l.193 1.315 1.17.177-.17-1.313-1.193-.179z'
        fill='#920000'
      />
      <path
        d='M9.823 15.555l1.963.058.485-.055-1.92-.063-.528.06z'
        fill='#FFC100'
      />
      <path
        d='M2.96 17.511l.69.249.355-.923-.658-.335-.387 1.01z'
        fill='#FEED00'
      />
      <path
        d='M11.97 23.782l.282-.401-.102 1.038-.29.502.11-1.139z'
        fill='#5AFF9D'
      />
      <path
        d='M4.525 7.34l.186 1.29 1.044-.455-.154-1.308-1.076.474z'
        fill='#C80000'
      />
      <path
        d='M14.63 18.855l-.278.849.172 1.842.285-.773-.178-1.918z'
        fill='#BEFF39'
      />
      <path
        d='M12.249 22.3l.707-.366.002.984-.706.463-.003-1.082z'
        fill='#80FF77'
      />
      <path
        d='M7.184 15.989l1.677.119.461-.347-1.634-.154-.504.382z'
        fill='#FFC800'
      />
      <path
        d='M14.524 21.546l-.443.601-.002 1.723.44-.514.005-1.81z'
        fill='#80FF77'
      />
      <path
        d='M13.281 18.047l1.673-.152.297.735-1.644.22-.326-.803z'
        fill='#E7FF0F'
      />
      <path
        d='M2.291 16.62l.243.516.42-1.098-.212-.603-.451 1.185z'
        fill='#FFD300'
      />
      <path
        d='M12.184 9.447l.08 1.236.854 1.585-.062-1.2-.872-1.62z'
        fill='#FF3400'
      />
      <path
        d='M2.534 17.135l.426.376.387-1.01-.393-.464-.42 1.098z'
        fill='#FFDE00'
      />
      <path
        d='M10.352 15.495l1.92.063.496.082-1.877-.056-.54-.089z'
        fill='#FFB900'
      />
      <path d='M4.006 16.837l.99.217.413-.719-.952-.288-.451.79z' fill='gold' />
      <path
        d='M5.408 16.335l1.329.177.447-.524-1.287-.23-.489.577z'
        fill='#FC0'
      />
      <path
        d='M2.533 13.806l.094.884.613-1.088-.058-.953-.649 1.157z'
        fill='#FF8600'
      />
      <path
        d='M12.67 19.949l1.189-.236.17.898-1.169.324-.19-.986z'
        fill='#BAFF3C'
      />
      <path
        d='M7.74 5.58l.17 1.313 1.17.503-.146-1.304L7.74 5.58z'
        fill='#960000'
      />
      <path
        d='M12.89 17.324l1.707-.092.357.662-1.673.153-.391-.723z'
        fill='#FBF100'
      />
      <path
        d='M12.053 24.093l-.082-.31-.11 1.137.071.416.121-1.243z'
        fill='#56FFA0'
      />
      <path
        d='M13.527 24.191l-.589.133-.144 1.454.577-.032.156-1.555z'
        fill='#4DFFAA'
      />
      <path
        d='M3.756 9.384l.138 1.21.919-.72L4.71 8.63l-.955.753z'
        fill='#FF1300'
      />
      <path
        d='M10.892 15.584l1.876.056.493.215-1.831-.036-.538-.235z'
        fill='#FFBD00'
      />
      <path
        d='M13.828 14.03l-.086 1.099.53 1.828.102-1.041-.546-1.887z'
        fill='#FFAE00'
      />
      <path
        d='M11.188 8.053l.1 1.265.976 1.365-.08-1.236-.996-1.394z'
        fill='#F10800'
      />
      <path
        d='M7.688 15.608l1.635.154.501-.207-1.587-.174-.549.227z'
        fill='#FFB900'
      />
      <path
        d='M12.442 16.701l1.746-.039.41.57-1.708.092-.448-.623z'
        fill='#FFDB00'
      />
      <path
        d='M3.084 11.577l.099 1.072.772-.933-.06-1.122-.811.983z'
        fill='#FF4A00'
      />
      <path
        d='M11.429 15.82l1.831.035.478.344-1.788-.004-.521-.376z'
        fill='#FFC100'
      />
      <path
        d='M11.951 16.195l1.788.004.45.464-1.747.038-.49-.506z'
        fill='#FC0'
      />
      <path
        d='M8.934 6.092l.145 1.304 1.137.816-.123-1.288-1.16-.832z'
        fill='#A40000'
      />
      <path
        d='M12.142 21.2l.718-.265.097.998-.708.366-.107-1.098z'
        fill='#A0FF56'
      />
      <path
        d='M10.094 6.924l.122 1.288 1.072 1.106-.1-1.265-1.094-1.13z'
        fill='#C40000'
      />
      <path
        d='M12.41 24.283l-.357-.19-.12 1.243.345.297.133-1.35z'
        fill='#53FFA4'
      />
      <path
        d='M11.967 22.595l.282-.296.002 1.082-.28.401-.004-1.187z'
        fill='#80FF77'
      />
      <path
        d='M12.938 24.324l-.527-.04-.133 1.349.515.145.145-1.454z'
        fill='#50FFA7'
      />
      <path
        d='M12.393 19l1.214-.15.252.862-1.188.236-.278-.947z'
        fill='#D7FF1F'
      />
      <path
        d='M3.348 16.503l.658.335.45-.79-.617-.41-.491.865z'
        fill='#FFC800'
      />
      <path
        d='M5.602 6.868l.154 1.308 1.106-.144-.122-1.315-1.138.151z'
        fill='#AD0000'
      />
      <path
        d='M2.628 14.69l.115.745.573-1.016-.075-.817-.613 1.088z'
        fill='#FF9800'
      />
      <path
        d='M5.897 15.759l1.287.23.504-.382-1.238-.268-.553.42z'
        fill='#FFB600'
      />
      <path
        d='M14.081 22.148l-.555.419v1.625l.553-.322.002-1.723z'
        fill='#80FF77'
      />
      <path
        d='M8.236 15.38l1.588.175.527-.06-1.537-.18-.578.065z'
        fill='#FFAE00'
      />
      <path
        d='M4.457 16.047l.952.288.489-.577-.906-.346-.535.635z'
        fill='#FFB900'
      />
      <path
        d='M14.272 16.957l-.266.924.345 1.824.28-.849-.36-1.899z'
        fill='#F8F500'
      />
      <path
        d='M2.954 16.038l.394.464.49-.864-.351-.54-.533.94z'
        fill='#FFB600'
      />
      <path
        d='M2.742 15.436l.212.602.532-.94-.17-.678-.574 1.016z'
        fill='#FFA700'
      />
      <path
        d='M14.352 19.705l-.436.69.165 1.753.443-.601-.172-1.842z'
        fill='#BAFF3C'
      />
      <path
        d='M12.033 18.119l1.248-.072.326.803-1.214.151-.36-.882z'
        fill='#F1FC06'
      />
      <path
        d='M11.932 20.117l.739-.168.19.986-.72.266-.21-1.084z'
        fill='#C1FF36'
      />
      <path
        d='M12.05 22.797l-.082-.201.004 1.187.082.311-.004-1.297z'
        fill='#80FF77'
      />
      <path
        d='M13.118 12.269l-.065 1.153.689 1.707.086-1.1-.71-1.76z'
        fill='#FF7300'
      />
      <path
        d='M8.814 15.315l1.538.18.54.089-1.486-.172-.592-.098z'
        fill='#FFA700'
      />
      <path
        d='M3.184 12.65l.058.952.729-.877-.015-1.008-.772.933z'
        fill='#FF5D00'
      />
      <path
        d='M11.849 21.39l.293-.189.107 1.098-.282.296-.118-1.205z'
        fill='#A4FF53'
      />
      <path
        d='M4.712 8.63l.101 1.244 1.005-.435-.062-1.264-1.044.456z'
        fill='#DA0000'
      />
      <path
        d='M11.602 17.325h1.287l.392.722-1.248.072-.431-.794z'
        fill='#FFE200'
      />
      <path
        d='M6.45 15.339l1.238.268.548-.226-1.186-.292-.6.25z'
        fill='#FFA300'
      />
      <path
        d='M13.527 22.566l-.59.239.001 1.519.59-.133v-1.625z'
        fill='#80FF77'
      />
      <path
        d='M6.74 6.716l.12 1.314 1.136.175-.088-1.313-1.17-.177z'
        fill='#A40000'
      />
      <path
        d='M9.406 15.412l1.486.172.537.235-1.432-.148-.59-.259z'
        fill='#FFAB00'
      />
      <path
        d='M3.839 15.637l.618.41.534-.635-.57-.47-.582.695z'
        fill='#FFA700'
      />
      <path
        d='M12.408 22.874l-.358-.078.004 1.297.357.19-.003-1.409z'
        fill='#80FF77'
      />
      <path
        d='M3.894 10.594l.06 1.122.876-.682-.017-1.16-.92.72z'
        fill='#FF2500'
      />
      <path d='M11.11 16.64l1.332.061.447.623h-1.287l-.493-.684z' fill='#FC0' />
      <path
        d='M9.997 15.67l1.433.149.521.376-1.381-.112-.573-.413z'
        fill='#FFAE00'
      />
      <path
        d='M12.935 22.805l-.528.07.003 1.408.527.04-.002-1.518z'
        fill='#80FF77'
      />
      <path
        d='M4.991 15.413l.906.346.553-.42-.854-.388-.605.462z'
        fill='#FF9F00'
      />
      <path
        d='M10.57 16.082l1.38.112.492.506-1.333-.062-.54-.556z'
        fill='#FFBD00'
      />
      <path
        d='M11.624 19.074l.768-.072.278.947-.739.168-.307-1.043z'
        fill='#E1FF16'
      />
      <path
        d='M12.264 10.684l-.04 1.201.83 1.537.065-1.153-.855-1.585z'
        fill='#FF3F00'
      />
      <path
        d='M3.24 13.602l.076.818.681-.818-.028-.877-.729.877z'
        fill='#FF6F00'
      />
      <path
        d='M13.742 15.129l-.246.997.51 1.755.267-.924-.53-1.828z'
        fill='#FFB600'
      />
      <path
        d='M7.05 15.089l1.186.291.578-.066-1.129-.298-.634.073z'
        fill='#FF9800'
      />
      <path
        d='M3.486 15.098l.353.54.583-.695-.303-.602-.633.757z'
        fill='#FF9400'
      />
      <path
        d='M13.916 20.395l-.547.52.158 1.652.555-.42-.166-1.752z'
        fill='#B7FF40'
      />
      <path
        d='M7.91 6.894l.088 1.312 1.135.49-.053-1.3-1.17-.502z'
        fill='#A40000'
      />
      <path
        d='M11.92 21.48l-.071-.09.118 1.206.083.2-.13-1.317z'
        fill='#A7FF50'
      />
      <path
        d='M11.617 20.199l.314-.083.21 1.085-.293.189-.23-1.191z'
        fill='#C7FF30'
      />
      <path
        d='M3.316 14.42l.17.678.633-.757-.12-.74-.683.819z'
        fill='#FF8200'
      />
      <path
        d='M14.007 17.88l-.421.78.33 1.735.436-.69-.345-1.824z'
        fill='#F1FC06'
      />
      <path
        d='M11.227 18.102l.806.017.36.883-.769.072-.397-.972z'
        fill='#FBF100'
      />
      <path
        d='M11.288 9.318l-.012 1.243.948 1.324.04-1.202-.976-1.365z'
        fill='#FF1300'
      />
      <path
        d='M5.756 8.175l.061 1.264 1.063-.135-.019-1.273-1.105.144z'
        fill='#C40000'
      />
      <path
        d='M9.08 7.396l.053 1.3 1.103.792-.02-1.276-1.136-.816z'
        fill='#B60000'
      />
      <path
        d='M7.685 15.016l1.129.298.592.098-1.07-.29-.651-.106z'
        fill='#FF9400'
      />
      <path
        d='M5.596 14.951l.853.388.602-.25-.796-.413-.66.275z'
        fill='#FF8D00'
      />
      <path
        d='M4.422 14.943l.57.47.604-.462-.514-.514-.66.506z'
        fill='#FF8D00'
      />
      <path
        d='M10.216 8.212l.02 1.276 1.04 1.073.011-1.243-1.071-1.106z'
        fill='#D10000'
      />
      <path
        d='M3.955 11.716l.015 1.008.826-.642.035-1.049-.876.683z'
        fill='#FF3800'
      />
      <path
        d='M12.268 21.443l-.348.036.13 1.317.357.079-.14-1.432z'
        fill='#ADFF49'
      />
      <path
        d='M13.37 20.914l-.583.346.15 1.544.59-.238-.158-1.652z'
        fill='#B4FF43'
      />
      <path
        d='M10.752 17.229l.85.096.431.795-.805-.017-.476-.875z'
        fill='#FFD300'
      />
      <path
        d='M4.813 9.874l.018 1.16.956-.411.03-1.184-1.004.435z'
        fill='#F10800'
      />
      <path
        d='M8.335 15.122l1.07.29.59.258-1.01-.264-.65-.284z'
        fill='#FF9400'
      />
      <path
        d='M12.786 21.262l-.518.182.14 1.431.528-.07-.15-1.543z'
        fill='#B1FF46'
      />
      <path
        d='M11.28 19.055l.345.02.307 1.042-.315.083-.338-1.145z'
        fill='#EBFF0C'
      />
      <path
        d='M13.053 13.422l-.22 1.065.663 1.639.246-.997-.689-1.707z'
        fill='#FF7E00'
      />
      <path
        d='M10.21 16.474l.9.165.492.685-.85-.097-.542-.753z'
        fill='#FFB900'
      />
      <path
        d='M8.985 15.406l1.012.264.573.412-.954-.221-.63-.455z'
        fill='#FF9C00'
      />
      <path
        d='M11.667 20.176l-.05.022.231 1.192.072.088-.253-1.302z'
        fill='#CEFF29'
      />
      <path
        d='M9.615 15.861l.954.222.54.557-.9-.166-.594-.613z'
        fill='#FFA700'
      />
      <path d='M4.12 14.34l.302.603.66-.506-.246-.648-.717.552z' fill='#F70' />
      <path
        d='M6.255 14.675l.796.414.634-.073-.734-.421-.696.08z'
        fill='#FF8200'
      />
      <path
        d='M3.97 12.723l.028.877.773-.597.025-.921-.826.641z'
        fill='#FF4A00'
      />
      <path
        d='M6.861 8.031l.02 1.273 1.091.17.025-1.268-1.136-.175z'
        fill='#B60000'
      />
      <path
        d='M13.586 18.66l-.53.619.313 1.635.547-.52-.33-1.734z'
        fill='#EBFF0C'
      />
      <path
        d='M3.998 13.601l.121.74.717-.552-.065-.785-.773.597z'
        fill='#FF6000'
      />
      <path d='M5.082 14.437l.514.514.66-.275-.454-.541-.72.302z' fill='#F70' />
      <path
        d='M13.496 16.125l-.397.865.487 1.67.42-.78-.51-1.755z'
        fill='#FFC100'
      />
      <path
        d='M10.844 17.986l.385.117.396.971-.345-.02-.436-1.068z'
        fill='#FFE200'
      />
      <path
        d='M11.993 20.027l-.326.15.253 1.302.347-.036-.274-1.416z'
        fill='#D7FF1F'
      />
      <path
        d='M12.224 11.885l-.189 1.126.798 1.476.22-1.065-.83-1.537z'
        fill='#FF4A00'
      />
      <path
        d='M6.95 14.594l.735.42.65.108-.67-.411-.715-.117z'
        fill='#FF7A00'
      />
      <path
        d='M4.83 11.034l-.034 1.05.902-.386.09-1.075-.957.411z'
        fill='#FF1A00'
      />
      <path
        d='M5.818 9.439l-.03 1.184 1.01-.127.083-1.192-1.063.135z'
        fill='#DA0000'
      />
      <path
        d='M11.298 18.924l-.019.13.338 1.145.05-.023-.37-1.252z'
        fill='#F4F802'
      />
      <path
        d='M13.055 19.28l-.563.453.294 1.528.582-.347-.313-1.635z'
        fill='#E4FF13'
      />
      <path
        d='M7.998 8.205l-.025 1.268 1.091.472.069-1.25-1.135-.49z'
        fill='#B00'
      />
      <path
        d='M10.32 17.025l.433.203.476.875-.385-.116-.524-.962z'
        fill='#FFC100'
      />
      <path
        d='M12.493 19.732l-.499.295.274 1.415.519-.182-.294-1.528z'
        fill='#DEFF19'
      />
      <path
        d='M4.835 13.79l.246.647.72-.303-.184-.675-.782.33z'
        fill='#FF6000'
      />
      <path
        d='M7.664 14.71l.671.412.65.284-.608-.383-.713-.312z'
        fill='#FF7E00'
      />
      <path
        d='M5.802 14.134l.453.541.696-.08-.389-.55-.76.09z'
        fill='#FF6C00'
      />
      <path
        d='M11.276 10.56l-.152 1.179.911 1.271.189-1.126-.948-1.324z'
        fill='#FF1E00'
      />
      <path
        d='M9.724 16.196l.486.278.542.754-.432-.203-.596-.829z'
        fill='#FFA700'
      />
      <path
        d='M9.132 8.695l-.069 1.25 1.06.763.112-1.22-1.103-.793z'
        fill='#C80000'
      />
      <path
        d='M8.377 15.023l.607.384.63.454-.544-.338-.693-.5z'
        fill='#FF8600'
      />
      <path
        d='M4.796 12.082l-.025.922.843-.358.084-.949-.902.386z'
        fill='#FF3000'
      />
      <path
        d='M12.833 14.486l-.366.946.632 1.558.397-.865-.663-1.639z'
        fill='#FF8900'
      />
      <path
        d='M9.07 15.523l.544.339.595.612-.486-.277-.654-.674z'
        fill='#FF9400'
      />
      <path
        d='M10.236 9.488l-.112 1.22 1 1.032.152-1.179-1.04-1.073z'
        fill='#E40000'
      />
      <path
        d='M13.098 16.99l-.503.715.46 1.574.53-.619-.487-1.67z'
        fill='#FFC800'
      />
      <path
        d='M4.77 13.005l.066.784.782-.33-.004-.813-.843.358z'
        fill='#FF4A00'
      />
      <path
        d='M10.82 17.755l.023.23.436 1.068.019-.13-.478-1.168z'
        fill='#FFD300'
      />
      <path
        d='M11.593 18.665l-.295.258.37 1.253.326-.15-.401-1.361z'
        fill='#FEED00'
      />
      <path
        d='M6.88 9.303l-.08 1.192 1.04.164.134-1.186-1.093-.17z'
        fill='#CD0000'
      />
      <path
        d='M6.562 14.045l.388.55.714.116-.322-.539-.78-.127z'
        fill='#FF6400'
      />
      <path
        d='M5.787 10.622l-.089 1.076.954-.117.147-1.085-1.012.126z'
        fill='#F10800'
      />
      <path
        d='M12.595 17.706l-.535.557.432 1.47.563-.453-.46-1.574z'
        fill='#FFD300'
      />
      <path
        d='M5.617 13.46l.184.675.76-.09-.117-.684-.827.099z'
        fill='#FF5200'
      />
      <path
        d='M12.06 18.263l-.467.402.401 1.362.499-.294-.432-1.47z'
        fill='#FFE200'
      />
      <path
        d='M10.248 16.703l.072.322.523.961-.022-.23-.573-1.053z'
        fill='#FFB200'
      />
      <path
        d='M12.035 13.012l-.329 1.017.76 1.404.367-.945-.798-1.476z'
        fill='#FF5900'
      />
      <path
        d='M7.343 14.172l.322.54.713.311-.255-.51-.78-.341z'
        fill='#FF6400'
      />
      <path
        d='M5.698 11.698l-.085.949.892-.108.147-.958-.954.117z'
        fill='#F20'
      />
      <path
        d='M11.074 17.395l-.254.36.478 1.169.295-.259-.519-1.27z'
        fill='#FFC400'
      />
      <path
        d='M5.613 12.647l.004.812.826-.098.062-.822-.892.108z'
        fill='#FF3800'
      />
      <path
        d='M12.467 15.433l-.469.804.597 1.47.503-.716-.631-1.558z'
        fill='#FF9400'
      />
      <path
        d='M7.973 9.474l-.134 1.186 1.039.45.186-1.164-1.091-.472z'
        fill='#D10000'
      />
      <path
        d='M9.596 15.797l.128.4.596.828-.072-.321-.652-.907z'
        fill='#FF9400'
      />
      <path
        d='M8.122 14.514l.255.51.693.5-.19-.464-.758-.546z'
        fill='#FF6C00'
      />
      <path d='M8.88 15.06l.19.463.653.673-.128-.4-.715-.736z' fill='#FF7E00' />
      <path
        d='M11.123 11.74l-.285 1.078.868 1.21.328-1.017-.91-1.272z'
        fill='#FF3000'
      />
      <path
        d='M6.444 13.361l.118.684.781.128-.05-.674-.849-.138z'
        fill='#FF4A00'
      />
      <path
        d='M6.799 10.496l-.147 1.085.98.156.207-1.077-1.04-.164z'
        fill='#E80000'
      />
      <path
        d='M9.064 9.946l-.186 1.165 1.01.726.237-1.129-1.06-.762z'
        fill='#DF0000'
      />
      <path
        d='M11.502 16.89l-.428.504.519 1.27.468-.402-.559-1.371z'
        fill='#FFB200'
      />
      <path
        d='M10.124 10.707l-.237 1.129.951.981.286-1.079-1-1.031z'
        fill='#FA0F00'
      />
      <path
        d='M11.998 16.236l-.496.655.559 1.372.534-.558-.597-1.469z'
        fill='#FFA300'
      />
      <path
        d='M10.452 16.25l-.204.453.573 1.052.253-.36-.622-1.145z'
        fill='#FF9F00'
      />
      <path
        d='M11.706 14.028l-.426.886.718 1.323.468-.805-.76-1.404z'
        fill='#FF6800'
      />
      <path
        d='M6.506 12.538l-.062.822.85.138.128-.813-.916-.147z'
        fill='#FF3000'
      />
      <path
        d='M7.293 13.498l.05.674.78.341.018-.645-.848-.37z'
        fill='#FF4A00'
      />
      <path
        d='M6.653 11.581l-.147.958.916.147.211-.949-.98-.156z'
        fill='#FF1A00'
      />
      <path
        d='M9.743 15.264l-.147.532.652.907.204-.453-.71-.986z'
        fill='#FF7E00'
      />
      <path
        d='M7.839 10.66l-.206 1.077.98.426.265-1.052-1.04-.45z'
        fill='#ED0400'
      />
      <path d='M8.14 13.87l-.018.644.758.546.084-.597-.824-.594z' fill='#F50' />
      <path
        d='M10.831 15.655l-.379.595.623 1.145.427-.504-.67-1.236z'
        fill='#FF8D00'
      />
      <path
        d='M8.965 14.463l-.084.597.715.737.147-.533-.778-.801z'
        fill='#FF6800'
      />
      <path
        d='M11.28 14.914l-.449.742.671 1.235.496-.654-.717-1.323z'
        fill='#FF7A00'
      />
      <path
        d='M10.839 12.818l-.377.956.819 1.14.426-.886-.868-1.21z'
        fill='#FF4300'
      />
      <path
        d='M7.421 12.685l-.129.813.848.37.196-.783-.915-.4z'
        fill='#FF3400'
      />
      <path
        d='M8.877 11.11l-.265 1.053.952.685.323-1.012-1.01-.726z'
        fill='#FA0F00'
      />
      <path
        d='M7.633 11.736l-.211.95.915.399.276-.923-.98-.426z'
        fill='#FF1A00'
      />
      <path
        d='M9.887 11.836l-.323 1.011.898.926.377-.955-.952-.982z'
        fill='#F20'
      />
      <path
        d='M10.065 14.59l-.323.674.71.987.379-.595-.766-1.065z'
        fill='#FF6800'
      />
      <path
        d='M10.462 13.773l-.397.817.766 1.065.45-.741-.819-1.14z'
        fill='#F50'
      />
      <path
        d='M8.337 13.086l-.196.784.824.594.261-.738-.89-.64z'
        fill='#FF3B00'
      />
      <path
        d='M9.226 13.726l-.261.736.777.802.323-.674-.839-.864z'
        fill='#FF4E00'
      />
      <path
        d='M8.612 12.163l-.275.922.89.64.337-.877-.952-.685z'
        fill='#FF2500'
      />
      <path
        d='M9.563 12.848l-.337.877.838.865.397-.817-.898-.925z'
        fill='#FF3800'
      />
    </svg>
  )
})

export const Dark = React.forwardRef(function Dark(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M19 12.63A7.015 7.015 0 1111.37 5 5.456 5.456 0 0019 12.63z'
      />
    </svg>
  )
})

export const Deposit = React.forwardRef(function Deposit(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5 3h14a3 3 0 011 5.82V18a3 3 0 01-3 3H7a3 3 0 01-3-3V8.82A3 3 0 015 3zm9 10h-4a1 1 0 010-2h4a1 1 0 110 2zm4 5a1 1 0 01-1 1H7a1 1 0 01-1-1V9h12v9zM5 7h14a1 1 0 100-2H5a1 1 0 100 2z'
      />
    </svg>
  )
})

export const Edit = React.forwardRef(function Edit(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <path d='M7.414 14.586l5.657-5.657 2.121 2.121-5.656 5.657-2.475.354.353-2.475zm6.364-6.364l1.06-1.06a1 1 0 011.415 0l.707.706a1 1 0 010 1.414l-1.06 1.061-2.122-2.121z' />
    </svg>
  )
})

export const Email = React.forwardRef(function Email(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12.41 11.018C11.044 11.018 4 7.024 4 7.024V6.4A1.4 1.4 0 015.401 5H19.42c.774 0 1.402.627 1.402 1.4l-.011.7s-6.968 3.918-8.4 3.918z'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12.41 12.943c1.5 0 8.4-3.743 8.4-3.743l.012 8.4A1.4 1.4 0 0119.42 19H5.4A1.401 1.401 0 014 17.6l.011-8.4s7.032 3.743 8.4 3.743z'
      />
    </svg>
  )
})

export const Error = React.forwardRef(function Error(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={60}
      height={60}
      viewBox='0 0 60 60'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M30 58c15.464 0 28-12.536 28-28S45.464 2 30 2 2 14.536 2 30s12.536 28 28 28zm0 2c16.569 0 30-13.431 30-30C60 13.431 46.569 0 30 0 13.431 0 0 13.431 0 30c0 16.569 13.431 30 30 30z'
        fill='#E14D4D'
      />
      <path
        d='M23.071 37.071a1 1 0 001.414 0l5.657-5.657 5.657 5.657a1 1 0 001.414-1.414L31.556 30l5.657-5.657A1 1 0 0035.8 22.93l-5.657 5.657-5.657-5.657a1 1 0 00-1.414 1.414L28.728 30l-5.657 5.657a1 1 0 000 1.414z'
        fill='#E14D4D'
      />
    </svg>
  )
})

export const Eth = React.forwardRef(function Eth(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <path opacity={0.6} d='M11.999 3.75v6.098l5.248 2.303-5.248-8.401z' />
      <path d='M11.999 3.75L6.75 12.151l5.249-2.303V3.75z' />
      <path opacity={0.6} d='M11.999 16.103v4.143l5.251-7.135L12 16.103z' />
      <path d='M11.999 20.246v-4.144L6.75 13.111l5.249 7.135z' />
      <path opacity={0.2} d='M11.999 15.144l5.248-2.993-5.248-2.301v5.294z' />
      <path opacity={0.6} d='M6.75 12.151l5.249 2.993V9.85l-5.249 2.3z' />
    </svg>
  )
})

export const Exodus = React.forwardRef(function Exodus(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={48}
      height={48}
      viewBox='0 0 48 48'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <path
        d='M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24z'
        fill='#1E1C32'
      />
      <g clipPath='url(#prefix__prefix__clip0_12052_1670)'>
        <path
          d='M38.755 17.375L25.98 9v4.683l8.195 5.326-.964 3.05H25.98v3.881h7.231l.964 3.051-8.195 5.326V39l12.775-8.35-2.089-6.637 2.09-6.637z'
          fill='url(#prefix__prefix__paint0_linear_12052_1670)'
        />
        <path
          d='M14.865 25.94h7.205v-3.881h-7.232l-.937-3.051 8.169-5.326V9L9.294 17.375l2.09 6.637-2.09 6.637L22.096 39v-4.683l-8.195-5.326.964-3.05z'
          fill='url(#prefix__prefix__paint1_linear_12052_1670)'
        />
        <mask
          id='prefix__a'
          maskUnits='userSpaceOnUse'
          x={9}
          y={8}
          width={30}
          height={31}
        >
          <path
            d='M38.755 17.375L25.98 9v4.683l8.195 5.326-.964 3.05H25.98v3.881h7.231l.964 3.051-8.195 5.326V39l12.775-8.35-2.089-6.637 2.09-6.637z'
            fill='url(#prefix__prefix__paint2_linear_12052_1670)'
          />
          <path
            d='M14.865 25.94h7.205v-3.881h-7.232l-.937-3.051 8.169-5.326V9L9.294 17.375l2.09 6.637-2.09 6.637L22.096 39v-4.683l-8.195-5.326.964-3.05z'
            fill='url(#prefix__prefix__paint3_linear_12052_1670)'
          />
        </mask>
        <g mask='url(#prefix__a)'>
          <path
            d='M38.56 8.999H9.31v30h29.25v-30z'
            fill='url(#prefix__prefix__paint4_linear_12052_1670)'
          />
        </g>
      </g>
      <defs>
        <linearGradient
          id='prefix__prefix__paint0_linear_12052_1670'
          x1={34.622}
          y1={41.062}
          x2={26.065}
          y2={5.704}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#0B46F9' />
          <stop offset={1} stopColor='#BBFBE0' />
        </linearGradient>
        <linearGradient
          id='prefix__prefix__paint1_linear_12052_1670'
          x1={34.622}
          y1={41.062}
          x2={26.065}
          y2={5.704}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#0B46F9' />
          <stop offset={1} stopColor='#BBFBE0' />
        </linearGradient>
        <linearGradient
          id='prefix__prefix__paint2_linear_12052_1670'
          x1={34.622}
          y1={41.062}
          x2={26.065}
          y2={5.704}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#0B46F9' />
          <stop offset={1} stopColor='#BBFBE0' />
        </linearGradient>
        <linearGradient
          id='prefix__prefix__paint3_linear_12052_1670'
          x1={34.622}
          y1={41.062}
          x2={26.065}
          y2={5.704}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#0B46F9' />
          <stop offset={1} stopColor='#BBFBE0' />
        </linearGradient>
        <linearGradient
          id='prefix__prefix__paint4_linear_12052_1670'
          x1={11.185}
          y1={15.749}
          x2={25.997}
          y2={26.811}
          gradientUnits='userSpaceOnUse'
        >
          <stop offset={0.12} stopColor='#8952FF' stopOpacity={0.87} />
          <stop offset={1} stopColor='#DABDFF' stopOpacity={0} />
        </linearGradient>
        <clipPath id='prefix__prefix__clip0_12052_1670'>
          <path
            fill='#fff'
            transform='translate(9.196 8.999)'
            d='M0 0h29.609v30H0z'
          />
        </clipPath>
      </defs>
    </svg>
  )
})

export const External = React.forwardRef(function External(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.333 7.75a.583.583 0 00-.583.583v7.334c0 .322.261.583.583.583h7.334a.583.583 0 00.583-.583v-2a.75.75 0 011.5 0v2c0 1.15-.933 2.083-2.083 2.083H8.333a2.083 2.083 0 01-2.083-2.083V8.333c0-1.15.933-2.083 2.083-2.083h2a.75.75 0 010 1.5h-2zm5.667 0a.75.75 0 010-1.5h3a.748.748 0 01.75.75v3a.75.75 0 01-1.5 0V8.81l-4.053 4.054a.75.75 0 01-1.06-1.061l4.052-4.053H14z'
      />
    </svg>
  )
})

export const Facebook = React.forwardRef(function Facebook(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12.964 20v-8h2.209l.293-2.758h-2.502l.004-1.38c0-.72.068-1.105 1.101-1.105h1.38V4h-2.208c-2.653 0-3.587 1.338-3.587 3.587v1.655H8V12h1.654v8h3.31z'
      />
    </svg>
  )
})

export const Gamestop = React.forwardRef(function Gamestop(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={48}
      height={48}
      viewBox='0 0 48 48'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <path
        d='M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24z'
        fill='#000'
      />
      <path
        d='M32.48 22.374h-2.615v-4.891c0-.661-.075-1.137-.436-1.137-.36 0-.436.476-.436 1.137v4.891H26.38v-4.891c0-.661-.075-1.137-.436-1.137-.36 0-.436.476-.436 1.137v4.891h-2.615v-7.47h2.617v.776a1.86 1.86 0 01.705-.686c.293-.161.624-.242.96-.233.713 0 1.332.256 1.722.99a1.8 1.8 0 01.701-.743c.301-.175.647-.261.996-.247 1.014 0 1.888.642 1.888 2.26l-.002 5.353zm-13.103-3.73c-.349.286-.873.586-.873 1.495 0 .612.158.862.438.862s.435-.25.435-.862v-1.495zm-.37-3.883c1.736 0 2.985.596 2.985 2.471v5.142h-2.615v-.647c-.28.44-.785.783-1.6.783-.562 0-1.873-.191-1.873-2.132 0-2.657 3.471-1.746 3.471-3.361 0-.661-.158-.93-.437-.93-.28 0-.436.269-.436.93v.41H16.02v-.19c0-1.876 1.251-2.472 2.987-2.472v-.004zm17.877 4.614h2.485c-.035 2.174-1.302 3.142-3.051 3.142-1.75 0-3.051-.987-3.051-3.228v-1.3c0-2.24 1.278-3.228 3.05-3.228 1.773 0 3.052.987 3.052 3.228v.783h-3.485v1.278c0 .659.085 1.134.5 1.134.414 0 .5-.476.5-1.134v-.675zm-.123-2.154c0-.66-.075-1.135-.436-1.135-.36 0-.436.476-.436 1.135v.395h.872v-.395zm-21.6-.715v-.381c0-2.585-1.558-3.284-3.278-3.284s-3.251.919-3.251 3.505v2.657c0 1.74.744 3.514 2.736 3.514.914 0 1.5-.437 1.753-.852l.207.717h1.82v-4.955h-3.163v1.597h.712v.334c0 .812-.114 1.555-.63 1.555-.518 0-.63-.743-.63-1.555v-3.404c0-.79.053-1.516.454-1.516s.453.726.453 1.516v.552h2.818zm7.432 16.632a3.9 3.9 0 01-1.5.3c-1.24 0-1.971-.7-1.971-2.029v-4.595h-.527v-.99h.527v-1.012h2.613v1.012h.858v.99h-.858v4.479c0 .483.087.907.51.907a.666.666 0 00.348-.1v1.04-.002zm-7.084-6.324h2.594v-.401c0-1.836-1.237-2.651-3.074-2.651-1.754 0-3.074.972-3.074 2.674 0 3.19 3.645 2.483 3.645 4.647 0 .573-.225.764-.5.764-.273 0-.497-.191-.497-.764v-.791h-2.617v.382c0 1.916 1.26 2.764 3.153 2.764 1.81 0 3.16-.997 3.16-2.781 0-3.555-3.75-2.57-3.75-4.537 0-.573.234-.764.48-.764.247 0 .48.191.48.764v.694zm10.927 1.337c0-.66-.075-1.135-.435-1.135s-.436.476-.436 1.135v2.819c0 .659.075 1.134.436 1.134.36 0 .435-.475.435-1.134v-2.82zm-.435-2.46c1.772 0 3.05.987 3.05 3.228v1.293c0 2.24-1.278 3.228-3.05 3.228-1.772 0-3.05-.988-3.05-3.228v-1.303c0-2.24 1.276-3.228 3.05-3.228v.01zm7.328 2.712c0-.661-.075-1.137-.436-1.137-.36 0-.435.476-.435 1.137v2.307c0 .66.075 1.135.435 1.135.361 0 .436-.476.436-1.135v-2.307zm.664-2.722c1.236 0 1.951.988 1.951 3.228v1.293c0 2.24-.715 3.228-1.951 3.228a1.879 1.879 0 01-1.543-.797v2.524h-2.6v-9.333h2.615v.653a1.879 1.879 0 011.543-.796h-.015zm1.612.415c.024.042.06.077.102.1a.26.26 0 00.143.039.268.268 0 00.139-.036.272.272 0 00.102-.102.263.263 0 00.038-.139.268.268 0 00-.142-.24.269.269 0 00-.137-.037.296.296 0 00-.14.036.264.264 0 00-.103.104.265.265 0 00-.039.137.28.28 0 00.037.138zm.036-.256a.244.244 0 01.146-.113.24.24 0 01.271.113.234.234 0 01-.089.324.222.222 0 01-.12.033.232.232 0 01-.12-.033.238.238 0 01-.09-.086.241.241 0 01.002-.238zm.292-.02a.134.134 0 00-.09-.024h-.086v.324h.049v-.131h.04l.079.13h.054l-.085-.142a.11.11 0 00.05-.036.093.093 0 00-.011-.122v.002zm-.127.02h.033a.106.106 0 01.055.011.04.04 0 01.014.017.046.046 0 01.004.021c0 .038-.026.056-.073.056h-.033v-.105z'
        fill='#fff'
      />
    </svg>
  )
})

export const History = React.forwardRef(function History(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M20 8.94a.887.887 0 00-.25-.64l-6-6c-.198-.186-.406-.3-.69-.3H7a3 3 0 00-3 3v14a3 3 0 003 3h10a3 3 0 003-3V8.94zm-6-3.53L16.59 8H14V5.41zM17 20a1 1 0 001-1v-9h-5a1 1 0 01-1-1V4H7a1 1 0 00-1 1v14a1 1 0 001 1h10z'
      />
    </svg>
  )
})

export const ImtokenCircle = React.forwardRef(function ImtokenCircle(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={48}
      height={49}
      viewBox='0 0 48 49'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <rect
        y={0.002}
        width={48}
        height={48}
        rx={24}
        fill='url(#prefix__prefix__paint0_linear_10169:6069)'
      />
      <path
        d='M36.932 15.606c.858 11.153-6.607 16.427-13.3 16.99-6.221.522-12.077-3.15-12.592-8.792-.423-4.661 2.576-6.645 4.932-6.843 2.424-.204 4.46 1.401 4.638 3.345.17 1.869-1.043 2.72-1.888 2.79a1.46 1.46 0 01-1.043-.27 1.35 1.35 0 01-.54-.9c-.066-.718.218-.816.149-1.579-.123-1.358-1.357-1.516-2.033-1.46-.817.068-2.3.985-2.092 3.267.21 2.302 2.508 4.12 5.52 3.867 3.25-.272 5.513-2.702 5.684-6.113-.002-.18.038-.359.115-.523v-.004c.035-.072.076-.14.123-.206.082-.116.173-.227.273-.33 0-.004 0-.004.003-.004.084-.09.184-.188.298-.294 1.422-1.286 6.536-4.321 11.372-3.36a.489.489 0 01.264.149c.068.075.11.17.118.27'
        fill='#fff'
      />
      <defs>
        <linearGradient
          id='prefix__prefix__paint0_linear_10169:6069'
          x1={46.656}
          y1={1.49}
          x2={0.001}
          y2={47.858}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#11C4D1' />
          <stop offset={1} stopColor='#0062AD' />
        </linearGradient>
      </defs>
    </svg>
  )
})

export const Imtoken = React.forwardRef(function Imtoken(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={40}
      height={40}
      viewBox='0 0 40 40'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <path
        d='M39.896 27.443s0 4.146-.443 5.926a8.333 8.333 0 01-2.186 3.96c-.928.92-2.152 1.76-4 2.198-1.876.437-5.918.416-5.918.416H12.651s-4.147 0-5.938-.438c-1.786-.458-3.052-1.276-3.973-2.198-.928-.92-1.77-2.135-2.193-4C.104 31.443.125 27.42.125 27.42V12.76s0-4.147.443-5.927A8.32 8.32 0 012.76 2.875c.923-.922 2.147-1.755 4-2.198C8.63.24 12.672.26 12.672.26h14.697s4.147 0 5.938.437c1.786.464 3.053 1.276 3.98 2.199.921.921 1.765 2.14 2.186 4 .423 1.864.423 5.885.423 5.885v14.662z'
        fill='url(#prefix__prefix__paint0_linear)'
      />
      <path
        d='M33.661 12.387c.823 11.285-6.713 16.649-13.473 17.233-6.272.547-12.167-3.141-12.672-8.86-.423-4.707 2.61-6.739 4.99-6.932 2.442-.208 4.483 1.407 4.671 3.375.172 1.885-1.053 2.76-1.912 2.828-.677.062-1.514-.338-1.604-1.176-.062-.73.235-.814.151-1.59-.13-1.385-1.37-1.53-2.04-1.468-.824.063-2.32 1.006-2.132 3.312.213 2.323 2.527 4.167 5.557 3.891 3.287-.292 5.584-2.74 5.751-6.197 0-.188.041-.355.125-.522.04-.062.063-.125.124-.186a2.49 2.49 0 01.276-.34l.298-.291c1.426-1.297 6.609-4.396 11.469-3.433.047 0 .088.021.11.042.186 0 .29.147.311.312'
        fill='#fff'
      />
      <defs>
        <linearGradient
          id='prefix__prefix__paint0_linear'
          x1={38.783}
          y1={1.49}
          x2={0.211}
          y2={39.909}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#11C4D1' />
          <stop offset={1} stopColor='#0062AD' />
        </linearGradient>
      </defs>
    </svg>
  )
})

export const Ldo = React.forwardRef(function Ldo(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <path
        d='M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11z'
        fill='#F69988'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12.005 4.223l3.859 6.025-3.859 2.244-3.858-2.244 3.858-6.025zm-2.677 5.74l2.677-4.18 2.677 4.18-2.677 1.557-2.677-1.557z'
        fill='#fff'
      />
      <path
        d='M12 13.816l-4.477-2.603-.122.191a5.433 5.433 0 00.74 6.78 5.467 5.467 0 007.718 0 5.432 5.432 0 00.74-6.78l-.122-.19L12 13.816z'
        fill='#fff'
      />
    </svg>
  )
})

export const Ldopl = React.forwardRef(function Ldopl(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <path
        d='M7.078 11.148l-.135.206a5.788 5.788 0 00.814 7.32 6.043 6.043 0 004.24 1.72l-4.92-9.246z'
        fill='#D219B8'
      />
      <path
        opacity={0.6}
        d='M11.997 13.958l-4.92-2.81 4.92 9.246v-6.436zm4.925-2.81l.134.206a5.788 5.788 0 01-.813 7.32 6.043 6.043 0 01-4.24 1.72l4.92-9.246z'
        fill='#D219B8'
      />
      <path
        opacity={0.2}
        d='M12.002 13.958l4.92-2.81-4.92 9.246v-6.436zm.001-6.278v4.847l4.238-2.422-4.238-2.425z'
        fill='#D219B8'
      />
      <path
        opacity={0.6}
        d='M12.003 7.68l-4.24 2.425 4.24 2.422V7.68z'
        fill='#D219B8'
      />
      <path d='M12.003 3.604l-4.24 6.502 4.24-2.431V3.604z' fill='#D219B8' />
      <path
        opacity={0.6}
        d='M12.003 7.674l4.241 2.432-4.24-6.506v4.074z'
        fill='#D219B8'
      />
    </svg>
  )
})

export const LedgerCircleInversion = React.forwardRef(
  function LedgerCircleInversion(
    props: React.SVGProps<SVGSVGElement>,
    svgRef?: React.Ref<SVGSVGElement>,
  ) {
    return (
      <svg
        width={48}
        height={48}
        viewBox='0 0 48 48'
        fill='currentColor'
        ref={svgRef}
        {...props}
      >
        <circle cx={24} cy={24} r={24} fill='#fff' />
        <path
          d='M10 29.34v6.876h10.464v-1.525h-8.94v-5.35H10zm26.294 0v5.351h-8.94v1.525h10.464V29.34h-1.524zM20.479 18.876V29.34h6.876v-1.375h-5.352v-9.089H20.48zM10 12v6.876h1.525v-5.351h8.939V12H10zm17.355 0v1.525h8.939v5.351h1.524V12H27.355z'
          fill='#000'
        />
      </svg>
    )
  },
)

export const LedgerCircle = React.forwardRef(function LedgerCircle(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={48}
      height={48}
      viewBox='0 0 48 48'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <circle cx={24} cy={24} r={24} fill='#000' />
      <path
        d='M10 29.34v6.876h10.464v-1.525h-8.94v-5.35H10zm26.294 0v5.351h-8.94v1.525h10.464V29.34h-1.524zM20.479 18.876V29.34h6.876v-1.375h-5.352v-9.089H20.48zM10 12v6.876h1.525v-5.351h8.939V12H10zm17.355 0v1.525h8.939v5.351h1.524V12H27.355z'
        fill='#fff'
      />
    </svg>
  )
})

export const LedgerConfirm = React.forwardRef(function LedgerConfirm(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={354}
      height={43}
      viewBox='0 0 354 43'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <rect
        x={58}
        y={6}
        width={238}
        height={36}
        rx={5}
        fill='#F6F7FB'
        stroke='#172340'
        strokeWidth={2}
      />
      <path
        d='M83 24a7 7 0 10-14 0 7 7 0 0014 0z'
        fill='#F6F7FB'
        stroke='#172340'
      />
      <path
        d='M81 24a5 5 0 10-10 0 5 5 0 0010 0z'
        fill='#136BFF'
        fillOpacity={0.15}
      />
      <path
        d='M76 19.5a4.5 4.5 0 110 9 4.5 4.5 0 010-9z'
        stroke='#136BFF'
        strokeOpacity={0.35}
      />
      <path d='M77 24a1 1 0 10-2 0 1 1 0 002 0z' fill='#136BFF' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M76 0c.276 0 .5.138.5.308v23.384c0 .17-.224.308-.5.308s-.5-.138-.5-.308V.308c0-.17.224-.308.5-.308z'
        fill='url(#prefix__prefix__paint0_linear_10116:2145)'
      />
      <rect
        x={96.597}
        y={10.597}
        width={60.807}
        height={26.807}
        rx={3.403}
        fill='#fff'
        stroke='#172340'
        strokeWidth={1.193}
      />
      <path
        d='M168 24c0-9.941 8.059-18 18-18h105.046A4.954 4.954 0 01296 10.954v26.092A4.954 4.954 0 01291.046 42H186c-9.941 0-18-8.059-18-18z'
        fill='#fff'
        stroke='#172340'
        strokeWidth={2}
      />
      <path
        d='M193 24a7 7 0 10-14 0 7 7 0 0014 0z'
        fill='#F6F7FB'
        stroke='#172340'
      />
      <path
        d='M191 24a5 5 0 10-10 0 5 5 0 0010 0z'
        fill='#136BFF'
        fillOpacity={0.15}
      />
      <path
        d='M186 19.5a4.5 4.5 0 110 9 4.5 4.5 0 010-9z'
        stroke='#136BFF'
        strokeOpacity={0.35}
      />
      <path d='M187 24a1 1 0 10-2 0 1 1 0 002 0z' fill='#136BFF' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M186 0c.276 0 .5.138.5.308v23.384c0 .17-.224.308-.5.308s-.5-.138-.5-.308V.308c0-.17.224-.308.5-.308z'
        fill='url(#prefix__prefix__paint1_linear_10116:2145)'
      />
      <path
        d='M44 21a3 3 0 013-3h9.613c.766 0 1.387.62 1.387 1.387v9.226C58 29.38 57.38 30 56.613 30H47a3 3 0 01-3-3v-6z'
        fill='#fff'
        stroke='#172340'
        strokeWidth={2}
      />
      <path
        d='M34.5 22.387c0-1.042.845-1.887 1.887-1.887h6.42c.383 0 .693.31.693.693v5.614c0 .383-.31.693-.693.693h-6.42a1.887 1.887 0 01-1.887-1.887v-3.226z'
        fill='#fff'
        stroke='#172340'
      />
      <path
        d='M.5 22.5h34v3H.5v-3z'
        fill='url(#prefix__prefix__paint2_linear_10116:2145)'
        stroke='url(#prefix__prefix__paint3_linear_10116:2145)'
      />
      <defs>
        <linearGradient
          id='prefix__prefix__paint0_linear_10116:2145'
          x1={76.5}
          y1={0.308}
          x2={76.5}
          y2={23.692}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#136BFF' stopOpacity={0} />
          <stop offset={1} stopColor='#136BFF' />
        </linearGradient>
        <linearGradient
          id='prefix__prefix__paint1_linear_10116:2145'
          x1={186.5}
          y1={0.308}
          x2={186.5}
          y2={23.692}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#136BFF' stopOpacity={0} />
          <stop offset={1} stopColor='#136BFF' />
        </linearGradient>
        <linearGradient
          id='prefix__prefix__paint2_linear_10116:2145'
          x1={35.473}
          y1={24}
          x2={0}
          y2={24}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#fff' />
          <stop offset={1} stopColor='#fff' stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id='prefix__prefix__paint3_linear_10116:2145'
          x1={35}
          y1={26}
          x2={2.838}
          y2={26}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#172340' />
          <stop offset={1} stopColor='#172340' stopOpacity={0} />
        </linearGradient>
      </defs>
    </svg>
  )
})

export const LedgerFail = React.forwardRef(function LedgerFail(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={354}
      height={38}
      viewBox='0 0 354 38'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <rect
        x={58}
        y={1}
        width={238}
        height={36}
        rx={5}
        fill='#F6F7FB'
        stroke='#172340'
        strokeWidth={2}
      />
      <path
        d='M83 19a7 7 0 10-14 0 7 7 0 0014 0z'
        fill='#F6F7FB'
        stroke='#172340'
      />
      <rect
        x={96.597}
        y={5.597}
        width={60.807}
        height={26.807}
        rx={3.403}
        fill='#fff'
        stroke='#172340'
        strokeWidth={1.193}
      />
      <path
        d='M122.199 23.801a.679.679 0 00.96 0l3.841-3.84 3.841 3.84a.679.679 0 10.96-.96L127.96 19l3.841-3.84a.68.68 0 00-.96-.961L127 18.039l-3.841-3.84a.679.679 0 10-.96.96L126.04 19l-3.841 3.84a.68.68 0 000 .961z'
        fill='#E14D4D'
      />
      <path
        d='M168 19c0-9.941 8.059-18 18-18h105.046A4.954 4.954 0 01296 5.954v26.092A4.954 4.954 0 01291.046 37H186c-9.941 0-18-8.059-18-18z'
        fill='#fff'
        stroke='#172340'
        strokeWidth={2}
      />
      <path
        d='M193 19a7 7 0 10-14 0 7 7 0 0014 0z'
        fill='#F6F7FB'
        stroke='#172340'
      />
      <path
        d='M44 16a3 3 0 013-3h9.613c.766 0 1.387.62 1.387 1.387v9.226C58 24.38 57.38 25 56.613 25H47a3 3 0 01-3-3v-6z'
        fill='#fff'
        stroke='#172340'
        strokeWidth={2}
      />
      <path
        d='M34.5 17.387c0-1.042.845-1.887 1.887-1.887h6.42c.383 0 .693.31.693.693v5.614c0 .383-.31.693-.693.693h-6.42a1.887 1.887 0 01-1.887-1.887v-3.226z'
        fill='#fff'
        stroke='#172340'
      />
      <path
        d='M.5 17.5h34v3H.5v-3z'
        fill='url(#prefix__prefix__paint0_linear_10549_10810)'
        stroke='url(#prefix__prefix__paint1_linear_10549_10810)'
      />
      <defs>
        <linearGradient
          id='prefix__prefix__paint0_linear_10549_10810'
          x1={35.473}
          y1={19}
          x2={0}
          y2={19}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#fff' />
          <stop offset={1} stopColor='#fff' stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id='prefix__prefix__paint1_linear_10549_10810'
          x1={35}
          y1={21}
          x2={2.838}
          y2={21}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#172340' />
          <stop offset={1} stopColor='#172340' stopOpacity={0} />
        </linearGradient>
      </defs>
    </svg>
  )
})

export const LedgerLoading = React.forwardRef(function LedgerLoading(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={354}
      height={38}
      viewBox='0 0 354 38'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <rect
        x={58}
        y={1}
        width={238}
        height={36}
        rx={5}
        fill='#F6F7FB'
        stroke='#172340'
        strokeWidth={2}
      />
      <path
        d='M83 19a7 7 0 10-14 0 7 7 0 0014 0z'
        fill='#F6F7FB'
        stroke='#172340'
      />
      <rect
        x={96.597}
        y={5.597}
        width={60.807}
        height={26.807}
        rx={3.403}
        fill='#fff'
        stroke='#172340'
        strokeWidth={1.193}
      />
      <circle
        opacity={0.1}
        cx={127}
        cy={19}
        r={6}
        stroke='#00A3FF'
        strokeWidth={2}
      />
      <path
        d='M131.555 22.905A6 6 0 00127 13'
        stroke='#00A3FF'
        strokeWidth={2}
        strokeLinecap='round'
      >
        <animateTransform
          attributeName='transform'
          attributeType='XML'
          type='rotate'
          from='0 127 19'
          to='360 127 19'
          dur='1s'
          repeatCount='indefinite'
        />
      </path>
      <path
        d='M168 19c0-9.941 8.059-18 18-18h105.046A4.954 4.954 0 01296 5.954v26.092A4.954 4.954 0 01291.046 37H186c-9.941 0-18-8.059-18-18z'
        fill='#fff'
        stroke='#172340'
        strokeWidth={2}
      />
      <path
        d='M193 19a7 7 0 10-14 0 7 7 0 0014 0z'
        fill='#F6F7FB'
        stroke='#172340'
      />
      <path
        d='M44 16a3 3 0 013-3h9.613c.766 0 1.387.62 1.387 1.387v9.226C58 24.38 57.38 25 56.613 25H47a3 3 0 01-3-3v-6z'
        fill='#fff'
        stroke='#172340'
        strokeWidth={2}
      />
      <path
        d='M34.5 17.387c0-1.042.845-1.887 1.887-1.887h6.42c.383 0 .693.31.693.693v5.614c0 .383-.31.693-.693.693h-6.42a1.887 1.887 0 01-1.887-1.887v-3.226z'
        fill='#fff'
        stroke='#172340'
      />
      <path
        d='M.5 17.5h34v3H.5v-3z'
        fill='url(#prefix__prefix__paint0_linear_10116:2259)'
        stroke='url(#prefix__prefix__paint1_linear_10116:2259)'
      />
      <defs>
        <linearGradient
          id='prefix__prefix__paint0_linear_10116:2259'
          x1={35.473}
          y1={19}
          x2={0}
          y2={19}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#fff' />
          <stop offset={1} stopColor='#fff' stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id='prefix__prefix__paint1_linear_10116:2259'
          x1={35}
          y1={21}
          x2={2.838}
          y2={21}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#172340' />
          <stop offset={1} stopColor='#172340' stopOpacity={0} />
        </linearGradient>
      </defs>
    </svg>
  )
})

export const LedgerSuccess = React.forwardRef(function LedgerSuccess(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={354}
      height={38}
      viewBox='0 0 354 38'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <rect
        x={58}
        y={1}
        width={238}
        height={36}
        rx={5}
        fill='#F6F7FB'
        stroke='#172340'
        strokeWidth={2}
      />
      <path
        d='M83 19a7 7 0 10-14 0 7 7 0 0014 0z'
        fill='#F6F7FB'
        stroke='#172340'
      />
      <rect
        x={96.597}
        y={5.597}
        width={60.807}
        height={26.807}
        rx={3.403}
        fill='#fff'
        stroke='#172340'
        strokeWidth={1.193}
      />
      <path
        d='M132 15l-6.875 6.875L122 18.75'
        stroke='#61B75F'
        strokeWidth={2}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M168 19c0-9.941 8.059-18 18-18h105.046A4.954 4.954 0 01296 5.954v26.092A4.954 4.954 0 01291.046 37H186c-9.941 0-18-8.059-18-18z'
        fill='#fff'
        stroke='#172340'
        strokeWidth={2}
      />
      <path
        d='M193 19a7 7 0 10-14 0 7 7 0 0014 0z'
        fill='#F6F7FB'
        stroke='#172340'
      />
      <path
        d='M44 16a3 3 0 013-3h9.613c.766 0 1.387.62 1.387 1.387v9.226C58 24.38 57.38 25 56.613 25H47a3 3 0 01-3-3v-6z'
        fill='#fff'
        stroke='#172340'
        strokeWidth={2}
      />
      <path
        d='M34.5 17.387c0-1.042.845-1.887 1.887-1.887h6.42c.383 0 .693.31.693.693v5.614c0 .383-.31.693-.693.693h-6.42a1.887 1.887 0 01-1.887-1.887v-3.226z'
        fill='#fff'
        stroke='#172340'
      />
      <path
        d='M.5 17.5h34v3H.5v-3z'
        fill='url(#prefix__prefix__paint0_linear_10116:2189)'
        stroke='url(#prefix__prefix__paint1_linear_10116:2189)'
      />
      <defs>
        <linearGradient
          id='prefix__prefix__paint0_linear_10116:2189'
          x1={35.473}
          y1={19}
          x2={0}
          y2={19}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#fff' />
          <stop offset={1} stopColor='#fff' stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id='prefix__prefix__paint1_linear_10116:2189'
          x1={35}
          y1={21}
          x2={2.838}
          y2={21}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#172340' />
          <stop offset={1} stopColor='#172340' stopOpacity={0} />
        </linearGradient>
      </defs>
    </svg>
  )
})

export const Ledger = React.forwardRef(function Ledger(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={40}
      height={40}
      viewBox='0 0 48 48'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <circle cx={24} cy={24} r={24} fill='#000' />
      <path
        d='M10 29.34v6.876h10.464v-1.525h-8.94v-5.35H10zm26.294 0v5.351h-8.94v1.525h10.464V29.34h-1.524zM20.479 18.876V29.34h6.876v-1.375h-5.352v-9.089H20.48zM10 12v6.876h1.525v-5.351h8.939V12H10zm17.355 0v1.525h8.939v5.351h1.524V12H27.355z'
        fill='#fff'
      />
    </svg>
  )
})

export const Light = React.forwardRef(function Light(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <path d='M12 3a1 1 0 011 1v1.455a1 1 0 11-2 0V4a1 1 0 011-1zm0 12.636a3.636 3.636 0 100-7.272 3.636 3.636 0 000 7.272zm1 2.91a1 1 0 10-2 0V20a1 1 0 102 0v-1.454zM5.635 5.634a1 1 0 011.414 0l1.033 1.033A1 1 0 116.668 8.08L5.635 7.048a1 1 0 010-1.414zm11.697 10.284a1 1 0 00-1.414 1.414l1.033 1.033a1 1 0 101.414-1.414l-1.033-1.033zM3 12a1 1 0 011-1h1.455a1 1 0 110 2H4a1 1 0 01-1-1zm15.546-1a1 1 0 100 2H20a1 1 0 100-2h-1.454zM8.082 15.918a1 1 0 010 1.414L7.05 18.365a1 1 0 11-1.414-1.414l1.033-1.033a1 1 0 011.414 0zm10.283-8.87a1 1 0 10-1.414-1.414l-1.033 1.033a1 1 0 001.414 1.414l1.033-1.033z' />
    </svg>
  )
})

export const Linkedin = React.forwardRef(function Linkedin(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <path d='M8.537 6.632C8.517 5.705 7.854 5 6.779 5 5.703 5 5 5.705 5 6.632c0 .907.682 1.632 1.738 1.632h.02c1.096 0 1.779-.725 1.779-1.632zm-.206 2.922H5.188V19H8.33V9.554zm7.719-.222c2.07 0 3.62 1.35 3.62 4.252V19h-3.144v-5.054c0-1.27-.455-2.135-1.593-2.135-.868 0-1.386.584-1.613 1.148-.083.202-.104.483-.104.766V19h-3.144s.042-8.56 0-9.446h3.145v1.338c.417-.643 1.164-1.56 2.833-1.56z' />
    </svg>
  )
})

export const LockSmall = React.forwardRef(function LockSmall(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <path d='M12 6a3.129 3.129 0 00-3.125 3.125V11H8.25C7.56 11 7 11.56 7 12.25V17c0 .69.56 1 1.25 1h7.5c.69 0 1.25-.31 1.25-1v-4.75c0-.69-.56-1.25-1.25-1.25h-.625V9.125A3.129 3.129 0 0012 6zm-1.875 3.125c0-1.034.841-1.875 1.875-1.875s1.875.841 1.875 1.875V11h-3.75V9.125zm2.5 5.702v.798a.625.625 0 11-1.25 0v-.798a1.245 1.245 0 01.354-2.298 1.25 1.25 0 011.521 1.221c0 .462-.252.86-.625 1.077z' />
    </svg>
  )
})

export const Lock = React.forwardRef(function Lock(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M17 7v2a3 3 0 013 3v7a3 3 0 01-3 3H7a3 3 0 01-3-3v-7a3 3 0 013-3V7a5 5 0 0110 0zm-6 7a1 1 0 112 0v3a1 1 0 11-2 0v-3zM9 7a3 3 0 116 0v2H9V7zm8 13a1 1 0 001-1v-7a1 1 0 00-1-1H7a1 1 0 00-1 1v7a1 1 0 001 1h10z'
      />
    </svg>
  )
})

export const MathWalletCircleInversion = React.forwardRef(
  function MathWalletCircleInversion(
    props: React.SVGProps<SVGSVGElement>,
    svgRef?: React.Ref<SVGSVGElement>,
  ) {
    return (
      <svg
        width={48}
        height={48}
        viewBox='0 0 48 48'
        fill='currentColor'
        ref={svgRef}
        {...props}
      >
        <circle cx={24} cy={24} r={24} fill='#fff' />
        <path
          d='M31.954 22.596a1.728 1.728 0 112.443-2.443 1.728 1.728 0 01-2.443 2.443zm-5.802 5.803a1.296 1.296 0 111.832-1.833 1.296 1.296 0 01-1.832 1.833zm9.162-3.054a1.296 1.296 0 111.832-1.833 1.296 1.296 0 01-1.832 1.833zm-3.054 3.054a1.296 1.296 0 111.832-1.833A1.296 1.296 0 0132.26 28.4zm6.413-.306a.864.864 0 111.222-1.221.864.864 0 01-1.222 1.221zm-3.054 3.054a.864.864 0 111.222-1.221.864.864 0 01-1.222 1.221zM28.9 25.65a1.728 1.728 0 112.444-2.443A1.728 1.728 0 0128.9 25.65zm0-6.108a1.728 1.728 0 112.443-2.443 1.728 1.728 0 01-2.443 2.443zm-3.054 3.054a1.728 1.728 0 112.443-2.443 1.728 1.728 0 01-2.443 2.443zm-6.136 0a1.728 1.728 0 112.443-2.443 1.728 1.728 0 01-2.443 2.443zm-5.803 5.803a1.296 1.296 0 111.833-1.833 1.296 1.296 0 01-1.833 1.833zm9.162-3.054a1.296 1.296 0 111.833-1.833 1.296 1.296 0 01-1.833 1.833zm-3.054 3.054a1.296 1.296 0 111.833-1.833 1.296 1.296 0 01-1.833 1.833zm-11.91-.306a.864.864 0 111.221-1.221.864.864 0 01-1.221 1.221zm3.054 3.054a.864.864 0 111.221-1.221.864.864 0 01-1.221 1.221zm12.216 0a.864.864 0 111.221-1.221.864.864 0 01-1.221 1.221zm-12.522-5.802a1.296 1.296 0 111.833-1.833 1.296 1.296 0 01-1.833 1.833zm5.803.305a1.728 1.728 0 112.444-2.443 1.728 1.728 0 01-2.444 2.443zm0-6.108a1.728 1.728 0 112.443-2.443 1.728 1.728 0 01-2.443 2.443zm-3.054 3.054a1.728 1.728 0 112.443-2.443 1.728 1.728 0 01-2.443 2.443z'
          fill='#293037'
        />
      </svg>
    )
  },
)

export const MathWalletCircle = React.forwardRef(function MathWalletCircle(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={48}
      height={48}
      viewBox='0 0 48 48'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <circle
        cx={24}
        cy={24}
        r={24}
        fill='url(#prefix__prefix__paint0_linear_10169:6073)'
      />
      <path
        d='M31.954 22.596a1.728 1.728 0 112.443-2.443 1.728 1.728 0 01-2.443 2.443zm-5.802 5.803a1.296 1.296 0 111.832-1.833 1.296 1.296 0 01-1.832 1.833zm9.162-3.054a1.296 1.296 0 111.832-1.833 1.296 1.296 0 01-1.832 1.833zm-3.054 3.054a1.296 1.296 0 111.832-1.833A1.296 1.296 0 0132.26 28.4zm6.413-.306a.864.864 0 111.222-1.221.864.864 0 01-1.222 1.221zm-3.054 3.054a.864.864 0 111.222-1.221.864.864 0 01-1.222 1.221zM28.9 25.65a1.728 1.728 0 112.444-2.443A1.728 1.728 0 0128.9 25.65zm0-6.108a1.728 1.728 0 112.443-2.443 1.728 1.728 0 01-2.443 2.443zm-3.054 3.054a1.728 1.728 0 112.443-2.443 1.728 1.728 0 01-2.443 2.443zm-6.136 0a1.728 1.728 0 112.443-2.443 1.728 1.728 0 01-2.443 2.443zm-5.803 5.803a1.296 1.296 0 111.833-1.833 1.296 1.296 0 01-1.833 1.833zm9.162-3.054a1.296 1.296 0 111.833-1.833 1.296 1.296 0 01-1.833 1.833zm-3.054 3.054a1.296 1.296 0 111.833-1.833 1.296 1.296 0 01-1.833 1.833zm-11.91-.306a.864.864 0 111.221-1.221.864.864 0 01-1.221 1.221zm3.054 3.054a.864.864 0 111.221-1.221.864.864 0 01-1.221 1.221zm12.216 0a.864.864 0 111.221-1.221.864.864 0 01-1.221 1.221zm-12.522-5.802a1.296 1.296 0 111.833-1.833 1.296 1.296 0 01-1.833 1.833zm5.803.305a1.728 1.728 0 112.444-2.443 1.728 1.728 0 01-2.444 2.443zm0-6.108a1.728 1.728 0 112.443-2.443 1.728 1.728 0 01-2.443 2.443zm-3.054 3.054a1.728 1.728 0 112.443-2.443 1.728 1.728 0 01-2.443 2.443z'
        fill='#fff'
      />
      <defs>
        <linearGradient
          id='prefix__prefix__paint0_linear_10169:6073'
          x1={48}
          y1={0}
          x2={0}
          y2={48}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#293037' />
          <stop offset={1} stopColor='#16181D' />
        </linearGradient>
      </defs>
    </svg>
  )
})

export const MetaMaskCircleInversion = React.forwardRef(
  function MetaMaskCircleInversion(
    props: React.SVGProps<SVGSVGElement>,
    svgRef?: React.Ref<SVGSVGElement>,
  ) {
    return (
      <svg
        width={48}
        height={49}
        viewBox='0 0 48 49'
        fill='currentColor'
        ref={svgRef}
        {...props}
      >
        <rect y={0.004} width={48} height={48} rx={24} fill='#fff' />
        <path
          d='M35.708 11.005L25.563 18.54l1.876-4.446 8.269-3.09z'
          fill='#E2761B'
        />
        <path
          d='M12.285 11.004L22.35 18.61l-1.785-4.517-8.279-3.09zM32.057 28.47l-2.702 4.14 5.782 1.59 1.662-5.639-4.742-.091zm-20.842.091l1.652 5.639 5.78-1.59-2.701-4.14-4.731.091z'
          fill='#E4761B'
        />
        <path
          d='M18.322 21.476l-1.611 2.437 5.74.255-.204-6.169-3.925 3.477zm11.35 0l-3.977-3.548-.133 6.24 5.73-.255-1.62-2.437zM18.648 32.61l3.447-1.683-2.977-2.325-.47 4.008zm7.25-1.683l3.457 1.683-.48-4.008-2.977 2.325z'
          fill='#E4761B'
        />
        <path
          d='M29.355 32.61l-3.457-1.682.276 2.253-.03.948 3.211-1.519zm-10.707 0l3.212 1.52-.02-.949.255-2.253-3.447 1.682z'
          fill='#D7C1B3'
        />
        <path
          d='M21.91 27.115l-2.875-.846 2.03-.928.845 1.774zm4.172 0l.846-1.774 2.04.928-2.886.846z'
          fill='#233447'
        />
        <path
          d='M18.647 32.61l.49-4.14-3.192.093 2.702 4.047zm10.216-4.14l.49 4.14 2.702-4.047-3.192-.092zm2.426-4.557l-5.73.255.53 2.947.846-1.774 2.04.927 2.314-2.355zm-12.253 2.355l2.039-.927.836 1.774.54-2.947-5.74-.255 2.325 2.355z'
          fill='#CD6116'
        />
        <path
          d='M16.71 23.914l2.407 4.69-.081-2.335-2.325-2.355zm12.267 2.354l-.102 2.335 2.416-4.69-2.314 2.355zm-6.527-2.1l-.54 2.947.673 3.477.153-4.578-.285-1.846zm3.11 0l-.275 1.835.122 4.589.684-3.477-.53-2.947z'
          fill='#E4751F'
        />
        <path
          d='M26.093 27.114l-.683 3.477.49.336 2.977-2.325.102-2.334-2.886.846zm-7.058-.846l.082 2.334 2.977 2.325.49-.336-.674-3.477-2.875-.846z'
          fill='#F6851B'
        />
        <path
          d='M26.143 34.13l.03-.949-.255-.224h-3.844l-.234.224.02.949-3.212-1.52 1.122.918 2.274 1.58h3.905l2.284-1.58 1.122-.918-3.212 1.52z'
          fill='#C0AD9E'
        />
        <path
          d='M25.898 30.928l-.49-.336h-2.824l-.49.336-.254 2.254.234-.225h3.844l.255.225-.275-2.254z'
          fill='#161616'
        />
        <path
          d='M36.132 19.028l.866-4.16-1.295-3.864-9.809 7.28 3.773 3.191L35 23.035l1.182-1.376-.51-.367.816-.744-.632-.49.816-.622-.54-.408zM11 14.868l.867 4.16-.55.408.815.622-.622.49.816.744-.51.367 1.172 1.377 5.333-1.56 3.772-3.192-9.808-7.28L11 14.868z'
          fill='#763D16'
        />
        <path
          d='M35.003 23.036l-5.333-1.56 1.621 2.437-2.416 4.69 3.181-.041h4.742l-1.795-5.526zm-16.681-1.56l-5.333 1.56-1.774 5.526h4.73l3.172.04-2.406-4.69 1.61-2.436zm7.237 2.693l.336-5.884 1.55-4.19h-6.883l1.53 4.19.357 5.884.122 1.855.01 4.568h2.825l.02-4.568.133-1.855z'
          fill='#F6851B'
        />
      </svg>
    )
  },
)

export const MetaMaskCircle = React.forwardRef(function MetaMaskCircle(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={48}
      height={49}
      viewBox='0 0 48 49'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <rect y={0.004} width={48} height={48} rx={24} fill='#233447' />
      <path
        d='M35.706 11.005L25.56 18.54l1.877-4.446 8.269-3.09z'
        fill='#E2761B'
      />
      <path
        d='M12.285 11.004L22.35 18.61l-1.785-4.517-8.279-3.09zM32.056 28.47l-2.702 4.14 5.78 1.59 1.663-5.639-4.741-.091zm-20.841.091l1.652 5.639 5.78-1.59-2.701-4.14-4.731.091z'
        fill='#E4761B'
      />
      <path
        d='M18.322 21.476l-1.611 2.437 5.74.255-.204-6.169-3.925 3.477zm11.348 0l-3.977-3.548-.133 6.24 5.73-.255-1.62-2.437zM18.648 32.61l3.447-1.683-2.977-2.325-.47 4.008zm7.248-1.683l3.457 1.683-.48-4.008-2.977 2.325z'
        fill='#E4761B'
      />
      <path
        d='M29.355 32.61l-3.457-1.682.276 2.253-.03.948 3.211-1.519zm-10.707 0l3.212 1.52-.02-.949.255-2.253-3.447 1.682z'
        fill='#D7C1B3'
      />
      <path
        d='M21.91 27.115l-2.875-.846 2.03-.928.845 1.774zm4.17 0l.846-1.774 2.04.928-2.886.846z'
        fill='#233447'
      />
      <path
        d='M18.647 32.61l.49-4.14-3.192.093 2.702 4.047zm10.216-4.14l.49 4.14 2.702-4.047-3.192-.092zm2.427-4.557l-5.73.255.53 2.947.847-1.774 2.04.927 2.314-2.355zm-12.256 2.355l2.039-.927.836 1.774.54-2.947-5.74-.255 2.325 2.355z'
        fill='#CD6116'
      />
      <path
        d='M16.71 23.914l2.407 4.69-.081-2.335-2.325-2.355zm12.269 2.354l-.102 2.335 2.417-4.69-2.315 2.355zm-6.526-2.1l-.54 2.947.672 3.477.153-4.578-.285-1.846zm3.109 0l-.275 1.835.123 4.589.683-3.477-.53-2.947z'
        fill='#E4751F'
      />
      <path
        d='M26.091 27.114l-.683 3.477.49.336 2.977-2.325.102-2.334-2.886.846zm-7.056-.846l.082 2.334 2.977 2.325.49-.336-.674-3.477-2.875-.846z'
        fill='#F6851B'
      />
      <path
        d='M26.143 34.13l.03-.949-.255-.224h-3.844l-.234.224.02.949-3.212-1.52 1.122.918 2.274 1.58h3.905l2.284-1.58 1.122-.918-3.212 1.52z'
        fill='#C0AD9E'
      />
      <path
        d='M25.898 30.928l-.49-.336h-2.824l-.49.336-.254 2.254.234-.225h3.844l.255.225-.275-2.254z'
        fill='#161616'
      />
      <path
        d='M36.133 19.028l.867-4.16-1.295-3.864-9.808 7.28 3.772 3.191 5.333 1.56 1.182-1.376-.51-.367.816-.744-.632-.49.816-.622-.54-.408zM11 14.868l.867 4.16-.55.408.815.622-.622.49.816.744-.51.367 1.172 1.377 5.333-1.56 3.772-3.192-9.808-7.28L11 14.868z'
        fill='#763D16'
      />
      <path
        d='M35.003 23.036l-5.333-1.56 1.621 2.437-2.416 4.69 3.181-.041h4.742l-1.795-5.526zm-16.681-1.56l-5.333 1.56-1.774 5.526h4.73l3.172.04-2.406-4.69 1.61-2.436zm7.238 2.693l.337-5.884 1.55-4.19h-6.883l1.53 4.19.357 5.884.122 1.855.01 4.568h2.825l.02-4.568.133-1.855z'
        fill='#F6851B'
      />
    </svg>
  )
})

export const MetaMask = React.forwardRef(function MetaMask(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={40}
      height={40}
      viewBox='0 0 40 40'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <path
        d='M34.413 4.457l-12.492 9.278 2.31-5.474 10.182-3.804z'
        fill='#E2761B'
        stroke='#E2761B'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M5.575 4.457l12.391 9.366-2.197-5.562L5.575 4.457zm24.344 21.507l-3.327 5.097 7.118 1.959 2.047-6.943-5.838-.113zm-25.663.113L6.29 33.02l7.119-1.959-3.327-5.097-5.826.113z'
        fill='#E4761B'
        stroke='#E4761B'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M13.007 17.351l-1.984 3 7.069.315-.251-7.596-4.834 4.281zm13.973-.001l-4.896-4.369-.163 7.684 7.056-.314-1.997-3zM13.41 31.061l4.243-2.072-3.666-2.862-.578 4.934zm8.925-2.071l4.257 2.071-.59-4.934-3.667 2.863z'
        fill='#E4761B'
        stroke='#E4761B'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M26.591 31.06l-4.256-2.07.339 2.774-.038 1.168 3.955-1.871zm-13.182 0l3.954 1.872-.025-1.168.314-2.775-4.243 2.072z'
        fill='#D7C1B3'
        stroke='#D7C1B3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M17.426 24.294l-3.54-1.042 2.498-1.143 1.042 2.185zm5.135 0l1.042-2.185 2.511 1.143-3.553 1.042z'
        fill='#233447'
        stroke='#233447'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M13.409 31.061l.602-5.097-3.93.113 3.328 4.984zm12.579-5.097l.603 5.097 3.327-4.984-3.93-.113zm2.989-5.612l-7.056.314.653 3.628 1.042-2.184 2.51 1.142 2.85-2.9zm-15.091 2.9l2.51-1.142 1.03 2.184.665-3.628-7.068-.314 2.863 2.9z'
        fill='#CD6116'
        stroke='#CD6116'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M11.023 20.352l2.963 5.775-.1-2.875-2.863-2.9zm15.104 2.9l-.125 2.875 2.975-5.775-2.85 2.9zm-8.035-2.586l-.666 3.628.829 4.282.188-5.637-.351-2.273zm3.829 0l-.339 2.26.15 5.65.842-4.282-.653-3.628z'
        fill='#E4751F'
        stroke='#E4751F'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M22.574 24.294l-.842 4.28.603.415 3.666-2.862.126-2.875-3.553 1.042zm-8.688-1.042l.1 2.875 3.666 2.862.603-.414-.829-4.281-3.54-1.043z'
        fill='#F6851B'
        stroke='#F6851B'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M22.637 32.931l.037-1.167-.314-.277h-4.733l-.289.277.025 1.167-3.954-1.87 1.38 1.13 2.8 1.945h4.809l2.812-1.946 1.381-1.13-3.954 1.871z'
        fill='#C0AD9E'
        stroke='#C0AD9E'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M22.335 28.99l-.602-.415h-3.478l-.603.415-.314 2.774.29-.276h4.732l.314.276-.339-2.774z'
        fill='#161616'
        stroke='#161616'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M34.94 14.338l1.068-5.123-1.595-4.758-12.078 8.964 4.646 3.93 6.566 1.92 1.456-1.694-.627-.452 1.004-.917-.778-.602 1.004-.766-.665-.502zM3.993 9.215l1.067 5.123-.678.502 1.004.766-.766.602 1.005.917-.628.452 1.444 1.695 6.566-1.921 4.645-3.93L5.575 4.457 3.993 9.215z'
        fill='#763D16'
        stroke='#763D16'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M33.547 19.271l-6.567-1.92 1.997 3L26 26.127l3.917-.05h5.838l-2.21-6.806zm-20.54-1.921l-6.566 1.921-2.185 6.805h5.826l3.904.05-2.963-5.775 1.984-3zm8.914 3.316l.414-7.245 1.909-5.16h-8.475l1.883 5.16.44 7.245.15 2.285.013 5.624h3.478l.025-5.624.163-2.285z'
        fill='#F6851B'
        stroke='#F6851B'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
})

export const OneInch = React.forwardRef(function OneInch(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={40}
      height={40}
      viewBox='0 0 40 40'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <path
        d='M10.391 22.35l.969-7.293-8.413-5.841 7.686 2.603 1.816-2.785 6.628-4.115 14.616 8.05.757 12.286-6.506 9.049-5.145.786 2.663-4.872v-4.69l-1.937-3.662-1.967-1.302-3.026 3.117v3.3l-2.36 2.208-2.997.363-1.331.757-2.179-.696-.908-3.268 1.634-2.3V22.35z'
        fill='#fff'
      />
      <path
        d='M23.828 9.156c-1.604-.333-3.36-.242-3.36-.242s-.574 2.663-4.145 3.359c.03 0 4.72 1.604 7.505-3.117zm1.452 24.149c1.936-1.513 3.389-3.601 4.054-5.962.03-.09.303-.242.485-.363.302-.181.605-.333.665-.575.121-.696.182-1.422.182-2.148 0-.273-.272-.545-.545-.817-.212-.182-.423-.394-.423-.545-.303-2.754-1.574-5.326-3.602-7.203l-.212.212c1.968 1.846 3.239 4.358 3.511 7.021.03.242.272.484.514.726.212.182.454.454.454.575 0 .697-.06 1.393-.181 2.088-.03.122-.303.243-.515.364-.302.151-.575.302-.635.544a11.185 11.185 0 01-4.6 6.265c.393-.848 1.634-3.601 2.3-4.994l-.121-4.478-3.844-3.723-2.178.303-2.391 3.873s1.12 1.423-.454 3.087c-1.543 1.634-2.754 1.998-2.754 1.998l-1.12-.606c.333-.423.999-1.059 1.514-1.482.877-.727 1.755-.787 1.755-1.574.03-1.634-1.725-1.18-1.725-1.18l-.636.605-.272 2.24-1.332 1.664-.151-.03-2.179-.485s1.332-.696 1.543-1.482c.212-.757-.423-3.269-.454-3.42.03.03.636.544.908 1.392.485-1.332 1.12-2.603 1.302-2.724.181-.12 2.633-1.422 2.633-1.422l-.818 2.149.606-.333 1.452-3.571s1.423-.696 2.482-.696c1.906-.03 4.72-2.36 3.45-6.537.363.151 6.657 3.299 7.747 9.472.817 4.751-1.876 9.2-6.416 11.772z'
        fill='#94A6C3'
      />
      <path
        d='M18.078 9.82c.696-.816.423-2.027.423-2.027l-2.027 2.996c-.03 0 .726.03 1.604-.968zm-6.81 16.374l.242-1.21s-.999 1.755-1.09 1.997c-.09.272.06.756.454.726.394-.03.878-.605.878-1.029 0-.545-.484-.484-.484-.484z'
        fill='#1B314F'
      />
      <path
        d='M29.245 6.945s1.514.06 3.087.242c-3.54-2.784-6.9-3.6-9.623-3.6-3.753 0-6.295 1.543-6.446 1.633l1.18-1.876s-4.72-.454-6.385 4.54c-.424-1.06-.817-2.603-.817-2.603S7.789 7.43 8.939 11C6.125 9.97 2.1 8.549 1.95 8.518c-.212-.03-.273.06-.273.06s-.06.091.121.243c.333.272 6.688 4.963 8.08 5.87-.302 1.09-.302 1.605 0 2.119.424.696.454 1.06.394 1.573-.06.515-.605 4.963-.726 5.508-.121.545-1.392 2.482-1.332 3.057.06.575.847 3.026 1.543 3.298.515.182 1.786.576 2.633.576.303 0 .575-.061.696-.182.515-.454.666-.545 1.03-.545h.09c.151 0 .333.03.545.03.484 0 1.12-.09 1.573-.514.666-.666 1.816-1.574 2.18-1.997a2.816 2.816 0 00.574-2.149c-.09-.726.303-1.362.757-1.997.575-.757 1.634-2.119 1.634-2.119 2.088 1.574 3.39 3.965 3.39 6.628 0 4.72-4.116 8.534-9.2 8.534a9.733 9.733 0 01-2.3-.273c2.33.818 4.297 1.09 5.9 1.09 3.42 0 5.236-1.24 5.236-1.24s-.635.816-1.664 1.754h.03c5.66-.787 8.413-5.447 8.413-5.447s-.212 1.513-.484 2.542c7.535-5.659 6.264-12.74 6.234-12.982.06.09.817.998 1.21 1.482 1.211-12.468-8.987-16.493-8.987-16.493zm-11.59 19.913c-.121.151-.636.605-.999.938-.363.333-.756.666-1.059.969-.12.12-.363.181-.726.181h-.908c.454-.605 1.785-1.997 2.24-2.3.544-.363.816-.726.483-1.362-.332-.635-1.21-.484-1.21-.484s.514-.212.968-.212c-.574-.151-1.3 0-1.634.333-.363.333-.302 1.513-.454 2.27-.151.787-.665 1.18-1.452 1.906-.424.394-.727.515-.969.515-.514-.09-1.12-.242-1.543-.393-.303-.394-.757-1.695-.878-2.24.091-.303.454-.938.636-1.301.363-.696.575-1.09.635-1.453.121-.514.515-3.692.666-5.023.394.514.938 1.361.817 1.906.878-1.24.242-2.451-.06-2.935-.273-.484-.636-1.453-.333-2.482.302-1.029 1.392-3.873 1.392-3.873s.363.635.878.514c.514-.12 4.66-6.355 4.66-6.355s1.12 2.451-.06 4.237c-1.211 1.785-2.391 2.118-2.391 2.118s1.664.303 3.207-.817c.636 1.483 1.241 3.026 1.271 3.238-.09.212-1.3 3.117-1.422 3.299-.06.06-.484.181-.787.242-.514.151-.817.242-.938.333-.212.181-1.18 2.844-1.634 4.146-.545.151-1.09.454-1.483 1.059.212-.152.878-.242 1.362-.303.424-.03 1.725.666 2.058 1.967v.06c.06.485-.09.939-.333 1.302zm-2.845.363c.273-.393.242-1.059.273-1.27.03-.213.09-.606.333-.667.242-.06.817.03.817.454 0 .394-.424.485-.727.757-.212.212-.635.666-.696.726zm12.075-5.78c.303-1.543.333-2.875.242-3.964 1.18 1.573 1.907 3.48 2.119 5.447.03.242.272.484.514.726.212.182.454.424.454.575 0 .696-.06 1.392-.182 2.088-.03.091-.302.242-.514.363-.303.152-.575.303-.636.545a11.268 11.268 0 01-3.994 5.84c2.814-2.935 4.176-7.776 1.997-11.62zm-1.907 11.893c1.968-1.513 3.48-3.631 4.146-6.022.03-.09.303-.242.485-.363.302-.152.605-.333.665-.575a12.61 12.61 0 00.182-2.149c0-.272-.272-.545-.545-.817-.151-.181-.393-.393-.393-.545a11.823 11.823 0 00-2.482-6.022c-.605-3.631-3.026-4.751-3.087-4.781.061.09 1.635 2.36.545 5.023-1.12 2.694-3.994 2.27-4.236 2.3-.243 0-1.18 1.21-2.36 3.45-.152-.06-.788-.212-1.514-.09.545-1.514 1.362-3.662 1.513-3.844.06-.06.515-.181.817-.272.575-.152.848-.242.938-.363.06-.091.363-.787.666-1.514.272 0 .968-.06 1.029-.09.06-.06.636-1.544.636-1.725 0-.152-1.18-3.087-1.635-4.207.212-.242.424-.545.636-.877 6.204.665 11.046 5.931 11.046 12.316 0 4.903-2.875 9.17-7.052 11.167z'
        fill='#1B314F'
      />
      <path
        d='M16.928 16.992c.575-.666.273-1.906-.786-2.118.272-.636.665-1.907.665-1.907s-3.086 4.842-3.359 4.933c-.272.09-.545-.968-.545-.968-.575 2.209.969 2.512 1.15 1.815.848-.211 2.3-1.12 2.875-1.755z'
        fill='#1B314F'
      />
      <path
        d='M14.296 18.174l1.574-2.694s.908.454.454 1.18c-.576.848-2.028 1.514-2.028 1.514z'
        fill='#FFD923'
      />
      <path
        d='M33.755 30.642a17.06 17.06 0 01-1.573 1.846c3.904-7.505.181-14.375.03-14.647.272.272.545.575.787.848 2.996 3.328 3.359 8.322.756 11.953zm3.632-9.655c-1.362-3.662-3.299-6.779-7.566-9.593-4.115-2.724-8.534-2.512-8.776-2.482h-.06c.151-.06.302-.09.454-.12.938-.303 2.148-.545 3.359-.697 3.208-.454 6.446.636 8.655 2.966l.06.06c2.512 2.664 3.813 5.992 3.874 9.866zM28.85 6.006c-4.509-.847-7.414-.423-9.502.364-.06-.243-.272-.727-.454-1.12-.636.756-1.301 1.664-1.725 2.24-1.15.786-1.634 1.543-1.634 1.543.666-2.27 2.602-3.965 4.963-4.388a12.202 12.202 0 012.179-.182c2.088.03 4.176.545 6.173 1.543zm-16.672 5.812c-3.541-.121-2.361-4.237-2.3-4.479 0 .03.242 3.238 2.3 4.48zm3.479-7.414c-2.723 1.635-2.179 5.538-2.179 5.538-2.602-3.964 1.967-5.447 2.18-5.538z'
        fill='#D82122'
      />
      <path
        d='M11.181 12.908c.182.151.363.423.151.817-.12.212-.302.181-.575.06-.363-.181-2.542-1.452-4.509-2.754 2.24.787 4.51 1.635 4.872 1.816l.061.06z'
        fill='#fff'
      />
    </svg>
  )
})

export const OperaWallet = React.forwardRef(function OperaWallet(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={48}
      height={48}
      viewBox='0 0 48 48'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <path
        d='M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24z'
        fill='#F2F5FF'
      />
      <path
        d='M19.326 32.001c-1.57-1.853-2.587-4.593-2.657-7.668v-.669c.07-3.074 1.086-5.814 2.657-7.668 2.036-2.645 5.065-4.322 8.446-4.322 2.08 0 4.026.635 5.69 1.74a14.143 14.143 0 00-9.41-3.614L24 9.799c-7.843 0-14.2 6.358-14.2 14.2 0 7.615 5.995 13.83 13.523 14.183a14.149 14.149 0 0010.14-3.597c-1.664 1.104-3.61 1.74-5.69 1.74-3.382 0-6.41-1.678-8.447-4.323z'
        fill='url(#prefix__prefix__paint0_linear_12052_1639)'
      />
      <path
        d='M19.325 15.997c1.303-1.538 2.987-2.466 4.826-2.466 4.133 0 7.484 4.687 7.484 10.468s-3.35 10.468-7.485 10.468c-1.838 0-3.522-.928-4.824-2.465 2.037 2.645 5.065 4.322 8.447 4.322 2.08 0 4.027-.634 5.69-1.738A14.165 14.165 0 0038.2 24c0-4.206-1.83-7.985-4.735-10.585-1.666-1.105-3.612-1.74-5.693-1.74-3.381 0-6.41 1.678-8.447 4.323z'
        fill='url(#prefix__prefix__paint1_linear_12052_1639)'
      />
      <defs>
        <linearGradient
          id='prefix__prefix__paint0_linear_12052_1639'
          x1={21.632}
          y1={10.262}
          x2={21.632}
          y2={37.785}
          gradientUnits='userSpaceOnUse'
        >
          <stop offset={0.3} stopColor='#FF1B2D' />
          <stop offset={0.438} stopColor='#FA1A2C' />
          <stop offset={0.594} stopColor='#ED1528' />
          <stop offset={0.758} stopColor='#D60E21' />
          <stop offset={0.927} stopColor='#B70519' />
          <stop offset={1} stopColor='#A70014' />
        </linearGradient>
        <linearGradient
          id='prefix__prefix__paint1_linear_12052_1639'
          x1={28.762}
          y1={11.884}
          x2={28.762}
          y2={36.227}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#9C0000' />
          <stop offset={0.7} stopColor='#FF4B4B' />
        </linearGradient>
      </defs>
    </svg>
  )
})

export const Plus = React.forwardRef(function Plus(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12 5a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H6a1 1 0 110-2h5V6a1 1 0 011-1z'
      />
    </svg>
  )
})

export const Question = React.forwardRef(function Question(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <path d='M12.188 9.109a1.455 1.455 0 00-1.618.95.727.727 0 01-1.372-.482 2.91 2.91 0 015.653.97c0 1.112-.826 1.847-1.415 2.24a5.64 5.64 0 01-1.262.63.735.735 0 01-.922-.46.727.727 0 01.46-.92c.322-.113.633-.271.917-.46.502-.335.767-.69.767-1.032a1.454 1.454 0 00-1.208-1.436zM12 15.636a.727.727 0 100-1.454.727.727 0 000 1.454z' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4 12a8 8 0 1116 0 8 8 0 01-16 0zm8-6.545a6.545 6.545 0 100 13.09 6.545 6.545 0 000-13.09z'
      />
    </svg>
  )
})

export const Referral = React.forwardRef(function Referral(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M14.92 15.48A4 4 0 0118 14a4 4 0 11-4 4c.004-.239.027-.476.07-.71l-5.28-2.43a4 4 0 110-5.72l5.28-2.43a4 4 0 11.85 1.81l-5.1 2.35a3.64 3.64 0 010 2.26l5.1 2.35zM20 6a2 2 0 10-4 0 2 2 0 004 0zM6 14a2 2 0 110-4 2 2 0 010 4zm10 4a2 2 0 104 0 2 2 0 00-4 0z'
      />
    </svg>
  )
})

export const RotateCw = React.forwardRef(function RotateCw(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={20}
      height={20}
      viewBox='0 0 20 20'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <path d='M10 1.5c2.218 0 4.338.825 5.986 2.266l.324.296.014.014.176.176V2.5a1 1 0 112 0v4.167a1 1 0 01-1 1h-4.167a1 1 0 010-2h1.753l-.177-.177A7.117 7.117 0 0010 3.5a6.5 6.5 0 106.5 6.5 1 1 0 112 0 8.502 8.502 0 01-14.51 6.01A8.5 8.5 0 0110 1.5z' />
    </svg>
  )
})

export const Solana = React.forwardRef(function Solana(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <path
        d='M17.129 9.033a.442.442 0 01-.314.132H5.695c-.393 0-.592-.48-.318-.764l1.824-1.89a.441.441 0 01.318-.136H18.68c.396 0 .594.485.314.768l-1.865 1.89zm0 8.44a.447.447 0 01-.314.129H5.695a.438.438 0 01-.318-.745l1.824-1.843a.447.447 0 01.318-.132H18.68c.396 0 .594.472.314.748l-1.865 1.843zm0-6.716a.447.447 0 00-.314-.128H5.695a.438.438 0 00-.318.745l1.824 1.842a.446.446 0 00.318.132H18.68a.438.438 0 00.314-.748l-1.865-1.843z'
        fill='url(#prefix__prefix__solana-icon-gradient)'
      />
      <defs>
        <linearGradient
          id='prefix__prefix__solana-icon-gradient'
          x1={6.263}
          y1={17.906}
          x2={18.092}
          y2={6.077}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#CF41E8' />
          <stop offset={1} stopColor='#10F2B0' />
        </linearGradient>
      </defs>
    </svg>
  )
})

export const Stake = React.forwardRef(function Stake(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M18.988 9.05a1 1 0 01.89.55 1 1 0 01-.08 1.04l-8 11a1 1 0 01-1.81-.59v-6h-5a1 1 0 01-.89-.64 1 1 0 01.08-1l8-11a1 1 0 011.12-.36 1 1 0 01.69 1v6h5zm-7 5v3.92l5-6.92h-4a1 1 0 01-1-1V6.13l-5 6.92h4a1 1 0 011 1z'
      />
    </svg>
  )
})

export const Steth = React.forwardRef(function Steth(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <path
        d='M7.078 11.148l-.135.206a5.788 5.788 0 00.814 7.32 6.043 6.043 0 004.24 1.72l-4.92-9.246z'
        fill='#00A3FF'
      />
      <path
        opacity={0.6}
        d='M11.997 13.958l-4.92-2.81 4.92 9.246v-6.436zm4.925-2.81l.134.206a5.788 5.788 0 01-.813 7.32 6.043 6.043 0 01-4.24 1.72l4.92-9.246z'
        fill='#00A3FF'
      />
      <path
        opacity={0.2}
        d='M12.002 13.958l4.92-2.81-4.92 9.246v-6.436zm.001-6.278v4.847l4.238-2.422-4.238-2.425z'
        fill='#00A3FF'
      />
      <path
        opacity={0.6}
        d='M12.003 7.68l-4.24 2.425 4.24 2.422V7.68z'
        fill='#00A3FF'
      />
      <path d='M12.003 3.604l-4.24 6.502 4.24-2.431V3.604z' fill='#00A3FF' />
      <path
        opacity={0.6}
        d='M12.003 7.674l4.241 2.432-4.24-6.506v4.074z'
        fill='#00A3FF'
      />
    </svg>
  )
})

export const Stsol = React.forwardRef(function Stsol(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <rect width={24} height={24} rx={12} />
      <path
        d='M17.129 9.032a.442.442 0 01-.314.132H5.695c-.393 0-.592-.48-.318-.764l1.824-1.89a.441.441 0 01.318-.135H18.68c.396 0 .594.484.314.768l-1.865 1.89zm0 8.44a.447.447 0 01-.314.129H5.695a.438.438 0 01-.318-.745l1.824-1.843a.449.449 0 01.318-.131H18.68c.396 0 .594.472.314.748l-1.865 1.843zm0-6.715a.447.447 0 00-.314-.129H5.695a.438.438 0 00-.318.745l1.824 1.843a.446.446 0 00.318.132H18.68a.438.438 0 00.314-.749l-1.865-1.842z'
        fill='url(#prefix__prefix__paint0_linear)'
      />
      <defs>
        <linearGradient
          id='prefix__prefix__paint0_linear'
          x1={6.263}
          y1={17.905}
          x2={18.092}
          y2={6.077}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#CF41E8' />
          <stop offset={1} stopColor='#10F2B0' />
        </linearGradient>
      </defs>
    </svg>
  )
})

export const Success = React.forwardRef(function Success(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={60}
      height={60}
      viewBox='0 0 60 60'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M30 58c15.464 0 28-12.536 28-28S45.464 2 30 2 2 14.536 2 30s12.536 28 28 28zm0 2c16.569 0 30-13.431 30-30C60 13.431 46.569 0 30 0 13.431 0 0 13.431 0 30c0 16.569 13.431 30 30 30z'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M38.707 24.293a1 1 0 010 1.414l-11 11a1 1 0 01-1.414 0l-5-5a1 1 0 011.414-1.414L27 34.586l10.293-10.293a1 1 0 011.414 0z'
      />
    </svg>
  )
})

export const TallyCircle = React.forwardRef(function TallyCircle(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={48}
      height={48}
      viewBox='0 0 300 300'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <circle cx={150} cy={150} r={150} fill='#D08E39' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M241.377 139.857a11.625 11.625 0 014.096 6.987 8.049 8.049 0 01-.03 2.469 14.972 14.972 0 01-.211 1.716 24.985 24.985 0 01-.723 3.313 22.76 22.76 0 01-3.011 6.264c-.25.362-.567.776-.786 1.061l-.178.234v.15l.012.091c.034.243.097.695.229 1.355.363 2.188.474 4.411.331 6.625a38.065 38.065 0 01-3.011 12.498 27.827 27.827 0 01-7.71 10.69l-.391.362-.542.18a89.167 89.167 0 01-12.919 3.765 53.88 53.88 0 01-13.733 1.325h-.783a137.188 137.188 0 00-29.482-6.023 58.416 58.416 0 01-8.101-1.175 66.15 66.15 0 01-7.709-2.469 94.077 94.077 0 00-12.317-3.554 13.976 13.976 0 00-2.56 9.456 38.841 38.841 0 004.487 13.673 73.842 73.842 0 017.198 14.665 36.837 36.837 0 011.325 17.075l-.813 5.21-4.397-3.011c-.529-.453-1.521-1.054-2.466-1.626l-.546-.332-3.011-1.656a66.766 66.766 0 012.108 12.046 68.703 68.703 0 01-.211 10.57A36.665 36.665 0 01143.233 272c-12.484-18.97-22.673-24.404-31.598-29.164-5.994-3.197-11.419-6.09-16.585-12.575-7.65-10.871-9.576-23.369 1.084-47.009 2.952-7.305 4.773-15.317 6.262-21.869 1.262-5.548 2.285-10.05 3.555-12.191v.181a44.007 44.007 0 000 15.057 16.833 16.833 0 002.56 6.565 12.345 12.345 0 005.331 4.006 45.936 45.936 0 0014.214 3.011c2.469.392 4.969.392 7.528.392a36.907 36.907 0 013.976.15c1.355.121 2.68.301 4.005.482a97.653 97.653 0 0115.479 3.825 43.497 43.497 0 0014.244 2.86 134.854 134.854 0 0130.476 6.023 53.58 53.58 0 0011.654-.903c1.386-.241 2.771-.572 4.156-.903 6.806-1.988 14.455-13.552 5.601-12.588a48.534 48.534 0 00-7.317.903c-1.382.327-2.75.845-4.2 1.394-1.489.563-3.065 1.16-4.835 1.618a20.458 20.458 0 01-10.118-.271 29.813 29.813 0 00-9.035-2.109 11.431 11.431 0 014.728-1.445c1.218-.122 2.298-.08 3.334-.039.502.02.993.039 1.485.039 2.809.386 5.665.264 8.432-.361 1.421-.402 2.86-1.174 4.406-2.004 1.239-.664 2.546-1.365 3.966-1.941a27.32 27.32 0 019.907-2.108h-.06a21.41 21.41 0 013.704 0 12.047 12.047 0 003.012-9.426 6.51 6.51 0 00-3.674-2.681 96.928 96.928 0 00-2.256-.453c-4.47-.867-11.786-2.285-14.729-5.027-2.018-1.958-3.102-7.83 4.005-9.456a40.882 40.882 0 0111.414-.362l.145.014c1.705.162 5.937.563 6.932-.285a28.034 28.034 0 01-1.339-.964c-.214-.16-.428-.321-.649-.481l-9.335-7.107c-.644-.453-1.269-.911-1.882-1.36-.937-.686-1.846-1.353-2.756-1.953a8.878 8.878 0 00-.964-.602 6.721 6.721 0 00-1.024-.452 28.817 28.817 0 01-3.011-1.355 38.102 38.102 0 01-9.818-7.258 122.687 122.687 0 01-21.531-29.904 20.72 20.72 0 00-10.812-9.787 17.796 17.796 0 0113.281 4.818c.603.5 1.372 1.876 2.357 3.637 2.751 4.92 7.188 12.857 14.417 13.167 1.246-.1 2.473-.374 3.644-.813-3.589-3.397-6.019-7.489-8.293-11.319-3.45-5.81-6.544-11.02-12.788-12.29a41.735 41.735 0 01-4.577-1.958l-4.216-2.078-8.432-4.126a151.67 151.67 0 00-17.166-6.956 87.085 87.085 0 00-17.858-3.855c-1.438-.19-2.886-.3-4.336-.331a7.56 7.56 0 00-3.373.783c-.61.261-1.297.628-2.004 1.005-.759.405-1.54.821-2.272 1.133a74.472 74.472 0 00-4.186 1.927 83.56 83.56 0 00-15.449 9.697 40.415 40.415 0 00-9.336 9.185 34.239 34.239 0 0113.341 1.747 50.683 50.683 0 00-16.02 2.289 55.079 55.079 0 00-7.439 2.74 50.797 50.797 0 00-6.957 3.644 30.356 30.356 0 00-6.022 4.547 7.712 7.712 0 00-1.687 2.59c-.511 1.143-.962 2.376-1.414 3.61l-.001.004a116.078 116.078 0 00-4.186 15.479 125.278 125.278 0 00-2.41 31.891 61.923 61.923 0 006.596 24.755 466.502 466.502 0 0010.81-14.847 231.943 231.943 0 0012.499-20.087c1.984-3.559 3.746-7.283 5.527-11.047 1.624-3.433 3.264-6.899 5.103-10.304a65.456 65.456 0 016.535-10.42 24.806 24.806 0 014.397-4.487 10.115 10.115 0 015.782-2.318c-6.746 6.053-11.986 22.315-17.226 40.534-4.216 14.786-18.55 48.485-27.585 49.328-3.493.18-4.788-1.476-7.167-4.909l-1.988-2.71a53.969 53.969 0 01-7.83-15.901 79.662 79.662 0 01-3.011-17.105c-.277-5.694-.146-11.4.391-17.075a141.56 141.56 0 013.012-16.714 121.47 121.47 0 014.909-16.262c.542-1.355 1.084-2.68 1.746-4.035a19.01 19.01 0 011.235-2.168 19.424 19.424 0 011.717-2.018 31.528 31.528 0 017.348-5.21 50.018 50.018 0 0112.527-4.547 29.876 29.876 0 015.541-8.342 60.713 60.713 0 017.469-6.595 90.572 90.572 0 0116.502-10.36c.929-.464 2.06-.968 3.059-1.414.491-.22.951-.424 1.338-.603.52-.24 1.075-.527 1.676-.837a52.885 52.885 0 012.51-1.24A13.946 13.946 0 01127.122 54c1.574 0 2.733.12 3.923.245.381.04.765.08 1.167.116a93.357 93.357 0 0119.032 4.126 154.816 154.816 0 0117.858 7.258l8.583 4.155 4.246 2.109c1.037.56 2.36 1.068 3.801 1.621l.325.125a46.255 46.255 0 014.577 2.018 20.21 20.21 0 012.439 1.476 23.61 23.61 0 012.108 1.927 43.917 43.917 0 016.023 8.221l.647 1.127c2.938 5.124 5.687 9.92 9.954 12.726l3.011 1.987a2.943 2.943 0 01-.181.482l-.632 1.145-3.012 1.535a2.44 2.44 0 00-1.295 1.386 2.683 2.683 0 00-.18.903v1.928a10.567 10.567 0 01-.392 3.011c-.125.388-.276.734-.41 1.041-.188.432-.343.785-.343 1.067-.095.314-.095.65 0 .964a32.093 32.093 0 008.192 6.023l2.409 1.114c.567.204 1.121.445 1.656.723l1.536.933c1.347.855 2.451 1.695 3.549 2.531.449.341.897.682 1.36 1.023l9.365 7.137 2.229 1.656c.944.616 1.849 1.29 2.71 2.018zm-73.993-27.796c.301 3.734-4.156 6.655-9.606 7.258-6.867.692-10.541-3.283-9.577-7.89 1.807-7.71-2.168-5.09-4.818-2.078a.364.364 0 01-.449.152.36.36 0 01-.214-.423c1.114-7.951 5.782-8.282 7.86-8.282a94.985 94.985 0 0118.611 3.162.908.908 0 01.688.683.9.9 0 01-.327.913 6.782 6.782 0 00-2.168 6.505z'
        fill='#002522'
      />
    </svg>
  )
})

export const Telegram = React.forwardRef(function Telegram(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9.066 18.333c-.518 0-.43-.195-.609-.69l-1.524-5.016 11.733-6.96'
        fill='#C8DAEA'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9.067 18.334c.4 0 .577-.183.8-.4L12 15.858l-2.66-1.605'
        fill='#A9C9DD'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9.339 14.255l6.448 4.763c.735.406 1.266.196 1.45-.683L19.86 5.967c.27-1.077-.41-1.566-1.114-1.246L3.335 10.663c-1.052.422-1.046 1.01-.192 1.27l3.955 1.235 9.157-5.776c.432-.263.829-.122.503.167'
        fill='url(#prefix__prefix__telegram-icon-gradient)'
      />
      <defs>
        <linearGradient
          id='prefix__prefix__telegram-icon-gradient'
          x1={9.997}
          y1={11.983}
          x2={11.707}
          y2={17.513}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#EFF7FC' />
          <stop offset={1} stopColor='#fff' />
        </linearGradient>
      </defs>
    </svg>
  )
})

export const Terra = React.forwardRef(function Terra(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <g
        clipPath='url(#prefix__prefix__clip0)'
        fillRule='evenodd'
        clipRule='evenodd'
      >
        <path
          d='M8.067 7.792c-1.636-.38-3.215-1.717-3.449-4.285a15.67 15.67 0 00-.101-.87A11.897 11.897 0 0112 0c3.434 0 6.531 1.453 8.719 3.782-1.14.45-11.11 4.37-12.652 4.01zm9.879 13.6c3.427-2.025 4.01-3.757 4.67-6.541.659-2.784-7.708-1.24-9.96-.28-2.253.96-3.505 3.75-1.211 6.391 2.294 2.642 3.075 2.454 6.501.43z'
          fill='#2642B4'
        />
        <path
          d='M22.497 17.943c-2.27.476-4.992 2-6.202 3.044-1.171 1.01-.752 2.016.805 2.039a12.084 12.084 0 005.397-5.083zM20.061 3.132c-2.5-1.315-3.79-.942-9.322 1.122-6.943 2.59-4.035 8.105 1.26 9.943.512.178 1.01.353 1.494.524 4.244 1.494 7.469 2.629 9.695 1.74.524-1.357.812-2.833.812-4.377 0-3.55-1.52-6.741-3.939-8.952zM1.269 6.669c1.965-.063 5.788-1.184 7.275-3.33 1.43-2.067.122-2.367-1.803-2.12a12.092 12.092 0 00-5.472 5.45zm-.562 1.32A12.139 12.139 0 000 12.085a12.09 12.09 0 007.296 11.12c.096-1.356.162-2.967.096-4.419C7.274 16.22 3.622 11.151.707 7.99z'
          fill='#4393FF'
        />
      </g>
      <defs>
        <clipPath id='prefix__prefix__clip0'>
          <path fill='#fff' d='M0 0h24v24H0z' />
        </clipPath>
      </defs>
    </svg>
  )
})

export const TickSquare = React.forwardRef(function TickSquare(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={16}
      height={16}
      viewBox='0 0 16 16'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5.113 1.333h5.78c2.26 0 3.774 1.587 3.774 3.947v5.447c0 2.353-1.514 3.94-3.774 3.94h-5.78c-2.26 0-3.78-1.587-3.78-3.94V5.28c0-2.36 1.52-3.947 3.78-3.947zm2.507 8.66l3.167-3.166a.587.587 0 000-.827.587.587 0 00-.827 0L7.207 8.754 6.04 7.587a.587.587 0 00-.827 0 .587.587 0 000 .827L6.8 9.994a.57.57 0 00.407.166.57.57 0 00.413-.167z'
        fill='#53BA95'
      />
    </svg>
  )
})

export const TimeSquare = React.forwardRef(function TimeSquare(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={16}
      height={16}
      viewBox='0 0 16 16'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5.113 1.333h5.78c2.26 0 3.774 1.587 3.774 3.946v5.447c0 2.354-1.514 3.94-3.774 3.94h-5.78c-2.26 0-3.78-1.586-3.78-3.94V5.28c0-2.36 1.52-3.946 3.78-3.946zm5.274 9.207a.495.495 0 00.426-.246.496.496 0 00-.173-.687L8.267 8.194V5.113a.5.5 0 10-1 0V8.48c0 .173.093.34.246.427l2.614 1.56a.47.47 0 00.26.073z'
        fill='#EC8600'
      />
    </svg>
  )
})

export const TrustCircle = React.forwardRef(function TrustCircle(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={48}
      height={48}
      viewBox='0 0 48 48'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <path
        d='M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24z'
        fill='#3375BB'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M23.18 12.35a1.446 1.446 0 011.871 0c2.918 2.475 6.243 2.457 7.566 2.45h.18a1.446 1.446 0 011.447 1.467c-.063 4.243-.23 7.286-.562 9.525-.332 2.236-.844 3.811-1.697 5.014-.861 1.216-1.967 1.9-3.092 2.532l-.6.332c-.98.54-2.05 1.13-3.326 2.06-.507.37-1.195.37-1.703 0-1.274-.93-2.343-1.519-3.322-2.058a84.964 84.964 0 01-.602-.334c-1.124-.632-2.229-1.317-3.088-2.533-.85-1.203-1.362-2.778-1.692-5.014-.33-2.238-.497-5.281-.56-9.524a1.446 1.446 0 011.446-1.468l.179.001c1.312.007 4.637.025 7.555-2.45zm-6.261 5.32c.077 3.446.237 5.9.502 7.7.302 2.043.72 3.1 1.192 3.766.462.654 1.07 1.077 2.144 1.68.173.098.356.199.55.305.784.432 1.731.954 2.809 1.676 1.08-.723 2.028-1.245 2.813-1.677.193-.106.376-.207.549-.304 1.074-.603 1.684-1.027 2.147-1.681.473-.667.893-1.724 1.196-3.767.266-1.798.427-4.252.504-7.697-1.738-.092-4.533-.517-7.21-2.393-2.671 1.873-5.462 2.3-7.196 2.392z'
        fill='#fff'
      />
    </svg>
  )
})

export const Trust = React.forwardRef(function Trust(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={40}
      height={40}
      viewBox='0 0 40 40'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M.89 8.827C0 11.173 0 14.115 0 20s0 8.827.89 11.173a13.682 13.682 0 007.937 7.937C11.173 40 14.115 40 20 40s8.827 0 11.173-.89a13.682 13.682 0 007.937-7.937C40 28.827 40 25.885 40 20s0-8.827-.89-11.173A13.682 13.682 0 0031.173.89C28.827 0 25.885 0 20 0S11.173 0 8.827.89A13.682 13.682 0 00.89 8.827zm18.242 23.745c.29.142.579.285.868.285.29 0 .579 0 .723-.143 1.302-.856 2.315-1.426 3.328-1.997 5.497-2.996 7.088-4.565 7.378-19.259 0-.428-.145-.713-.434-.998-.29-.286-.58-.428-1.013-.428h-.29c-1.446 0-5.352 0-8.824-2.568-.434-.428-1.157-.428-1.736 0-3.472 2.568-7.378 2.568-8.825 2.568h-.289c-.29 0-.723.142-1.013.285-.289.285-.434.57-.434.999.145 14.693 1.736 16.263 7.234 19.259.22.123.446.247.678.374.837.457 1.743.953 2.649 1.623zm-1.921-4.304c-4.163-2.406-5.458-3.154-5.746-15.383 2.025-.143 5.642-.57 8.535-2.568 3.183 2.14 6.22 2.425 8.246 2.568-.29 12.268-1.447 12.982-5.787 15.407a52.1 52.1 0 00-.868.53c-.521.323-1.1.681-1.736 1.04a46.074 46.074 0 00-2.049-1.245l-.555-.325-.04-.024z'
        fill='#4276B6'
      />
    </svg>
  )
})

export const Twitter = React.forwardRef(function Twitter(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12.05 9.192l.032.52-.524-.064c-1.91-.244-3.578-1.07-4.995-2.458l-.692-.688-.179.508c-.377 1.134-.136 2.33.651 3.136.42.444.325.508-.399.243-.252-.085-.472-.148-.493-.116-.073.074.179 1.038.378 1.419.273.53.829 1.049 1.437 1.356l.514.243-.608.011c-.588 0-.609.01-.546.233.21.689 1.039 1.42 1.962 1.737l.65.223-.566.339a5.906 5.906 0 01-2.812.784c-.472.01-.86.053-.86.084 0 .106 1.28.7 2.025.932 2.235.689 4.89.392 6.883-.783 1.416-.837 2.833-2.5 3.494-4.11.357-.858.713-2.426.713-3.178 0-.487.032-.55.62-1.133.346-.34.67-.71.734-.816.105-.201.094-.201-.44-.021-.893.317-1.019.275-.578-.202.325-.338.713-.953.713-1.133 0-.032-.157.021-.335.117-.19.106-.609.264-.924.36l-.566.18-.514-.35c-.284-.19-.682-.402-.892-.466-.535-.148-1.354-.127-1.836.043-1.312.476-2.14 1.705-2.046 3.05z'
      />
    </svg>
  )
})

export const Uniswap = React.forwardRef(function Uniswap(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={40}
      height={40}
      viewBox='0 0 40 40'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <g clipPath='url(#prefix__prefix__prefix__clip0)' fill='#FF007A'>
        <path d='M18.77 19.01c.84 1.485-1.037 1.945-1.918 2.03-1.336.13-1.612-.642-1.351-1.613a1.746 1.746 0 011.501-1.317 1.857 1.857 0 011.769.9zm5.24-2.742c-.975 7.498 12.18 5.938 11.93 11.905 1.297-1.694 1.855-6.299-1.965-8.668-3.404-2.113-7.839-.957-9.964-3.237zm7.58-2.831c-.086-.08-.174-.158-.26-.236.087.08.174.163.26.236zm3.058 5.468l-.008-.012a4.992 4.992 0 00-.405-.635 3.263 3.263 0 00-1.803-1.225 7.676 7.676 0 00-1.468-.232c-.503-.036-1.015-.057-1.533-.085-1.038-.057-2.1-.164-3.139-.461a8.726 8.726 0 01-1.537-.59 6.57 6.57 0 01-1.346-.98c-.8-.748-1.427-1.595-2.057-2.416a28.52 28.52 0 00-1.907-2.373 8.7 8.7 0 00-2.336-1.832 8.045 8.045 0 00-2.908-.835 6.848 6.848 0 013.107.381 8.213 8.213 0 012.695 1.72c.508.478.984.989 1.427 1.528 3.296-.651 5.97-.073 8.023 1.051l.047.023a10.118 10.118 0 012.087 1.511c.437.404.844.84 1.218 1.304l.029.037c1.213 1.544 1.812 3.149 1.813 4.121zm-.002 0l-.007-.016.007.016zM14.368 8.192c.84.123 1.698.46 2.251 1.1.553.642.757 1.476.916 2.27.13.615.233 1.242.474 1.825.117.284.288.533.43.802.119.223.334.423.417.662a.213.213 0 01-.024.21c-.294.327-1.085-.036-1.384-.182a4.503 4.503 0 01-1.36-1.042c-1.198-1.336-1.817-3.26-1.78-5.01.009-.212.028-.424.06-.635z' />
        <path d='M28.43 23.262c-1.816 5.093 6.424 8.51 3.337 13.687 3.167-1.314 4.671-5.283 3.357-8.432-1.15-2.765-4.55-3.773-6.693-5.255zM17.533 29.92a7.176 7.176 0 011.61-.919 9.364 9.364 0 011.8-.521c1.22-.233 2.428-.29 3.443-.701a4.41 4.41 0 001.361-.848c.386-.36.681-.806.862-1.303.185-.524.26-1.081.22-1.636a6.017 6.017 0 00-.398-1.738 3.99 3.99 0 011.016 3.618 3.773 3.773 0 01-.99 1.792 4.592 4.592 0 01-1.708 1.069 7.168 7.168 0 01-1.896.39c-.622.053-1.225.067-1.816.103a11.66 11.66 0 00-3.504.694zm11.623 8.954c-.183.146-.366.3-.567.436a4.842 4.842 0 01-.635.355 3.288 3.288 0 01-1.471.335c-1.38-.026-2.357-1.059-2.928-2.225-.389-.795-.657-1.654-1.12-2.412-.66-1.083-1.79-1.955-3.114-1.794-.54.068-1.045.312-1.345.783-.79 1.229.344 2.95 1.788 2.707.123-.019.243-.052.358-.099.115-.049.222-.114.318-.194a1.45 1.45 0 00.44-.639 1.5 1.5 0 00.06-.812 1.116 1.116 0 00-.464-.695c.278.13.494.364.604.652.113.296.143.618.084.93a1.85 1.85 0 01-.413.878c-.113.129-.244.24-.389.332a2.269 2.269 0 01-1.473.323 2.694 2.694 0 01-1.31-.57c-.447-.355-.779-.819-1.182-1.218a5.617 5.617 0 00-1.612-1.182 5.985 5.985 0 00-1.297-.404 8.488 8.488 0 00-.68-.11c-.103-.01-.612-.123-.683-.057a14.232 14.232 0 012.284-1.72c.838-.5 1.739-.888 2.678-1.152a7.61 7.61 0 012.996-.23 5.818 5.818 0 011.505.39c.506.203.972.493 1.378.856a4.3 4.3 0 01.958 1.341c.208.473.363.967.462 1.474.296 1.516.187 3.867 2.163 4.213.103.02.207.035.312.045l.323.008c.222-.016.442-.048.66-.096a7.01 7.01 0 001.312-.45zm-11.485-1.656l-.052-.04.052.04zm-1.772-21.392a2.194 2.194 0 01-.37.768 3 3 0 01-1.23.945 4.744 4.744 0 01-1.371.362c-.103.013-.21.02-.312.029a1.398 1.398 0 00-1.301 1.043 3.557 3.557 0 00-.08.439c-.046.383-.054.782-.096 1.264a7.512 7.512 0 01-.7 2.362c-.469.993-.996 1.794-.874 2.938.08.743.46 1.241.963 1.755.909.933 2.942 1.35 2.488 3.65-.274 1.372-2.54 2.813-5.724 3.316.317-.049-.406-1.273-.452-1.35-.34-.538-.715-1.044-.986-1.626-.532-1.13-.778-2.438-.56-3.676.23-1.304 1.19-2.302 1.988-3.298.95-1.185 1.946-2.737 2.167-4.276.051-.372.088-.839.17-1.303.08-.514.24-1.012.476-1.476a3 3 0 01.625-.809.81.81 0 00.156-.985L5.8 6.726l7.29 9.038a.91.91 0 001.08.266.908.908 0 00.317-.236.62.62 0 00.02-.782c-.477-.61-.98-1.234-1.468-1.847l-1.835-2.28L7.522 6.33 2.5 0l5.494 5.922 3.92 4.353 1.956 2.182c.648.734 1.297 1.445 1.946 2.216l.106.13.024.203a2.4 2.4 0 01-.047.82z' />
        <path d='M17.578 37.157a4.89 4.89 0 01-.931-.953c.285.342.596.66.931.953z' />
      </g>
      <defs>
        <clipPath id='prefix__prefix__prefix__clip0'>
          <path fill='#fff' d='M0 0h40v40H0z' />
        </clipPath>
      </defs>
    </svg>
  )
})

export const Unstoppabledomains = React.forwardRef(function Unstoppabledomains(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={48}
      height={48}
      viewBox='0 0 48 48'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <path
        d='M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24z'
        fill='#4C47F7'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M38.897 10.964v10.242L9.104 33.309l29.793-22.344z'
        fill='#2FE9FF'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M33.31 10.499v17.69a9.31 9.31 0 01-18.62 0V20.74l5.586-3.072v10.52a3.259 3.259 0 006.517 0V14.084L33.31 10.5z'
        fill='#fff'
      />
    </svg>
  )
})

export const Validators = React.forwardRef(function Validators(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M21 18h-6.18A3 3 0 0013 16.18V13h7a1 1 0 100-2h-1V5a3 3 0 00-3-3H8a3 3 0 00-3 3v6H4a1 1 0 100 2h7v3.18A3 3 0 009.18 18H3a1 1 0 100 2h6.18a3 3 0 005.64 0H21a1 1 0 100-2zM7 11V5a1 1 0 011-1h8a1 1 0 011 1v6H7zm4 8a1 1 0 102 0 1 1 0 00-2 0z'
      />
    </svg>
  )
})

export const WalletConnectCircle = React.forwardRef(
  function WalletConnectCircle(
    props: React.SVGProps<SVGSVGElement>,
    svgRef?: React.Ref<SVGSVGElement>,
  ) {
    return (
      <svg
        width={48}
        height={48}
        viewBox='0 0 48 48'
        fill='currentColor'
        ref={svgRef}
        {...props}
      >
        <rect width={48} height={48} rx={24} fill='#3B99FC' />
        <path
          d='M16.323 19.113c4.24-4.15 11.114-4.15 15.355 0l.51.5a.523.523 0 010 .752l-1.746 1.71a.276.276 0 01-.384 0l-.702-.688c-2.958-2.896-7.754-2.896-10.712 0l-.752.736a.276.276 0 01-.383 0l-1.747-1.71a.523.523 0 010-.75l.56-.55zm18.965 3.535l1.553 1.522a.524.524 0 010 .75l-7.005 6.86a.551.551 0 01-.767 0l-4.973-4.868a.138.138 0 00-.192 0l-4.971 4.868a.551.551 0 01-.768 0l-7.006-6.86a.523.523 0 010-.75l1.554-1.522a.551.551 0 01.767 0l4.973 4.868a.137.137 0 00.191 0l4.972-4.868a.552.552 0 01.767 0l4.973 4.868a.138.138 0 00.192 0l4.972-4.868a.551.551 0 01.767 0h.001z'
          fill='#fff'
        />
      </svg>
    )
  },
)

export const WalletConnect = React.forwardRef(function WalletConnect(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={40}
      height={40}
      viewBox='0 0 40 40'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <path
        d='M8.192 12.789c6.522-6.385 17.095-6.385 23.617 0l.784.769a.804.804 0 010 1.156l-2.685 2.629a.424.424 0 01-.59 0l-1.08-1.058c-4.55-4.454-11.926-4.454-16.475 0l-1.157 1.133a.424.424 0 01-.59 0l-2.686-2.63a.807.807 0 010-1.155l.861-.844h.001zm29.17 5.437l2.389 2.34a.804.804 0 010 1.155L28.976 32.27a.848.848 0 01-1.18 0l-7.648-7.487a.211.211 0 00-.295 0l-7.647 7.487a.848.848 0 01-1.181 0L.25 21.72a.804.804 0 010-1.156l2.39-2.34a.848.848 0 011.18 0l7.648 7.488c.081.08.213.08.295 0l7.647-7.487a.848.848 0 011.18 0l7.648 7.487c.082.08.214.08.295 0l7.647-7.487a.848.848 0 011.181 0h.001z'
        fill='#3B99FC'
      />
    </svg>
  )
})

export const Wallet = React.forwardRef(function Wallet(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M17.4 7.6h.9a2.7 2.7 0 012.7 2.7v7.2a2.7 2.7 0 01-2.7 2.7H5.7A2.7 2.7 0 013 17.5V6.7A2.7 2.7 0 015.7 4h9a2.7 2.7 0 012.7 2.7v.9zm-2.7-1.8h-9a.9.9 0 100 1.8h9.9v-.9a.9.9 0 00-.9-.9zm4.5 9h-.9a.9.9 0 110-1.8h.9v1.8zm-.9-3.6h.9v-.9a.9.9 0 00-.9-.9H5.7a2.7 2.7 0 01-.9-.153V17.5a.9.9 0 00.9.9h12.6a.9.9 0 00.9-.9v-.9h-.9a2.7 2.7 0 010-5.4z'
      />
    </svg>
  )
})

export const Warning = React.forwardRef(function Warning(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={64}
      height={64}
      viewBox='0 0 64 64'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M32 61.867c16.495 0 29.867-13.372 29.867-29.867S48.495 2.133 32 2.133 2.133 15.505 2.133 32 15.505 61.867 32 61.867zM32 64c17.673 0 32-14.327 32-32C64 14.327 49.673 0 32 0 14.327 0 0 14.327 0 32c0 17.673 14.327 32 32 32z'
        fill='#EC8600'
      />
      <circle cx={32} cy={43} r={1} fill='#EC8600' />
      <path
        d='M32 20v15'
        stroke='#EC8600'
        strokeWidth={2}
        strokeLinecap='round'
      />
    </svg>
  )
})

export const Weth = React.forwardRef(function Weth(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <path opacity={0.6} d='M11.999 3.75v6.098l5.248 2.303-5.248-8.401z' />
      <path d='M11.999 3.75L6.75 12.151l5.249-2.303V3.75z' />
      <path opacity={0.6} d='M11.999 16.103v4.143l5.251-7.135L12 16.103z' />
      <path d='M11.999 20.246v-4.144L6.75 13.111l5.249 7.135z' />
      <path opacity={0.2} d='M11.999 15.144l5.248-2.993-5.248-2.301v5.294z' />
      <path opacity={0.6} d='M6.75 12.151l5.249 2.993V9.85l-5.249 2.3z' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12 1.5c-.39 0-.774.021-1.152.062a.5.5 0 01-.108-.994 11.624 11.624 0 012.52 0 .5.5 0 11-.108.994A10.622 10.622 0 0012 1.5zm-3.967.225a.5.5 0 01-.256.659c-.708.311-1.376.699-1.992 1.152a.5.5 0 11-.592-.806c.674-.496 1.405-.92 2.181-1.262a.5.5 0 01.66.257zm7.934 0a.5.5 0 01.659-.257c.776.342 1.507.766 2.181 1.262a.5.5 0 11-.592.806 10.486 10.486 0 00-1.992-1.152.5.5 0 01-.256-.66zM3.429 5.086a.5.5 0 01.107.7c-.453.615-.84 1.283-1.152 1.991a.5.5 0 01-.916-.403c.342-.776.766-1.507 1.262-2.181a.5.5 0 01.7-.107zm17.142 0a.5.5 0 01.699.107c.496.674.92 1.405 1.262 2.181a.5.5 0 11-.916.403 10.494 10.494 0 00-1.152-1.992.5.5 0 01.107-.699zM1.12 10.297a.5.5 0 01.442.551 10.622 10.622 0 000 2.304.5.5 0 01-.994.108 11.624 11.624 0 010-2.52.5.5 0 01.552-.443zm21.76 0a.5.5 0 01.552.443 11.606 11.606 0 010 2.52.5.5 0 11-.994-.108 10.627 10.627 0 000-2.304.5.5 0 01.443-.55zm-21.155 5.67a.5.5 0 01.659.256c.311.708.699 1.376 1.152 1.992a.5.5 0 01-.806.592 11.486 11.486 0 01-1.262-2.181.5.5 0 01.257-.66zm20.55 0a.5.5 0 01.257.659 11.488 11.488 0 01-1.262 2.181.5.5 0 11-.806-.592 10.53 10.53 0 001.152-1.992.5.5 0 01.66-.256zM5.086 20.57a.5.5 0 01.7-.107c.615.453 1.283.84 1.991 1.152a.5.5 0 11-.403.916 11.49 11.49 0 01-2.181-1.262.5.5 0 01-.107-.7zm13.828 0a.5.5 0 01-.107.699c-.674.496-1.405.92-2.181 1.262a.5.5 0 11-.403-.916 10.491 10.491 0 001.992-1.152.5.5 0 01.699.107zm-8.617 2.31a.5.5 0 01.551-.443 10.627 10.627 0 002.304 0 .5.5 0 01.108.994 11.606 11.606 0 01-2.52 0 .5.5 0 01-.443-.551z'
      />
    </svg>
  )
})

export const Whitepaper = React.forwardRef(function Whitepaper(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M20 8.94a.865.865 0 00-.25-.64l-6-6c-.176-.166-.472-.3-.7-.3H7a3 3 0 00-3 3v14a3 3 0 003 3h10a3 3 0 003-3V8.94zM10 10H9a1 1 0 010-2h1a1 1 0 110 2zm-2 3a1 1 0 011-1h6a1 1 0 110 2H9a1 1 0 01-1-1zm8.59-5L14 5.41V7a1 1 0 001 1h1.59zM18 19a1 1 0 01-1 1H7a1 1 0 01-1-1V5a1 1 0 011-1h5v3a3 3 0 003 3h3v9zM8 17a1 1 0 011-1h6a1 1 0 110 2H9a1 1 0 01-1-1z'
      />
    </svg>
  )
})

export const Withdraw = React.forwardRef(function Withdraw(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <g clipPath='url(#prefix__prefix__clip0_13227_1683)'>
        <path
          clipRule='evenodd'
          d='M13 18.584l.79-.8a1.004 1.004 0 011.42 1.42l-2.5 2.5a.999.999 0 01-.33.21 1 1 0 01-.76 0 1 1 0 01-.33-.21l-2.5-2.5a1 1 0 010-1.42 1 1 0 011.42 0l.79.8v-4.59a1 1 0 012 0v4.59zm-6.016-1.886A1.018 1.018 0 016 16.434a8.46 8.46 0 1112 0 1.018 1.018 0 11-1.44-1.44 6.45 6.45 0 10-9.12 0 1.018 1.018 0 01-.456 1.704z'
        />
      </g>
      <defs>
        <clipPath id='prefix__prefix__clip0_13227_1683'>
          <path fill='#fff' d='M0 0h24v24H0z' />
        </clipPath>
      </defs>
    </svg>
  )
})

export const Wrap = React.forwardRef(function Wrap(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M1 16.757a3.026 3.026 0 001.653 2.698l8 4a3 3 0 002.684 0l8-4A3 3 0 0023 16.77V7.23a3.026 3.026 0 00-1.665-2.686L13.337.546a3 3 0 00-2.684 0l-8 4A3.026 3.026 0 001 7.243v9.514zm20 .013a1 1 0 01-.555.895h-.002L13 21.388v-9.769l8-4v9.152zM19.77 5.998l-7.327-3.664a1 1 0 00-.896 0L9.226 3.495 17 7.382l2.77-1.384zM6.99 4.613L4.226 5.995 12 9.882 14.764 8.5 6.99 4.613zM3 7.618l8 4v9.774l-7.45-3.725h-.001a1 1 0 01-.549-.9V7.618z'
      />
    </svg>
  )
})

export const Wsteth = React.forwardRef(function Wsteth(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <path
        d='M20 2H4a2 2 0 00-2 2v16a2 2 0 002 2h16a2 2 0 002-2V4a2 2 0 00-2-2z'
        fill='#00A3FF'
      />
      <path
        d='M7.898 11.29l-.112.17a4.824 4.824 0 00.678 6.1 5.036 5.036 0 003.534 1.434l-4.1-7.705z'
        fill='#fff'
      />
      <path
        opacity={0.6}
        d='M11.997 13.63l-4.1-2.34 4.1 7.704v-5.363zm4.105-2.34l.112.17a4.823 4.823 0 01-.678 6.1 5.036 5.036 0 01-3.534 1.434l4.1-7.705z'
        fill='#fff'
      />
      <path
        opacity={0.2}
        d='M12.002 13.63l4.1-2.34-4.1 7.704v-5.363zm.001-5.23v4.038l3.531-2.018-3.531-2.02z'
        fill='#fff'
      />
      <path
        opacity={0.6}
        d='M12.003 8.4l-3.534 2.02 3.534 2.018V8.4z'
        fill='#fff'
      />
      <path d='M12.003 5.002L8.469 10.42l3.534-2.027V5.002z' fill='#fff' />
      <path
        opacity={0.6}
        d='M12.003 8.394l3.534 2.027-3.534-5.422v3.395z'
        fill='#fff'
      />
    </svg>
  )
})

export const XdefiWallet = React.forwardRef(function XdefiWallet(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={48}
      height={48}
      viewBox='0 0 48 48'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <circle cx={24} cy={24} r={24} fill='#2043D0' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M19.022 27.432a13.605 13.605 0 007.644-1.784l1.404.835a14.963 14.963 0 01-9.134 2.42 8.841 8.841 0 01-6.52-2.858 7.307 7.307 0 01-1.477-5.871 7.509 7.509 0 01.687-2.222l.052-.105a13.508 13.508 0 014.685-5.103 13.746 13.746 0 0113.462-.76 13.562 13.562 0 015.24 4.549 13.315 13.315 0 01.982 13.286 13.494 13.494 0 01-4.518 5.252 13.711 13.711 0 01-6.557 2.35l-.128-1.457a12.22 12.22 0 005.84-2.092 12.025 12.025 0 004.023-4.679 11.866 11.866 0 00-.87-11.838 12.086 12.086 0 00-4.667-4.054 12.254 12.254 0 00-11.992.661 12.039 12.039 0 00-4.18 4.544l-.038.077a6.083 6.083 0 00-.556 1.79 5.842 5.842 0 001.156 4.729 7.483 7.483 0 005.462 2.33zm.806 3.411a16.008 16.008 0 009.668-3.537l1.34.797c-1.2 1.155-4.649 3.86-10.923 4.207-.489.038-.958.038-1.405.038-5.456 0-7.778-1.856-7.881-1.94l.534-.633.41-.5c.022.019 2.445 1.885 8.257 1.568zm12.187-2.027a10.785 10.785 0 01-2.892 2.604c-3.933 2.508-8.935 2.832-12.437 2.657l-.071 1.465c.59.029 1.154.042 1.703.042 9.876 0 13.867-4.446 14.982-6.033l-1.286-.746.001.011zm.271-5.743c-.19.13-.416.201-.647.204a1.18 1.18 0 01-1.186-1.172 1.172 1.172 0 111.833.968z'
        fill='#fff'
      />
    </svg>
  )
})

export const Zengo = React.forwardRef(function Zengo(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={48}
      height={48}
      viewBox='0 0 48 48'
      fill='currentColor'
      ref={svgRef}
      {...props}
    >
      <path
        d='M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24z'
        fill='url(#prefix__prefix__paint0_linear_11640_1714)'
      />
      <g filter='url(#prefix__prefix__filter0_i_11640_1714)'>
        <path
          d='M20.95 22.472c.901-.369 1.277.24.72.954-1.428 1.834-3.639 5.708-.85 7.436 1.248.772 3.112.206 4.678-.315l.25-.084c.414-.138.803-.267 1.147-.36 2.214-.598 4.55-1.168 6.841-.683 2.633.556 4.418 3.196 4.07 5.88-.345 2.661-2.72 4.58-5.371 4.58H16.256c-3.14.062-5.32-2.218-5.55-4.916-.04-.465-.027-.94.045-1.416.47-3.093 2.226-5.607 4.39-7.725 1.397-1.366 3.914-2.772 5.772-3.34l.038-.01zM31.745 8.028c3.14-.062 5.32 2.217 5.55 4.916.04.464.027.94-.045 1.415-.47 3.094-2.226 5.607-4.39 7.725-1.398 1.367-3.914 2.773-5.772 3.34-.012.003-.025.006-.038.011-.9.37-1.276-.24-.72-.953 1.428-1.835 3.64-5.709.85-7.436-1.652-1.023-4.385.302-6.074.759-2.214.598-4.55 1.167-6.841.683-2.633-.557-4.418-3.196-4.07-5.88.345-2.662 2.72-4.58 5.371-4.58h16.179z'
          fill='url(#prefix__prefix__paint1_linear_11640_1714)'
        />
      </g>
      <defs>
        <linearGradient
          id='prefix__prefix__paint0_linear_11640_1714'
          x1={24}
          y1={0}
          x2={24}
          y2={47.054}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#fff' />
          <stop offset={0.999} stopColor='#E6F7F7' />
        </linearGradient>
        <linearGradient
          id='prefix__prefix__paint1_linear_11640_1714'
          x1={11.982}
          y1={9.177}
          x2={37.421}
          y2={39.223}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#4FF4BA' />
          <stop offset={1} stopColor='#43CFC7' stopOpacity={0.677} />
        </linearGradient>
        <filter
          id='prefix__prefix__filter0_i_11640_1714'
          x={10.15}
          y={8.027}
          width={27.699}
          height={32.854}
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity={0} result='BackgroundImageFix' />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='BackgroundImageFix'
            result='shape'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feComposite in2='hardAlpha' operator='arithmetic' k2={-1} k3={1} />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.262745 0 0 0 0 0.811765 0 0 0 0 0.780392 0 0 0 0.677133 0'
          />
          <feBlend
            mode='normal'
            in2='shape'
            result='effect1_innerShadow_11640_1714'
          />
        </filter>
      </defs>
    </svg>
  )
})
